import React, { useState, useEffect, useRef } from 'react'
import { Row, Col, Container, Form, Button, Modal, Badge, InputGroup, Table } from 'react-bootstrap'
import Card from '../../../components/Card'
import { useNavigate } from 'react-router-dom'
import { apiHandler } from '../../../api/apihandler';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {
    TEACHERS_ASSIGN_GAMES_NAME_API, TEACHERS_GET_ASSIGNED_GAMES_API, TEACHERS_LUNCH_PLAN_WAIVER_API,
    TEACHERS_MEDICATION_API, TEACHERS_NON_MEDICATION_API, TEACHERS_PEANUT_POLICY_API, TEACHERS_ROOMS_API,
    TEACHERS_ROOMS_STUDENTS_API, TEACHERS_ROOMS_STUDENTS_ATTENDANCE_API, TEACHERS_ASSIGN_GAME_API,
    TEACHERS_OBSERVATION_API, TEACHERS_OBSERVATION_SAVE_API, DAILY_REPORT_STORE, DAILY_REPORT_VIEW, 
    TEACHERS_MEDICATION_LOG_STORE_API, TEACHERS_MEDICATION_LOG_API, TEACHERS_NON_MEDICATION_LOG_STORE_API, 
    TEACHERS_NON_MEDICATION_LOG_API, TEACHERS_ALLERGY_VIEW_API, PROFILE_DETAILS, CHILD_REGISTRATION_VIEW,
    ACCIDENT_REPORTS_LIST, ACCIDENT_REPORT_STORE, ACCIDENT_REPORT_DELETE, ACCIDENT_REPORT_SIGNATURE, ACCIDENT_REPORT_SUBMIT,
    ILLNESS_REPORTS_LIST, ILLNESS_REPORT_STORE, ILLNESS_REPORT_DELETE, ILLNESS_REPORT_SIGNATURE, ILLNESS_REPORT_SUBMIT
} from "../../../api/constants";
import Moment from 'moment';
import loader from '../../../assets/images/page-img/page-load-loader.gif'
import NoDataFound from '../../../components/noDataFound';
import Swal from 'sweetalert2'
import { useSelector, useDispatch } from 'react-redux';
import SignatureCanvas from 'react-signature-canvas';
import { handleImageUpload } from '../../../api/uploads';
import RegistrationDetailModal from '../../../components/registrationPacket/RegistrationDetailModal';
import DOMPurify from 'isomorphic-dompurify';

const AttendancePage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    let profileData = useSelector((state) => state.setting.setting.user_data);
    profileData = profileData ? JSON.parse(profileData) : null;
    const [students, setStudents] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [showBulkModal, setShowBulkModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [refreshing, setRefreshing] = useState(false);
    const [rooms, setRooms] = useState([]);
    const [selectedRoom, setSelectedRoom] = useState(null);
    const [scheduleInfo, setScheduleInfo] = useState(null);
    const [hasSchedule, setHasSchedule] = useState(false);
    const [totalStudents, setTotalStudents] = useState(0);
    const [canTakeAttendance, setCanTakeAttendance] = useState(true);
    const [showEmergencyModal, setShowEmergencyModal] = useState(false);
    const [selectedEmergencyContacts, setSelectedEmergencyContacts] = useState([]);
    const [showObservationModal, setShowObservationModal] = useState(false);
    const [selectedStudent, setSelectedStudent] = useState(null);
    const [observationNotes, setObservationNotes] = useState('');
    const [observationText, setObservationText] = useState('');
    const [showExitTimeModal, setShowExitTimeModal] = useState(false);
    const [exitTime, setExitTime] = useState('');
    const [showDailyReportModal, setShowDailyReportModal] = useState(false);
    const [dailyReportData, setDailyReportData] = useState(null);
    const [showMedicationModal, setShowMedicationModal] = useState(false);
    const [medicationData, setMedicationData] = useState(null);
    const [showNonMedicationModal, setShowNonMedicationModal] = useState(false);
    const [nonMedicationData, setNonMedicationData] = useState(null);
    const [showMedicationLogFormModal, setShowMedicationLogFormModal] = useState(false);
    const [showMedicationLogViewModal, setShowMedicationLogViewModal] = useState(false);
    const [selectedMedicationLog, setSelectedMedicationLog] = useState(null);
    const [showPeanutPolicyModal, setShowPeanutPolicyModal] = useState(false);
    const [peanutPolicyData, setPeanutPolicyData] = useState(null);
    const [showLunchPlanModal, setShowLunchPlanModal] = useState(false);
    const [lunchPlanData, setLunchPlanData] = useState(null);
    const [showGameModal, setShowGameModal] = useState(false);
    const [gameData, setGameData] = useState(null);
    const [gameNames, setGameNames] = useState([]);
    const [selectedGame, setSelectedGame] = useState('');
    const [showObservationViewModal, setShowObservationViewModal] = useState(false);
    const [observationData, setObservationData] = useState(null);
    const [showDailyReportFormModal, setShowDailyReportFormModal] = useState(false);
    const [isEditingDailyReport, setIsEditingDailyReport] = useState(false);
    const [currentDailyReportData, setCurrentDailyReportData] = useState(null);
    const [showAllergyModal, setShowAllergyModal] = useState(false);
    const [allergyData, setAllergyData] = useState(null);
    const [showMeditationModal, setShowMeditationModal] = useState(false);
    const [meditationData, setMeditationData] = useState(null);
    const [parentInfoData, setParentInfoData] = useState(null);
    const [showRegistrationModal, setShowRegistrationModal] = useState(false);
    const [registrationData, setRegistrationData] = useState(null);
    const [registrationLoading, setRegistrationLoading] = useState(false);

    // Medication Log Management States
    const [showMedicationLogForm, setShowMedicationLogForm] = useState(false);
    const [isEditingMedicationLog, setIsEditingMedicationLog] = useState(false);
    const [medicationLogData, setMedicationLogData] = useState({
        medication_date: '',
        medication: '',
        is_dosage_given: 1,
        time_given: '',
        staff_signiture: '',
        comments: ''
    });
    const [medicationLogs, setMedicationLogs] = useState([]);
    const [showLogViewModal, setShowLogViewModal] = useState(false);
    const [selectedLog, setSelectedLog] = useState(null);
    const [isLoadingLogs, setIsLoadingLogs] = useState(false);
    
    // Non-Medication Log Management States
    const [showNonMedicationLogFormModal, setShowNonMedicationLogFormModal] = useState(false);
    const [isEditingNonMedicationLog, setIsEditingNonMedicationLog] = useState(false);
    const [nonMedicationLogData, setNonMedicationLogData] = useState({
        medication_date: '',
        medication: '',
        is_dosage_given: 1,
        time_given: '',
        staff_signiture: '',
        comments: ''
    });

    // Signature pad refs
    const medicationSignaturePadRef = useRef(null);
    const nonMedicationSignaturePadRef = useRef(null);

    const [dailyReportFormData, setDailyReportFormData] = useState({
        feeling_id: 1,
        learned: '',
        comments: '',
        diapers: [],
        meals: [],
        sleeps: [],
        bring_diapers: false,
        bring_wipes: false,
        bring_ointment: false,
        bring_clothes: false,
        bring_blanket: false,
        other_item: ''
    });
    const [hasDraft, setHasDraft] = useState(false);
    const [isDraftMode, setIsDraftMode] = useState(false);

    // Draft management functions
    const getDraftKey = (studentId, date) => {
        return `dailyReport_draft_${studentId}_${date}`;
    };

    const saveDraftToLocalStorage = (studentId, date, formData) => {
        const draftKey = getDraftKey(studentId, date);
        const draftData = {
            ...formData,
            savedAt: new Date().toISOString()
        };
        localStorage.setItem(draftKey, JSON.stringify(draftData));
        setHasDraft(true);
        console.log('Draft saved to localStorage:', draftKey, draftData);
    };

    const loadDraftFromLocalStorage = (studentId, date) => {
        const draftKey = getDraftKey(studentId, date);
        const draftData = localStorage.getItem(draftKey);
        console.log('Attempting to load draft from localStorage:', draftKey);
        if (draftData) {
            try {
                const parsed = JSON.parse(draftData);
                delete parsed.savedAt; // Remove metadata
                setHasDraft(true);
                console.log('Draft loaded successfully:', parsed);
                return parsed;
            } catch (error) {
                console.error('Error parsing draft:', error);
                return null;
            }
        }
        console.log('No draft found in localStorage for key:', draftKey);
        setHasDraft(false);
        return null;
    };

    const clearDraftFromLocalStorage = (studentId, date) => {
        const draftKey = getDraftKey(studentId, date);
        localStorage.removeItem(draftKey);
        setHasDraft(false);
    };

    const checkDraftExists = (studentId, date) => {
        const draftKey = getDraftKey(studentId, date);
        return localStorage.getItem(draftKey) !== null;
    };

    // Accident and Illness Report States
    const [showAccidentReportsModal, setShowAccidentReportsModal] = useState(false);
    const [showIllnessReportsModal, setShowIllnessReportsModal] = useState(false);
    const [accidentReports, setAccidentReports] = useState([]);
    const [illnessReports, setIllnessReports] = useState([]);
    const [loadingAccidentReports, setLoadingAccidentReports] = useState(false);
    const [loadingIllnessReports, setLoadingIllnessReports] = useState(false);
    const [showAccidentSignatureModal, setShowAccidentSignatureModal] = useState(false);
    const [showIllnessSignatureModal, setShowIllnessSignatureModal] = useState(false);
    const [selectedAccidentReport, setSelectedAccidentReport] = useState(null);
    const [selectedIllnessReport, setSelectedIllnessReport] = useState(null);
    const [accidentSignatureDate, setAccidentSignatureDate] = useState('');
    const [illnessSignatureDate, setIllnessSignatureDate] = useState('');
    const accidentSignaturePadRef = useRef(null);
    const illnessSignaturePadRef = useRef(null);

    // Create/Edit Accident Report States
    const [showCreateAccidentModal, setShowCreateAccidentModal] = useState(false);
    const [isEditingAccidentReport, setIsEditingAccidentReport] = useState(false);
    const [editingAccidentReportId, setEditingAccidentReportId] = useState(null);
    const [accidentFormData, setAccidentFormData] = useState({
        classroom: '',
        child_name: '',
        incident_date: '',
        incident_time: '',
        location: '',
        incident_description: '',
        first_aid: '',
        parent_contacted: false,
        parent_contacted_time: '',
        follow_up_information: '',
        staff_name: '',
        staff_position: '',
        existing_staff_signature: '',
        existing_supervisor_signature: ''
    });
    const accidentStaffSignaturePadRef = useRef(null);
    const accidentSupervisorSignaturePadRef = useRef(null);

    // Create/Edit Illness Report States
    const [showCreateIllnessModal, setShowCreateIllnessModal] = useState(false);
    const [isEditingIllnessReport, setIsEditingIllnessReport] = useState(false);
    const [editingIllnessReportId, setEditingIllnessReportId] = useState(null);
    const [illnessFormData, setIllnessFormData] = useState({
        classroom: '',
        student_name: '',
        symptoms: '',
        requested_action_parent: '',
        return_date: '',
        teacher_signature_date: '',
        existing_teacher_signature: ''
    });
    const illnessTeacherSignaturePadRef = useRef(null);

    // Check if attendance can be edited (based on API response)
    const canEditAttendance = () => {
        return canTakeAttendance;
    };

    // Format time to 12-hour format with AM/PM
    const formatTime = (time) => {
        if (!time) return '';
        return Moment(time, 'HH:mm:ss').format('hh:mm A');
    };

    // Helper function to render modal field values
    const renderFieldValue = (key, value) => {
        if (value === null || value === undefined || value === '') {
            return 'N/A';
        }

        // Check if it's an image URL
        const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg'];
        const isImage = typeof value === 'string' && imageExtensions.some(ext => value.toLowerCase().includes(ext));

        if (isImage || (typeof value === 'string' && (value.includes('http') && (key.toLowerCase().includes('image') || key.toLowerCase().includes('photo') || key.toLowerCase().includes('picture') || key.toLowerCase().includes('signature'))))) {
            return (
                <img
                    src={value}
                    alt={key}
                    style={{
                        maxWidth: '100%',
                        maxHeight: '300px',
                        borderRadius: '8px',
                        objectFit: 'contain',
                        border: '1px solid #dee2e6'
                    }}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.style.display = 'none';
                        e.target.parentElement.innerHTML = value;
                    }}
                />
            );
        }

        // Check if it's an array
        if (Array.isArray(value)) {
            return (
                <div>
                    {value.map((item, index) => (
                        <div key={index} style={{ marginBottom: '8px', padding: '8px', background: '#ffffff', borderRadius: '6px', border: '1px solid #dee2e6' }}>
                            {typeof item === 'object' ? (
                                Object.entries(item).map(([k, v]) => (
                                    <div key={k} style={{ marginBottom: '4px' }}>
                                        <strong style={{ fontSize: '12px', color: '#6c757d', textTransform: 'capitalize' }}>
                                            {k.replace(/_/g, ' ')}:
                                        </strong>{' '}
                                        <span style={{ fontSize: '13px' }}>{renderFieldValue(k, v)}</span>
                                    </div>
                                ))
                            ) : (
                                <span>{item}</span>
                            )}
                        </div>
                    ))}
                </div>
            );
        }

        // Check if it's an object
        if (typeof value === 'object') {
            return (
                <div style={{ padding: '8px', background: '#ffffff', borderRadius: '6px', border: '1px solid #dee2e6' }}>
                    {Object.entries(value).map(([k, v]) => (
                        <div key={k} style={{ marginBottom: '4px' }}>
                            <strong style={{ fontSize: '12px', color: '#6c757d', textTransform: 'capitalize' }}>
                                {k.replace(/_/g, ' ')}:
                            </strong>{' '}
                            <span style={{ fontSize: '13px' }}>{renderFieldValue(k, v)}</span>
                        </div>
                    ))}
                </div>
            );
        }

        // For regular text values
        return String(value);
    };

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        const initializePage = async () => {
            setLoading(true);
            await loadRooms();
            setLoading(false);
        };
        initializePage();
    }, []);

    useEffect(() => {
        if (selectedRoom && selectedDate) {
            loadAttendanceData();
        }
    }, [selectedDate, selectedRoom]);

    const loadRooms = async () => {
        try {
            const response = await apiHandler(TEACHERS_ROOMS_API, 'POST', {});
            console.log('=== ROOMS API RESPONSE ===');
            console.log('Full Response:', response);
            console.log('Status:', response.data?.response?.status);
            console.log('Rooms Data:', response.data?.data);
            
            if (response.data?.response?.status === 200) {
                const roomsData = response.data?.data?.rooms || [];
                console.log('✓ Rooms extracted:', roomsData);
                console.log('✓ Number of rooms:', roomsData.length);
                
                setRooms(roomsData);
                
                // Auto-select first room if available
                if (roomsData.length > 0 && !selectedRoom) {
                    console.log('✓ Auto-selecting first room:', roomsData[0].id, roomsData[0].room_name);
                    setSelectedRoom(roomsData[0].id);
                } else if (roomsData.length === 0) {
                    console.warn('⚠ No rooms found in response');
                }
            } else {
                console.error('✗ Room API returned non-200 status:', response.data);
            }
        } catch (error) {
            console.error('✗ ERROR loading rooms:', error);
            console.error('Error stack:', error.stack);
            Swal.fire({
                title: 'Error',
                text: 'Failed to load rooms. Please refresh the page.',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    };

    const loadAttendanceData = async () => {
        if (!selectedRoom) return;

        setLoading(true);
        try {
            const requestPayload = {
                room_id: selectedRoom,
                attendance_date: selectedDate.toISOString().split('T')[0]
            };
            // Add optional parameters if available
            if (profileData?.id || profileData?.user_id) {
                requestPayload.teacher_id = profileData?.id || profileData?.user_id;
            }
            if (profileData?.class_id || profileData?.class?.id) {
                requestPayload.class_id = profileData?.class_id || profileData?.class?.id;
            }
            console.log('Loading attendance with payload:', requestPayload);
            
            const response = await apiHandler(TEACHERS_ROOMS_STUDENTS_API, 'POST', requestPayload);

            if (response.data?.response?.status === 200) {
                const studentsData = response.data?.data?.students || [];
                console.log('Raw students data from API:', studentsData);
                
                // Check if we have cached attendance data
                const cacheKey = `attendance_${selectedRoom}_${selectedDate.toISOString().split('T')[0]}`;
                const cachedAttendance = localStorage.getItem(cacheKey);
                const attendanceCache = cachedAttendance ? JSON.parse(cachedAttendance) : {};
                console.log('Loaded attendance from localStorage:', cacheKey, attendanceCache);
                
                const mappedStudents = studentsData.map(student => {
                    console.log('Processing student:', student.name, 'Raw attendance_status:', student.attendance_status);
                    
                    // Check if student is on leave: attendance_status = 2 or is_on_leave = true
                    const isOnLeave = student.attendance_status === 2 || student.attendance_status === '2' || student.is_on_leave === true;
                    
                    // Check multiple possible field names for attendance status
                    let attendanceStatus = student.attendance_status || student.attendance || student.status;
                    let attendanceTime = student.attendance_time;
                    let exitTime = student.exit_time;
                    
                    // If API returns null but we have cached data, use it
                    if (attendanceCache[student.id] && !attendanceStatus && !student.attendance_time) {
                        console.log('Using cached attendance for', student.name, attendanceCache[student.id]);
                        attendanceStatus = attendanceCache[student.id].attendance === 'present' || attendanceCache[student.id].attendance === 'late' ? 1 : 0;
                        attendanceTime = attendanceCache[student.id].attendance_time;
                        exitTime = attendanceCache[student.id].exit_time;
                    }

                    // If status is numeric (0 or 1), convert to text
                    if (attendanceStatus === 1 || attendanceStatus === '1') {
                        attendanceStatus = 'present';
                    } else if (attendanceStatus === 0 || attendanceStatus === '0') {
                        attendanceStatus = 'absent';
                    } else if (attendanceStatus === 2 || attendanceStatus === '2') {
                        attendanceStatus = 'on_leave';
                    }

                    // If no status but has attendance_time, it means attendance was marked as present
                    if (!attendanceStatus && student.attendance_time) {
                        attendanceStatus = 'present';
                    }

                    // Default to absent only if no status is provided and not on leave
                    if (!attendanceStatus && !isOnLeave) {
                        attendanceStatus = 'absent';
                    } else if (isOnLeave && !attendanceStatus) {
                        attendanceStatus = 'on_leave';
                    }

                    // Ensure valid status
                    if (!['present', 'late', 'absent', 'on_leave'].includes(attendanceStatus)) {
                        console.log('Invalid attendance status for student:', student.name, 'Status:', attendanceStatus);
                        attendanceStatus = 'absent';
                    }

                    console.log('Final mapped status for', student.name, ':', attendanceStatus);

                    return {
                        id: student.id,
                        name: student.name,
                        rollNumber: `ST${String(student.id).padStart(3, '0')}`,
                        avatar: student.photo || "https://uzone360live.s3.amazonaws.com/noimage.png",
                        attendance: attendanceStatus,
                        attendance_time: attendanceTime,
                        exit_time: exitTime,
                        has_medication: student.has_medication,
                        has_non_medication: student.has_non_medication,
                        lunch_plan_waiver_id: student.lunch_plan_waiver_id,
                        peanut_policy_id: student.peanut_policy_id,
                        allergy_report_id: student.allergy_report_id,
                        emergency_contacts: student.emergency_contacts || [],
                        swap_room: student.swap_room,
                        is_on_leave: isOnLeave
                    };
                });

                setStudents(mappedStudents);
                setTotalStudents(response.data?.data?.total || 0);
                setHasSchedule(response.data?.data?.hasSchedule || false);
                setScheduleInfo(response.data?.data?.scheduleInfo || null);
                setCanTakeAttendance(response.data?.data?.canTakeAttendance !== undefined ? response.data?.data?.canTakeAttendance : true);
            } else {
                setStudents([]);
                setTotalStudents(0);
            }
        } catch (error) {
            console.error('Error loading attendance:', error);
            setStudents([]);
            Swal.fire({
                title: 'Error',
                text: 'Failed to load students',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (date) => {
        return date.toLocaleDateString('en-US', {
            weekday: 'short',
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    const updateAttendance = (studentId, status) => {
        console.log('updateAttendance called:', { studentId, status, canEdit: canEditAttendance() });

        setStudents(prevStudents => {
            const updated = prevStudents.map(student => {
                if (student.id === studentId) {
                    // Use the status as provided - no automatic conversion
                    const finalStatus = status;

                    const updatedStudent = {
                        ...student,
                        attendance: finalStatus,
                        attendance_time: status === 'present' || status === 'late' ? Moment().format('HH:mm:ss') : student.attendance_time
                    };

                    console.log('Updated student:', updatedStudent);
                    return updatedStudent;
                }
                return student;
            });

            console.log('All students after update:', updated);
            return updated;
        });
    };

    const bulkUpdateAttendance = (status) => {
        setStudents(prevStudents =>
            prevStudents.map(student => {
                // Skip students who are on leave
                if (student.is_on_leave) {
                    return student;
                }
                
                // Use the status as provided - no automatic conversion
                const finalStatus = status;

                return {
                    ...student,
                    attendance: finalStatus,
                    attendance_time: status === 'present' || status === 'late' ? Moment().format('HH:mm:ss') : student.attendance_time
                };
            })
        );
        setShowBulkModal(false);
    };

    const saveAttendance = async () => {
        // Validate that can take attendance
        if (!canEditAttendance()) {
            Swal.fire({
                title: 'Not Allowed',
                text: 'You cannot save attendance for this date. This is view-only mode.',
                icon: 'warning',
                confirmButtonText: 'OK',
                confirmButtonColor: '#FFA500'
            });
            return;
        }

        if (!selectedRoom) {
            Swal.fire({
                title: 'Warning',
                text: 'Please select a room first',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }

        if (students.length === 0) {
            Swal.fire({
                title: 'Warning',
                text: 'No students to save attendance for',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }

        try {
            setLoading(true);

            // Map students to attendance array with proper status values, excluding students on leave
            const attendanceArray = students
                .filter(student => !student.is_on_leave) // Exclude students on leave
                .map(student => ({
                    student_id: student.id,
                    status: (student.attendance === 'present' || student.attendance === 'late') ? 1 : 0,
                    attendance_time: student.attendance_time || Moment().format('HH:mm:ss'),
                    exit_time: student.exit_time || null
                }));

            // Validate attendance array
            if (attendanceArray.length === 0) {
                setLoading(false);
                Swal.fire({
                    title: 'Warning',
                    text: 'No active students to save attendance for',
                    icon: 'warning',
                    confirmButtonText: 'OK'
                });
                return;
            }

            // Prepare payload with fallback values - use scheduleInfo class_id if available
            const payload = {
                class_id: scheduleInfo?.class_id || profileData?.class_id || profileData?.class?.id || 1,
                room_id: selectedRoom,
                teacher_id: profileData?.id || profileData?.user_id || 1,
                attendance_date: selectedDate.toISOString().split('T')[0],
                attendance: attendanceArray
            };

            const response = await apiHandler(TEACHERS_ROOMS_STUDENTS_ATTENDANCE_API, 'POST', payload);

            if (response.data?.response?.status === 200) {
                Swal.fire({
                    title: 'Success!',
                    text: 'Attendance saved successfully!',
                    icon: 'success',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#3498DB',
                    timer: 2000
                });
                
                // Store current state before reload with metadata
                const cacheKey = `attendance_${selectedRoom}_${selectedDate.toISOString().split('T')[0]}`;
                const attendanceCache = {};
                students.filter(s => !s.is_on_leave).forEach(student => {
                    attendanceCache[student.id] = {
                        attendance: student.attendance,
                        attendance_time: student.attendance_time,
                        exit_time: student.exit_time
                    };
                });
                // Save the exact class_id and room_id used for this save
                const metaCache = {
                    class_id: payload.class_id,
                    room_id: payload.room_id,
                    teacher_id: payload.teacher_id
                };
                localStorage.setItem(cacheKey, JSON.stringify(attendanceCache));
                localStorage.setItem(`${cacheKey}_meta`, JSON.stringify(metaCache));
                console.log('Saved attendance to localStorage:', cacheKey, attendanceCache);
                console.log('Saved meta info:', metaCache);
                
                // Add delay to ensure backend has processed the save
                await new Promise(resolve => setTimeout(resolve, 1500));
                
                // Reload attendance data after save using SAME parameters as save
                setLoading(true);
                const reloadPayload = {
                    room_id: selectedRoom,
                    attendance_date: selectedDate.toISOString().split('T')[0],
                    class_id: payload.class_id,  // Use same class_id as save
                    teacher_id: payload.teacher_id  // Use same teacher_id as save
                };
                console.log('Reloading attendance with payload (should match save):', reloadPayload);
                console.log('Original save payload was:', payload);
                const reloadResponse = await apiHandler(TEACHERS_ROOMS_STUDENTS_API, 'POST', reloadPayload);
                
                if (reloadResponse.data?.response?.status === 200) {
                    const studentsData = reloadResponse.data?.data?.students || [];
                    
                    // Check if backend returned attendance data
                    const hasAttendanceData = studentsData.some(s => 
                        s.attendance_status !== null || s.attendance_time !== null
                    );
                    
                    if (hasAttendanceData) {
                        // Backend returned the data, proceed with normal load
                        await loadAttendanceData();
                    } else {
                        console.warn('Backend did not return saved attendance data, using localStorage cache');
                        // Load cached attendance from localStorage
                        const cacheKey = `attendance_${selectedRoom}_${selectedDate.toISOString().split('T')[0]}`;
                        const cachedData = localStorage.getItem(cacheKey);
                        const attendanceCacheData = cachedData ? JSON.parse(cachedData) : {};
                        console.log('Using cached attendance data:', attendanceCacheData);
                        
                        // Merge cached attendance with student data
                        const mappedStudents = studentsData.map(student => {
                            const savedData = attendanceCacheData[student.id];
                            const isOnLeave = student.attendance_status === 2 || student.attendance_status === '2' || student.is_on_leave === true;
                            
                            return {
                                id: student.id,
                                name: student.name,
                                rollNumber: `ST${String(student.id).padStart(3, '0')}`,
                                avatar: student.photo || "https://uzone360live.s3.amazonaws.com/noimage.png",
                                attendance: savedData ? savedData.attendance : (isOnLeave ? 'on_leave' : 'absent'),
                                attendance_time: savedData ? savedData.attendance_time : student.attendance_time,
                                exit_time: savedData ? savedData.exit_time : student.exit_time,
                                has_medication: student.has_medication,
                                has_non_medication: student.has_non_medication,
                                lunch_plan_waiver_id: student.lunch_plan_waiver_id,
                                peanut_policy_id: student.peanut_policy_id,
                                allergy_report_id: student.allergy_report_id,
                                emergency_contacts: student.emergency_contacts || [],
                                swap_room: student.swap_room,
                                is_on_leave: isOnLeave
                            };
                        });
                        
                        setStudents(mappedStudents);
                        setTotalStudents(reloadResponse.data?.data?.total || 0);
                        setHasSchedule(reloadResponse.data?.data?.hasSchedule || false);
                        setScheduleInfo(reloadResponse.data?.data?.scheduleInfo || null);
                        setCanTakeAttendance(reloadResponse.data?.data?.canTakeAttendance !== undefined ? reloadResponse.data?.data?.canTakeAttendance : true);
                    }
                }
                setLoading(false);
            } else {
                setLoading(false);
                const errorMessage = response.data?.response?.message || response.data?.message || 'Failed to save attendance';
                console.error('API Error Response:', response.data);
                throw new Error(errorMessage);
            }
        } catch (error) {
            setLoading(false);
            console.error('Error saving attendance:', error);
            console.error('Error details:', {
                message: error.message,
                response: error.response,
                data: error.response?.data
            });
            Swal.fire({
                title: 'Error!',
                text: error.message || error.response?.data?.message || 'Failed to save attendance. Please check the console for details.',
                icon: 'error',
                confirmButtonText: 'OK',
                confirmButtonColor: '#E74C3C'
            });
        }
    };

    const filteredStudents = students.filter(student =>
        student.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        student.rollNumber.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const getAttendanceStats = () => {
        // Exclude students on leave from attendance statistics
        const eligibleStudents = students.filter(s => !s.is_on_leave);
        const present = eligibleStudents.filter(s => s.attendance === 'present').length;
        const absent = eligibleStudents.filter(s => s.attendance === 'absent').length;
        const late = eligibleStudents.filter(s => s.attendance === 'late').length;
        const onLeave = students.filter(s => s.is_on_leave).length;
        const total = eligibleStudents.length;
        return { present, absent, late, onLeave, total };
    };

    const stats = getAttendanceStats();

    const renderDateSelector = () => (
        <Card className="mb-3 h-100">
            <Card.Header className="py-3">
                <h5 className="card-title mb-0 fw-bold">Student Attendance</h5>
            </Card.Header>
            <Card.Body className="p-3">
                {/* Room Selector */}
                <div className="mb-3">
                    <label className="form-label fw-semibold mb-1 d-flex align-items-center" style={{ fontSize: '13px' }}>
                        <i className="ri-door-line me-1 text-primary"></i>
                        Room
                    </label>
                    <select
                        value={selectedRoom || ''}
                        onChange={(e) => setSelectedRoom(Number(e.target.value))}
                        className="form-select form-select-sm"
                        style={{ fontSize: '13px' }}
                    >
                        <option value="">Choose room...</option>
                        {rooms.map(room => (
                            <option key={room.id} value={room.id}>
                                {room.room_name}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Date Selector */}
                <div className="mb-3">
                    <label className="form-label fw-semibold mb-1 d-flex align-items-center" style={{ fontSize: '13px' }}>
                        <i className="ri-calendar-line me-1 text-primary"></i>
                        Date
                    </label>
                    <div
                        className="form-control form-control-sm d-flex align-items-center justify-content-between"
                        style={{ fontSize: '13px', cursor: 'pointer' }}
                        onClick={() => document.getElementById('dateInput').showPicker()}
                    >
                        <span>{formatDate(selectedDate)}</span>
                        <i className="ri-arrow-down-s-line"></i>
                        <input
                            id="dateInput"
                            type="date"
                            value={selectedDate.toISOString().split('T')[0]}
                            onChange={(e) => setSelectedDate(new Date(e.target.value))}
                            max={new Date().toISOString().split('T')[0]}
                            style={{ position: 'absolute', opacity: 0, pointerEvents: 'none' }}
                        />
                    </div>
                </div>

                {/* Schedule Info and Read-Only Indicator - Same Line */}
                {(hasSchedule && scheduleInfo) || !canEditAttendance() ? (
                    <div className="d-flex gap-2 mb-0">
                        {hasSchedule && scheduleInfo && (
                            <div className="alert alert-success py-2 px-2 mb-0 d-flex align-items-center flex-fill" style={{ fontSize: '12px' }}>
                                <i className="ri-time-line me-2"></i>
                                <strong>{formatTime(scheduleInfo.start_time)} - {formatTime(scheduleInfo.end_time)}</strong>
                            </div>
                        )}
                        {!canEditAttendance() && (
                            <div className="alert alert-warning py-2 px-2 mb-0 d-flex align-items-center flex-fill" style={{ fontSize: '12px' }}>
                                <i className="ri-lock-line me-2"></i>
                                <div>
                                    <strong className="d-block">View Only</strong>
                                    <small>Past date</small>
                                </div>
                            </div>
                        )}
                    </div>
                ) : null}
            </Card.Body>
        </Card>
    );

    const renderStatsCards = () => (
        <Card className="mb-3 h-100">
            <Card.Header className="py-3">
                <h5 className="card-title mb-0 fw-bold">Statistics</h5>
            </Card.Header>
            <Card.Body className="p-2">
                <Row className="g-2">
                    <Col xs={6}>
                        <div className="text-center py-2 px-1 rounded bg-soft-primary">
                            <i className="ri-checkbox-circle-line text-primary" style={{ fontSize: '22px' }}></i>
                            <h5 className="mb-0 mt-1 text-primary fw-bold">{stats.present}</h5>
                            <small className="text-muted" style={{ fontSize: '11px' }}>Present</small>
                        </div>
                    </Col>
                    <Col xs={6}>
                        <div className="text-center py-2 px-1 rounded bg-soft-danger">
                            <i className="ri-close-circle-line text-danger" style={{ fontSize: '22px' }}></i>
                            <h5 className="mb-0 mt-1 text-danger fw-bold">{stats.absent}</h5>
                            <small className="text-muted" style={{ fontSize: '11px' }}>Absent</small>
                        </div>
                    </Col>
                    <Col xs={6}>
                        <div className="text-center py-2 px-1 rounded bg-soft-warning">
                            <i className="ri-time-line text-warning" style={{ fontSize: '22px' }}></i>
                            <h5 className="mb-0 mt-1 text-warning fw-bold">{stats.late}</h5>
                            <small className="text-muted" style={{ fontSize: '11px' }}>Late</small>
                        </div>
                    </Col>
                    <Col xs={6}>
                        <div className="text-center py-2 px-1 rounded bg-soft-secondary">
                            <i className="ri-plane-line text-secondary" style={{ fontSize: '22px' }}></i>
                            <h5 className="mb-0 mt-1 text-secondary fw-bold">{stats.onLeave}</h5>
                            <small className="text-muted" style={{ fontSize: '11px' }}>On Leave</small>
                        </div>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );

    const renderSearchBar = () => (
        <Card className="mb-3">
            <Card.Body>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    background: '#f8f9fa',
                    padding: '12px 16px',
                    borderRadius: '8px',
                    border: '1px solid #e9ecef'
                }}>
                    <i className="ri-search-line" style={{
                        fontSize: '20px',
                        color: '#6c757d',
                        marginRight: '12px'
                    }}></i>
                    <input
                        type="text"
                        placeholder="Search students by name or roll number..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        style={{
                            flex: 1,
                            border: 'none',
                            outline: 'none',
                            fontSize: '14px',
                            color: '#212529',
                            background: 'transparent'
                        }}
                    />
                    {searchQuery && (
                        <button
                            onClick={() => setSearchQuery('')}
                            style={{
                                background: 'transparent',
                                border: 'none',
                                cursor: 'pointer',
                                padding: '4px',
                                marginLeft: '8px'
                            }}
                        >
                            <i className="ri-close-line" style={{
                                fontSize: '20px',
                                color: '#6c757d'
                            }}></i>
                        </button>
                    )}
                </div>
            </Card.Body>
        </Card>
    );

    const renderBulkActions = () => (
        <Card>
            <Card.Header className="py-3">
                <h5 className="card-title mb-0 fw-bold">Quick Actions</h5>
            </Card.Header>
            <Card.Body className="p-2">
                <div className="d-flex gap-2 flex-wrap">
                    <Button
                        variant="success"
                        size="sm"
                        disabled={!canEditAttendance()}
                        onClick={() => {
                            if (canEditAttendance()) {
                                bulkUpdateAttendance('present');
                            }
                        }}
                        className="d-flex align-items-center justify-content-center py-2 flex-fill"
                        style={{ fontSize: '12px', fontWeight: '600', opacity: canEditAttendance() ? 1 : 0.6, minWidth: '150px' }}
                    >
                        <i className="ri-checkbox-circle-line me-1" style={{ fontSize: '16px' }}></i>
                        Mark All Present
                    </Button>
                    <Button
                        variant="warning"
                        size="sm"
                        disabled={!canEditAttendance()}
                        onClick={() => {
                            if (canEditAttendance()) {
                                bulkUpdateAttendance('late');
                            }
                        }}
                        className="d-flex align-items-center justify-content-center text-white py-2 flex-fill"
                        style={{ fontSize: '12px', fontWeight: '600', opacity: canEditAttendance() ? 1 : 0.6, minWidth: '150px' }}
                    >
                        <i className="ri-time-line me-1" style={{ fontSize: '16px' }}></i>
                        Mark All Late
                    </Button>
                    <Button
                        variant="danger"
                        size="sm"
                        disabled={!canEditAttendance()}
                        onClick={() => {
                            if (canEditAttendance()) {
                                bulkUpdateAttendance('absent');
                            }
                        }}
                        className="d-flex align-items-center justify-content-center py-2 flex-fill"
                        style={{ fontSize: '12px', fontWeight: '600', opacity: canEditAttendance() ? 1 : 0.6, minWidth: '150px' }}
                    >
                        <i className="ri-close-circle-line me-1" style={{ fontSize: '16px' }}></i>
                        Mark All Absent
                    </Button>
                </div>
            </Card.Body>
        </Card>
    );

    const handleSetExitTime = (student) => {
        // Check if editing is allowed for this date
        if (!canEditAttendance()) {
            Swal.fire({
                title: 'Not Allowed',
                text: 'Cannot set exit time for past dates. This is view-only mode.',
                icon: 'warning',
                confirmButtonText: 'OK',
                confirmButtonColor: '#FFA500'
            });
            return;
        }

        setSelectedStudent(student);
        setExitTime(student.exit_time || Moment().format('HH:mm'));
        setShowExitTimeModal(true);
    };

    const saveExitTime = () => {
        // Double-check if editing is allowed
        if (!canEditAttendance()) {
            Swal.fire({
                title: 'Not Allowed',
                text: 'Cannot set exit time for past dates. This is view-only mode.',
                icon: 'warning',
                confirmButtonText: 'OK',
                confirmButtonColor: '#FFA500'
            });
            setShowExitTimeModal(false);
            return;
        }

        if (selectedStudent && exitTime) {
            setStudents(prevStudents =>
                prevStudents.map(s =>
                    s.id === selectedStudent.id
                        ? { ...s, exit_time: exitTime + ':00' }
                        : s
                )
            );
            setShowExitTimeModal(false);
            setSelectedStudent(null);
            setExitTime('');
            Swal.fire({
                title: 'Success!',
                text: 'Exit time updated successfully!',
                icon: 'success',
                timer: 2000,
                showConfirmButton: false
            });
        }
    };

    // API Functions for viewing data
    const viewDailyReport = async (student) => {
        try {
            const response = await apiHandler(DAILY_REPORT_VIEW, 'POST', {
                student_id: student.id,
                class_id: scheduleInfo?.class_id || profileData?.class_id || profileData?.class?.id,
                report_date: selectedDate.toISOString().split('T')[0]
            });
            if (response.data?.response?.status === 200) {
                setDailyReportData(response.data?.data || {});
                setCurrentDailyReportData(response.data?.data?.daily_report || null);
                setSelectedStudent(student);
                setShowDailyReportModal(true);
            } else {
                Swal.fire({
                    title: 'Info',
                    text: response.data?.response?.message || 'No daily report found',
                    icon: 'info',
                    confirmButtonText: 'OK'
                });
            }
        } catch (error) {
            console.error('Error loading daily report:', error);
            Swal.fire({
                title: 'Error',
                text: 'Failed to load daily report',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    };

    const openDailyReportForm = async (student, isEdit = false) => {
        setSelectedStudent(student);
        setIsEditingDailyReport(isEdit);
        const reportDate = selectedDate.toISOString().split('T')[0];

        if (isEdit) {
            try {
                const response = await apiHandler(DAILY_REPORT_VIEW, 'POST', {
                    student_id: student.id,
                    class_id: scheduleInfo?.class_id || profileData?.class_id || profileData?.class?.id,
                    report_date: reportDate
                });
                if (response.data?.response?.status === 200 && response.data?.data?.daily_report) {
                    const reportData = response.data.data.daily_report;
                    const loadedData = {
                        feeling_id: reportData.daily_report_fealings?.[0]?.fealing_id || 1,
                        learned: reportData.learned ? reportData.learned.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ') : '',
                        comments: reportData.comments ? reportData.comments.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ') : '',
                        diapers: reportData.daily_report_diapers?.map(d => ({
                            diaper_time: d.diaper_time,
                            diaper_check: d.diaper_check
                        })) || [],
                        meals: reportData.daily_report_meals?.map(m => ({
                            meal_time: m.meal_time,
                            meal_type_id: m.meal_type_id,
                            meal_amount: m.meal_amount
                        })) || [],
                        sleeps: reportData.daily_report_sleeps?.map(s => ({
                            start_time: s.start_time,
                            end_time: s.end_time
                        })) || [],
                        bring_diapers: reportData.daily_report_bring_mores?.some(b => b.things === 1) || false,
                        bring_wipes: reportData.daily_report_bring_mores?.some(b => b.things === 2) || false,
                        bring_ointment: reportData.daily_report_bring_mores?.some(b => b.things === 3) || false,
                        bring_clothes: reportData.daily_report_bring_mores?.some(b => b.things === 4) || false,
                        bring_blanket: reportData.daily_report_bring_mores?.some(b => b.things === 5) || false,
                        other_item: reportData.daily_report_bring_mores?.find(b => b.things === 6)?.other || ''
                    };
                    setDailyReportFormData(loadedData);
                    // Check if this is a draft (status === 0)
                    setIsDraftMode(reportData.status === 0);
                    if (reportData.status === 0) {
                        setHasDraft(true);
                    }
                } else {
                    // No saved report, check for draft in localStorage
                    const draftData = loadDraftFromLocalStorage(student.id, reportDate);
                    if (draftData) {
                        setDailyReportFormData(draftData);
                        setIsDraftMode(true);
                    } else {
                        resetDailyReportForm();
                        setIsDraftMode(false);
                    }
                }
            } catch (error) {
                console.error('Error loading daily report for edit:', error);
                // Check for draft in localStorage as fallback
                const draftData = loadDraftFromLocalStorage(student.id, reportDate);
                if (draftData) {
                    setDailyReportFormData(draftData);
                    setIsDraftMode(true);
                } else {
                    resetDailyReportForm();
                    setIsDraftMode(false);
                }
            }
        } else {
            // New report - check for draft in localStorage
            const draftData = loadDraftFromLocalStorage(student.id, reportDate);
            if (draftData) {
                setDailyReportFormData(draftData);
                setIsDraftMode(true);
                // Ask user if they want to continue with draft
                Swal.fire({
                    title: 'Draft Found',
                    text: 'A draft report exists for this student. Do you want to continue with the draft?',
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Continue with Draft',
                    cancelButtonText: 'Start Fresh',
                    confirmButtonColor: '#667eea'
                }).then((result) => {
                    if (!result.isConfirmed) {
                        // User wants to start fresh
                        clearDraftFromLocalStorage(student.id, reportDate);
                        resetDailyReportForm();
                        setIsDraftMode(false);
                    }
                });
            } else {
                resetDailyReportForm();
                setIsDraftMode(false);
            }
        }
        setShowDailyReportFormModal(true);
    };

    const printDailyReport = () => {
        const printWindow = window.open('', '_blank');
        const reportContent = `
            <html>
                <head>
                    <title>Daily Report - ${selectedStudent?.name}</title>
                    <style>
                        body { font-family: Arial, sans-serif; padding: 20px; }
                        .header { text-align: center; margin-bottom: 30px; border-bottom: 2px solid #667eea; padding-bottom: 20px; }
                        .section { margin-bottom: 25px; }
                        .section-title { background: #667eea; color: white; padding: 10px; margin-bottom: 15px; font-weight: bold; }
                        .info-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 15px; margin-bottom: 20px; }
                        .info-item { padding: 10px; background: #f8f9fa; border-radius: 5px; }
                        .info-label { font-size: 12px; color: #666; text-transform: uppercase; font-weight: bold; }
                        .info-value { font-size: 14px; font-weight: 600; color: #333; }
                        table { width: 100%; border-collapse: collapse; margin-top: 10px; }
                        th, td { padding: 8px; border: 1px solid #ddd; text-align: left; }
                        th { background: #f8f9fa; font-weight: bold; }
                        .feeling-badge { display: inline-block; padding: 5px 15px; border-radius: 15px; color: white; margin-right: 10px; }
                        .happy { background: #4CAF50; }
                        .sick { background: #f44336; }
                        .content-text { padding: 15px; background: #f8f9fa; border-radius: 5px; line-height: 1.6; }
                        .bring-items { display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 10px; }
                        .bring-item { padding: 8px; background: #fff3cd; border-radius: 5px; text-align: center; }
                        @media print { body { margin: 0; } }
                    </style>
                </head>
                <body>
                    <div class="header">
                        <h1>Daily Report</h1>
                        <h2>${selectedStudent?.name}</h2>
                        <p><strong>Date:</strong> ${dailyReportData?.report_date ? new Date(dailyReportData.report_date).toLocaleDateString('en-US', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        }) : new Date().toLocaleDateString('en-US', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        })}</p>
                    </div>
                    
                    <div class="section">
                        <div class="section-title">Student Information</div>
                        <div class="info-grid">
                            <div class="info-item">
                                <div class="info-label">Student Name</div>
                                <div class="info-value">${dailyReportData?.student?.name || 'N/A'}</div>
                            </div>
                            <div class="info-item">
                                <div class="info-label">Class</div>
                                <div class="info-value">${dailyReportData?.class?.name || 'N/A'}</div>
                            </div>
                            <div class="info-item">
                                <div class="info-label">Attendance</div>
                                <div class="info-value">${dailyReportData?.is_present ? 'Present' : 'Absent'}</div>
                            </div>
                        </div>
                    </div>

                    ${dailyReportData?.daily_report ? `
                        ${dailyReportData.daily_report.daily_report_fealings && dailyReportData.daily_report.daily_report_fealings.length > 0 ? `
                            <div class="section">
                                <div class="section-title">Today I Felt</div>
                                ${dailyReportData.daily_report.daily_report_fealings.map(feeling =>
            `<span class="feeling-badge ${feeling.fealing.name === 'Happy' ? 'happy' : 'sick'}">${feeling.fealing.name}</span>`
        ).join('')}
                            </div>
                        ` : ''}

                        ${dailyReportData.daily_report.learned ? `
                            <div class="section">
                                <div class="section-title">Today I Learned</div>
                                <div class="content-text">${dailyReportData.daily_report.learned.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ')}</div>
                            </div>
                        ` : ''}

                        ${dailyReportData.daily_report.daily_report_diapers && dailyReportData.daily_report.daily_report_diapers.length > 0 ? `
                            <div class="section">
                                <div class="section-title">Diapers/Toilet (${dailyReportData.daily_report.daily_report_diapers.length} entries)</div>
                                <table>
                                    <thead>
                                        <tr><th>Time</th><th>Check</th></tr>
                                    </thead>
                                    <tbody>
                                        ${dailyReportData.daily_report.daily_report_diapers.map(diaper => `
                                            <tr>
                                                <td>${new Date(`2000-01-01T${diaper.diaper_time}`).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })}</td>
                                                <td>${diaper.diaper_check === 1 ? 'D/T' : diaper.diaper_check === 2 ? 'Dry' : diaper.diaper_check === 3 ? 'Wet' : 'BM'}</td>
                                            </tr>
                                        `).join('')}
                                    </tbody>
                                </table>
                            </div>
                        ` : ''}

                        ${dailyReportData.daily_report.daily_report_sleeps && dailyReportData.daily_report.daily_report_sleeps.length > 0 ? `
                            <div class="section">
                                <div class="section-title">Sleep (${dailyReportData.daily_report.daily_report_sleeps.length} entries)</div>
                                <table>
                                    <thead>
                                        <tr><th>Start Time</th><th>End Time</th><th>Duration</th></tr>
                                    </thead>
                                    <tbody>
                                        ${dailyReportData.daily_report.daily_report_sleeps.map(sleep => {
            const start = new Date(`2000-01-01T${sleep.start_time}`);
            const end = new Date(`2000-01-01T${sleep.end_time}`);
            const duration = Math.abs(end - start) / (1000 * 60);
            const hours = Math.floor(duration / 60);
            const minutes = Math.floor(duration % 60);
            return `
                                                <tr>
                                                    <td>${start.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })}</td>
                                                    <td>${end.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })}</td>
                                                    <td>${hours > 0 ? `${hours}h ` : ''}${minutes}m</td>
                                                </tr>
                                            `;
        }).join('')}
                                    </tbody>
                                </table>
                            </div>
                        ` : ''}

                        ${dailyReportData.daily_report.daily_report_bring_mores && dailyReportData.daily_report.daily_report_bring_mores.length > 0 ? `
                            <div class="section">
                                <div class="section-title">Please Bring More</div>
                                <div class="bring-items">
                                    ${dailyReportData.daily_report.daily_report_bring_mores.map(item => {
            const names = { 1: 'Diapers', 2: 'Wipes', 3: 'Ointment', 4: 'Clothes', 5: 'Blanket', 6: item.other || 'Other' };
            return `<div class="bring-item">${names[item.things] || 'Unknown'}</div>`;
        }).join('')}
                                </div>
                            </div>
                        ` : ''}

                        ${dailyReportData.daily_report.comments ? `
                            <div class="section">
                                <div class="section-title">Comments</div>
                                <div class="content-text">${dailyReportData.daily_report.comments.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ')}</div>
                            </div>
                        ` : ''}
                    ` : '<div class="section"><p>No daily report data available.</p></div>'}
                </body>
            </html>
        `;

        printWindow.document.write(reportContent);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
            printWindow.print();
        }, 500);
    };

    const isToday = (dateString) => {
        if (!dateString) return true; // If no date, assume today for new reports
        const reportDate = new Date(dateString);
        const today = new Date();
        return reportDate.toDateString() === today.toDateString();
    };

    const editDailyReport = (student) => {
        if (!dailyReportData?.daily_report || !isToday(dailyReportData.report_date)) {
            Swal.fire({
                icon: 'warning',
                title: 'Cannot Edit',
                text: 'You can only edit today\'s reports.',
                confirmButtonColor: '#667eea'
            });
            return;
        }

        setSelectedStudent(student || selectedStudent);
        setDailyReportFormData({
            feeling_id: dailyReportData.daily_report.daily_report_fealings?.[0]?.fealing_id || '',
            learned: dailyReportData.daily_report.learned ? dailyReportData.daily_report.learned.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ') : '',
            comments: dailyReportData.daily_report.comments ? dailyReportData.daily_report.comments.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ') : '',
            diapers: dailyReportData.daily_report.daily_report_diapers?.map(d => ({
                diaper_time: d.diaper_time,
                diaper_check: d.diaper_check
            })) || [],
            meals: dailyReportData.daily_report.daily_report_meals?.map(m => ({
                meal_time: m.meal_time,
                meal_type_id: m.meal_type_id,
                meal_amount: m.meal_amount
            })) || [],
            sleeps: dailyReportData.daily_report.daily_report_sleeps?.map(s => ({
                start_time: s.start_time,
                end_time: s.end_time
            })) || [],
            bring_diapers: dailyReportData.daily_report.daily_report_bring_mores?.some(item => item.things === 1) || false,
            bring_wipes: dailyReportData.daily_report.daily_report_bring_mores?.some(item => item.things === 2) || false,
            bring_ointment: dailyReportData.daily_report.daily_report_bring_mores?.some(item => item.things === 3) || false,
            bring_clothes: dailyReportData.daily_report.daily_report_bring_mores?.some(item => item.things === 4) || false,
            bring_blanket: dailyReportData.daily_report.daily_report_bring_mores?.some(item => item.things === 5) || false,
            bring_other: dailyReportData.daily_report.daily_report_bring_mores?.find(item => item.things === 6)?.other || ''
        });
        setIsEditingDailyReport(true);
        setShowDailyReportModal(false);
        setShowDailyReportFormModal(true);
    };

    const handleAddReport = async (student) => {
        setSelectedStudent(student);
        const reportDate = selectedDate.toISOString().split('T')[0];

        // Check if student already has a report for today by loading it
        try {
            const response = await apiHandler(DAILY_REPORT_VIEW, 'POST', {
                student_id: student.id,
                class_id: scheduleInfo?.class_id || profileData?.class_id || profileData?.class?.id,
                report_date: reportDate
            });

            if (response.data?.response?.status === 200 && response.data?.data?.daily_report) {
                // Set the daily report data for use in edit
                setDailyReportData(response.data?.data || {});
                setCurrentDailyReportData(response.data?.data?.daily_report || null);

                // Load existing report data for editing using the same logic as editDailyReport
                const reportData = response.data.data.daily_report;
                setDailyReportFormData({
                    feeling_id: reportData.daily_report_fealings?.[0]?.fealing_id || 1,
                    learned: reportData.learned ? reportData.learned.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ') : '',
                    comments: reportData.comments ? reportData.comments.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ') : '',
                    diapers: reportData.daily_report_diapers?.map(d => ({
                        diaper_time: d.diaper_time,
                        diaper_check: d.diaper_check
                    })) || [],
                    meals: reportData.daily_report_meals?.map(m => ({
                        meal_time: m.meal_time,
                        meal_type_id: m.meal_type_id,
                        meal_amount: m.meal_amount
                    })) || [],
                    sleeps: reportData.daily_report_sleeps?.map(s => ({
                        start_time: s.start_time,
                        end_time: s.end_time
                    })) || [],
                    bring_diapers: reportData.daily_report_bring_mores?.some(item => item.things === 1) || false,
                    bring_wipes: reportData.daily_report_bring_mores?.some(item => item.things === 2) || false,
                    bring_ointment: reportData.daily_report_bring_mores?.some(item => item.things === 3) || false,
                    bring_clothes: reportData.daily_report_bring_mores?.some(item => item.things === 4) || false,
                    bring_blanket: reportData.daily_report_bring_mores?.some(item => item.things === 5) || false,
                    other_item: reportData.daily_report_bring_mores?.find(item => item.things === 6)?.other || ''
                });
                setIsEditingDailyReport(true);
                
                // Check if this is a draft (status === 0)
                setIsDraftMode(reportData.status === 0);
                if (reportData.status === 0) {
                    setHasDraft(true);
                }

                // Show success message for editing
                Swal.fire({
                    title: reportData.status === 0 ? 'Draft Found' : 'Existing Report Found',
                    text: reportData.status === 0 ? 'Loading draft report for editing.' : 'Loading existing report for editing.',
                    icon: 'info',
                    timer: 1500,
                    showConfirmButton: false
                });
            } else {
                // No existing report on server, check for draft in localStorage
                const draftData = loadDraftFromLocalStorage(student.id, reportDate);
                if (draftData) {
                    setDailyReportFormData(draftData);
                    setIsEditingDailyReport(false);
                    setIsDraftMode(true);
                    
                    // Ask user if they want to continue with draft
                    Swal.fire({
                        title: 'Draft Found',
                        text: 'A draft report exists for this student. Do you want to continue with the draft?',
                        icon: 'question',
                        showCancelButton: true,
                        confirmButtonText: 'Continue with Draft',
                        cancelButtonText: 'Start Fresh',
                        confirmButtonColor: '#667eea'
                    }).then((result) => {
                        if (!result.isConfirmed) {
                            // User wants to start fresh
                            clearDraftFromLocalStorage(student.id, reportDate);
                            resetDailyReportForm();
                            setIsDraftMode(false);
                        }
                    });
                } else {
                    // No draft found, create new one
                    resetDailyReportForm();
                    setIsEditingDailyReport(false);
                    setIsDraftMode(false);
                }
            }

            setShowDailyReportFormModal(true);
        } catch (error) {
            console.error('Error checking for existing report:', error);
            // If there's an error (likely no report exists), check for draft in localStorage
            const draftData = loadDraftFromLocalStorage(student.id, reportDate);
            if (draftData) {
                setDailyReportFormData(draftData);
                setIsEditingDailyReport(false);
                setIsDraftMode(true);
                
                // Ask user if they want to continue with draft
                Swal.fire({
                    title: 'Draft Found',
                    text: 'A draft report exists for this student. Do you want to continue with the draft?',
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Continue with Draft',
                    cancelButtonText: 'Start Fresh',
                    confirmButtonColor: '#667eea'
                }).then((result) => {
                    if (!result.isConfirmed) {
                        // User wants to start fresh
                        clearDraftFromLocalStorage(student.id, reportDate);
                        resetDailyReportForm();
                        setIsDraftMode(false);
                    }
                });
            } else {
                // No draft found, create new one
                resetDailyReportForm();
                setIsEditingDailyReport(false);
                setIsDraftMode(false);
            }
            setShowDailyReportFormModal(true);
        }
    };

    const resetDailyReportForm = () => {
        setDailyReportFormData({
            feeling_id: 1,
            learned: '',
            comments: '',
            diapers: [],
            meals: [],
            sleeps: [],
            bring_diapers: false,
            bring_wipes: false,
            bring_ointment: false,
            bring_clothes: false,
            bring_blanket: false,
            other_item: ''
        });
        // Don't reset selectedStudent and isEditingDailyReport here to preserve form context
    };

    const handleCloseDailyReportModal = () => {
        // Check if form has any data
        const hasData = dailyReportFormData.learned || 
                       dailyReportFormData.comments || 
                       dailyReportFormData.diapers.length > 0 || 
                       dailyReportFormData.meals.length > 0 || 
                       dailyReportFormData.sleeps.length > 0 ||
                       dailyReportFormData.bring_diapers ||
                       dailyReportFormData.bring_wipes ||
                       dailyReportFormData.bring_ointment ||
                       dailyReportFormData.bring_clothes ||
                       dailyReportFormData.bring_blanket ||
                       dailyReportFormData.other_item;

        if (hasData && selectedStudent) {
            // Auto-save draft to localStorage
            const reportDate = selectedDate.toISOString().split('T')[0];
            saveDraftToLocalStorage(selectedStudent.id, reportDate, dailyReportFormData);
        }
        
        setShowDailyReportFormModal(false);
        resetDailyReportForm();
        setIsDraftMode(false);
    };

    const saveDailyReport = async (saveAsDraft = false) => {
        if (!selectedStudent) {
            Swal.fire({
                title: 'Error',
                text: 'Please select a student',
                icon: 'error',
                confirmButtonText: 'OK'
            });
            return;
        }

        // For draft, we don't need strict validation
        if (!saveAsDraft) {
            // Validate required fields for publish
            if (!dailyReportFormData.feeling_id) {
                Swal.fire({
                    title: 'Validation Error',
                    text: 'Please select how the student felt today',
                    icon: 'warning',
                    confirmButtonText: 'OK'
                });
                return;
            }
        }

        try {
            const reportDate = selectedDate.toISOString().split('T')[0];
            const payload = {
                student_id: selectedStudent.id,
                class_id: scheduleInfo?.class_id || profileData?.class_id || profileData?.class?.id,
                report_date: reportDate,
                comments: dailyReportFormData.comments || '',
                learned: dailyReportFormData.learned || '',
                feeling_id: dailyReportFormData.feeling_id || 1,
                status: saveAsDraft ? 0 : 1, // 0 for draft, 1 for published
                diapers: dailyReportFormData.diapers || [],
                meals: dailyReportFormData.meals || [],
                sleeps: dailyReportFormData.sleeps || [],
                bring_diapers: dailyReportFormData.bring_diapers || false,
                bring_wipes: dailyReportFormData.bring_wipes || false,
                bring_ointment: dailyReportFormData.bring_ointment || false,
                bring_clothes: dailyReportFormData.bring_clothes || false,
                bring_blanket: dailyReportFormData.bring_blanket || false,
                other_item: dailyReportFormData.other_item || ''
            };

            console.log('Saving daily report with payload:', payload);

            const response = await apiHandler(DAILY_REPORT_STORE, 'POST', payload);

            console.log('Daily report response:', response);

            if (response.data?.response?.status === 200) {
                if (saveAsDraft) {
                    // Save draft to localStorage for quick access
                    saveDraftToLocalStorage(selectedStudent.id, reportDate, dailyReportFormData);
                    setIsDraftMode(true);
                } else {
                    // Clear draft from localStorage on successful publish
                    clearDraftFromLocalStorage(selectedStudent.id, reportDate);
                    Swal.fire({
                        title: 'Success!',
                        text: response.data?.data?.message || 'Daily report published successfully!',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });
                    setIsDraftMode(false);
                }
                setShowDailyReportFormModal(false);
                resetDailyReportForm();
                setSelectedStudent(null);
                setIsEditingDailyReport(false);
                // Refresh the attendance data to show the new report
                await loadAttendanceData();
            } else {
                throw new Error(response.data?.response?.message || response.data?.data?.message || 'Failed to save daily report');
            }
        } catch (error) {
            console.error('Error saving daily report:', error);
            Swal.fire({
                title: 'Error',
                text: error.message || 'Failed to save daily report',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    };

    const viewMedication = async (student) => {
        try {
            const response = await apiHandler(TEACHERS_MEDICATION_API, 'POST', {
                student_id: student.id
            });

            if (response.data?.response?.status === 200 && response.data.data) {
                const { student: studentData, medication, medication_logs } = response.data.data;
                
                if (medication) {
                    // Has medication data
                    setMedicationData({
                        student_id: student.id,
                        first_name: studentData?.name?.split(' ')[0] || student.name.split(' ')[0],
                        last_name: studentData?.name?.split(' ').slice(1).join(' ') || student.name.split(' ').slice(1).join(' '),
                        student_email: studentData?.email || student.email,
                        date_of_birth: 'N/A',
                        class_name: 'N/A',
                        parent_name: medication.parent_name || 'N/A',
                        medication_name: medication.medication_name || 'N/A',
                        times_to_be_administered: medication.times_to_be_administered ? (medication.times_to_be_administered.includes(':') ? Moment(medication.times_to_be_administered, 'HH:mm:ss').format('h:mm A') : medication.times_to_be_administered) : 'N/A',
                        date_start: medication.date_start ? Moment(medication.date_start).format('YYYY-MM-DD') : 'N/A',
                        date_end: medication.date_end ? Moment(medication.date_end).format('YYYY-MM-DD') : 'N/A',
                        expiry_date: medication.expiry_date ? Moment(medication.expiry_date).format('YYYY-MM-DD') : 'N/A',
                        parents_consent_and_instruction: medication.parents_consent_and_instruction || 'N/A',
                        additional_instructions: medication.additional_instructions || 'N/A',
                        reason_for_administering: medication.reason_for_administering || 'N/A',
                        doctor_note: medication.doctor_note || null,
                        signiture_of_parent: medication.signiture_of_parent || null,
                        signature_date: medication.signature_date ? Moment(medication.signature_date).format('MMM D YYYY') : 'N/A',
                        medication_id: medication.id,
                        status: medication.status
                    });
                    setSelectedStudent(student);
                    setMedicationLogs(medication_logs || []);
                    setShowMedicationModal(true);
                } else {
                    // No medication data
                    Swal.fire({
                        title: 'No Medication',
                        text: 'No medication record found for this student',
                        icon: 'info',
                        confirmButtonText: 'OK'
                    });
                }
            } else {
                Swal.fire({
                    title: 'No Medication',
                    text: 'No medication record found for this student',
                    icon: 'info',
                    confirmButtonText: 'OK'
                });
            }
        } catch (error) {
            console.error('Error loading medication:', error);
            Swal.fire({
                title: 'Error',
                text: 'Unable to load medication information',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    };

    // Medication Log Functions
    const handleAddMedicationLog = () => {
        // Reset form data
        setMedicationLogData({
            medication_date: new Date().toISOString().split('T')[0],
            medication: medicationData?.medication?.medication_name || '',
            is_dosage_given: 1,
            time_given: new Date().toTimeString().slice(0, 8),
            staff_signiture: '',
            comments: ''
        });
        setShowMedicationLogForm(true);
    };

    const saveMedicationLog = async () => {
        if (!medicationLogData.medication_date || !medicationLogData.medication) {
            Swal.fire({
                title: 'Validation Error',
                text: 'Please fill in medication date and medication name',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }

        try {
            setIsLoadingLogs(true);
            
            // Handle signature from canvas
            let signatureUrl = medicationLogData.staff_signiture;
            const hasNewSignature = medicationSignaturePadRef.current && !medicationSignaturePadRef.current.isEmpty();
            
            if (hasNewSignature) {
                const signatureDataURL = medicationSignaturePadRef.current.toDataURL('image/png');
                const signatureBlob = await fetch(signatureDataURL).then(res => res.blob());
                const signatureFile = new File([signatureBlob], `staff_signature_${Date.now()}.png`, { type: 'image/png' });
                signatureUrl = await handleImageUpload(signatureFile, 'signatures/', 'image/png');
            }
            
            const payload = {
                user_id: selectedStudent.id,
                administration_medication_id: medicationData.medication_id,
                medication_date: medicationLogData.medication_date,
                medication: medicationLogData.medication,
                is_dosage_given: medicationLogData.is_dosage_given
            };
            
            // Only include optional fields if they have values
            if (medicationLogData.time_given) {
                payload.time_given = medicationLogData.time_given;
            }
            if (signatureUrl) {
                payload.staff_signiture = signatureUrl;
            }
            if (medicationLogData.comments) {
                payload.comments = medicationLogData.comments;
            }

            let response;
            if (isEditingMedicationLog && medicationLogData.id) {
                // Update existing log
                response = await apiHandler(`${TEACHERS_MEDICATION_LOG_API}${medicationLogData.id}`, 'POST', payload);
            } else {
                // Create new log
                response = await apiHandler(TEACHERS_MEDICATION_LOG_STORE_API, 'POST', payload);
            }

            if (response.data?.response?.status === 200) {
                Swal.fire({
                    title: 'Success',
                    text: isEditingMedicationLog ? 'Medication log updated successfully' : 'Medication log added successfully',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });
                setShowMedicationLogFormModal(false);
                setIsEditingMedicationLog(false);
                // Reload medication data to get updated logs
                await viewMedication(selectedStudent);
            } else {
                throw new Error(response.data?.response?.message || 'Failed to save medication log');
            }
        } catch (error) {
            console.error('Error saving medication log:', error);
            Swal.fire({
                title: 'Error',
                text: error.message || 'Failed to save medication log',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        } finally {
            setIsLoadingLogs(false);
        }
    };

    const viewMedicationLog = (log) => {
        setSelectedLog(log);
        setShowLogViewModal(true);
    };

    const deleteMedicationLog = async (logId, medicationId) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'This medication log will be permanently deleted.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        });

        if (result.isConfirmed) {
            try {
                const response = await apiHandler(`users/v1/attendance/medication/log/${logId}`, 'DELETE');

                if (response.data?.response?.status === 200) {
                    Swal.fire({
                        title: 'Deleted!',
                        text: 'Medication log has been deleted successfully.',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });

                    // Reload medication data
                    await viewMedication(selectedStudent);
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: response.data?.response?.message || 'Failed to delete medication log',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    });
                }
            } catch (error) {
                console.error('Error deleting medication log:', error);
                Swal.fire({
                    title: 'Network Error',
                    text: 'Unable to connect to the server. Please check your internet connection.',
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            }
        }
    };

    const editMedicationLog = (log) => {
        setMedicationLogData({
            id: log.id,
            medication_date: log.medication_date ? Moment(log.medication_date).format('YYYY-MM-DD') : '',
            medication: log.medication || '',
            is_dosage_given: log.is_dosage_given || 1,
            time_given: log.time_given || '',
            staff_signiture: log.staff_signiture || '',
            comments: log.comments || ''
        });
        setIsEditingMedicationLog(true);
        setShowMedicationLogFormModal(true);
    };

    // Non-Medication Log Functions
    const saveNonMedicationLog = async () => {
        if (!nonMedicationLogData.medication_date || !nonMedicationLogData.medication) {
            Swal.fire({
                title: 'Validation Error',
                text: 'Please fill in medication date and medication name',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }

        try {
            setIsLoadingLogs(true);
            
            // Handle signature from canvas
            let signatureUrl = nonMedicationLogData.staff_signiture;
            const hasNewSignature = nonMedicationSignaturePadRef.current && !nonMedicationSignaturePadRef.current.isEmpty();
            
            if (hasNewSignature) {
                const signatureDataURL = nonMedicationSignaturePadRef.current.toDataURL('image/png');
                const signatureBlob = await fetch(signatureDataURL).then(res => res.blob());
                const signatureFile = new File([signatureBlob], `staff_signature_${Date.now()}.png`, { type: 'image/png' });
                signatureUrl = await handleImageUpload(signatureFile, 'signatures/', 'image/png');
            }
            
            const payload = {
                user_id: selectedStudent.id,
                administration_non_medication_id: nonMedicationData.non_medication_id,
                medication_date: nonMedicationLogData.medication_date,
                medication: nonMedicationLogData.medication,
                is_dosage_given: nonMedicationLogData.is_dosage_given
            };
            
            // Only include optional fields if they have values
            if (nonMedicationLogData.time_given) {
                payload.time_given = nonMedicationLogData.time_given;
            }
            if (signatureUrl) {
                payload.staff_signiture = signatureUrl;
            }
            if (nonMedicationLogData.comments) {
                payload.comments = nonMedicationLogData.comments;
            }

            let response;
            if (isEditingNonMedicationLog && nonMedicationLogData.id) {
                // Update existing log
                response = await apiHandler(`${TEACHERS_NON_MEDICATION_LOG_API}${nonMedicationLogData.id}`, 'POST', payload);
            } else {
                // Create new log
                response = await apiHandler(TEACHERS_NON_MEDICATION_LOG_STORE_API, 'POST', payload);
            }

            if (response.data?.response?.status === 200) {
                Swal.fire({
                    title: 'Success',
                    text: isEditingNonMedicationLog ? 'Non-medication log updated successfully' : 'Non-medication log added successfully',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });
                setShowNonMedicationLogFormModal(false);
                setIsEditingNonMedicationLog(false);
                // Reload non-medication data to get updated logs
                await viewNonMedication(selectedStudent);
            } else {
                throw new Error(response.data?.response?.message || 'Failed to save non-medication log');
            }
        } catch (error) {
            console.error('Error saving non-medication log:', error);
            Swal.fire({
                title: 'Error',
                text: error.message || 'Failed to save non-medication log',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        } finally {
            setIsLoadingLogs(false);
        }
    };

    const deleteNonMedicationLog = async (logId) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'This non-medication log will be permanently deleted.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        });

        if (result.isConfirmed) {
            try {
                const response = await apiHandler(`${TEACHERS_NON_MEDICATION_LOG_API}${logId}`, 'DELETE');

                if (response.data?.response?.status === 200) {
                    Swal.fire({
                        title: 'Deleted!',
                        text: 'Non-medication log has been deleted successfully.',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });

                    // Reload non-medication data
                    await viewNonMedication(selectedStudent);
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: response.data?.response?.message || 'Failed to delete non-medication log',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    });
                }
            } catch (error) {
                console.error('Error deleting non-medication log:', error);
                Swal.fire({
                    title: 'Network Error',
                    text: 'Unable to connect to the server. Please check your internet connection.',
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            }
        }
    };

    const editNonMedicationLog = (log) => {
        setNonMedicationLogData({
            id: log.id,
            medication_date: log.medication_date ? Moment(log.medication_date).format('YYYY-MM-DD') : '',
            medication: log.medication || '',
            is_dosage_given: log.is_dosage_given || 1,
            time_given: log.time_given || '',
            staff_signiture: log.staff_signiture || '',
            comments: log.comments || ''
        });
        setIsEditingNonMedicationLog(true);
        setShowNonMedicationLogFormModal(true);
    };

    const viewNonMedication = async (student) => {
        try {
            const response = await apiHandler(TEACHERS_NON_MEDICATION_API, 'POST', {
                student_id: student.id
            });
            if (response.data?.response?.status === 200 && response.data.data) {
                const { student: studentData, non_medication, non_medication_logs } = response.data.data;
                
                if (non_medication) {
                    setNonMedicationData({
                        student_id: student.id,
                        student_name: studentData?.name || student.name,
                        student_email: studentData?.email || student.email,
                        parent_name: non_medication.parent_name || 'N/A',
                        medication_name: non_medication.medication_name || 'N/A',
                        times_to_be_administered: non_medication.times_to_be_administered ? (non_medication.times_to_be_administered.includes(':') ? Moment(non_medication.times_to_be_administered, 'HH:mm:ss').format('h:mm A') : non_medication.times_to_be_administered) : 'N/A',
                        date_start: non_medication.date_start ? Moment(non_medication.date_start).format('YYYY-MM-DD') : 'N/A',
                        date_end: non_medication.date_end ? Moment(non_medication.date_end).format('YYYY-MM-DD') : 'N/A',
                        expiry_date: non_medication.expiry_date ? Moment(non_medication.expiry_date).format('YYYY-MM-DD') : 'N/A',
                        parents_consent_and_instruction: non_medication.parents_consent_and_instruction || 'N/A',
                        additional_instructions: non_medication.additional_instructions || 'N/A',
                        reason_for_administering: non_medication.reason_for_administering || 'N/A',
                        doctor_note: non_medication.doctor_note || null,
                        signiture_of_parent: non_medication.signiture_of_parent || null,
                        signature_date: non_medication.signature_date ? Moment(non_medication.signature_date).format('MMM D YYYY') : 'N/A',
                        non_medication_id: non_medication.id,
                        non_medication_logs: non_medication_logs || [],
                        status: non_medication.status
                    });
                    setSelectedStudent(student);
                    setShowNonMedicationModal(true);
                } else {
                    Swal.fire({
                        title: 'No Record',
                        text: 'No non-medication record found for this student',
                        icon: 'info',
                        confirmButtonText: 'OK'
                    });
                }
            } else {
                Swal.fire({
                    title: 'Info',
                    text: response.data?.response?.message || 'No non-medication found',
                    icon: 'info',
                    confirmButtonText: 'OK'
                });
            }
        } catch (error) {
            console.error('Error loading non-medication:', error);
            Swal.fire({
                title: 'Error',
                text: 'Failed to load non-medication',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    };

    const viewAllergy = async (student) => {
        try {
            const response = await apiHandler(TEACHERS_ALLERGY_VIEW_API, 'POST', {
                student_id: student.id
            });
            if (response.data?.response?.status === 200) {
                setAllergyData(response.data?.data || {});
                setSelectedStudent(student);
                setShowAllergyModal(true);
                // Remove focus from button
                if (document.activeElement) {
                    document.activeElement.blur();
                }
            } else {
                Swal.fire({
                    title: 'Info',
                    text: response.data?.response?.message || 'No allergy report found',
                    icon: 'info',
                    confirmButtonText: 'OK'
                });
            }
        } catch (error) {
            console.error('Error loading allergy report:', error);
            Swal.fire({
                title: 'Error',
                text: 'Failed to load allergy report',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    };

    const viewRegistration = async (student) => {
        setRegistrationLoading(true);
        setShowRegistrationModal(true);
        try {
            const response = await apiHandler(CHILD_REGISTRATION_VIEW, 'POST', {
                student_id: student.id
            });
            if (response.data?.response?.status === 200) {
                // Extract and flatten the nested data structure
                const apiData = response.data?.data?.data || response.data?.data || {};
                const userDetails = apiData.user_details || {};
                const registrationPackage = apiData.registration_package || {};
                
                console.log('Raw API Response:', apiData);
                console.log('User Details:', userDetails);
                console.log('Registration Package:', registrationPackage);
                
                // Merge user_details and registration_package into a flat structure
                const flattenedData = {
                    ...registrationPackage,
                    user_details: userDetails,
                    // Child Info
                    child_first_name: userDetails.first_name || registrationPackage.child_first_name,
                    child_last_name: userDetails.last_name || registrationPackage.child_last_name,
                    child_email: userDetails.email || registrationPackage.child_email,
                    child_dob: userDetails.user_setting?.dob || registrationPackage.child_dob || registrationPackage.child_date_of_birth,
                    child_gender: userDetails.user_setting?.gender || registrationPackage.child_gender,
                    child_photo: userDetails.user_setting?.photo || registrationPackage.child_photo,
                    child_age: registrationPackage.child_age,
                    child_home_address: userDetails.user_setting?.address || registrationPackage.child_home_address || registrationPackage.child_address,
                    child_city: registrationPackage.child_city,
                    child_province: registrationPackage.child_province,
                    child_state: registrationPackage.child_state,
                    child_postal_code: registrationPackage.child_postal_code,
                    // Mother/Parent 1
                    mother_name: registrationPackage.mother_name || registrationPackage.parent1_name,
                    mother_home_phone: registrationPackage.mother_home_phone || registrationPackage.parent1_home_phone,
                    mother_cell: registrationPackage.mother_cell || registrationPackage.parent1_cell,
                    mother_email: registrationPackage.mother_email || registrationPackage.parent1_email,
                    mother_home_address: registrationPackage.mother_home_address || registrationPackage.parent1_home_address,
                    mother_city: registrationPackage.mother_city || registrationPackage.parent1_city,
                    mother_province: registrationPackage.mother_province || registrationPackage.parent1_province,
                    mother_state: registrationPackage.mother_state || registrationPackage.parent1_state,
                    mother_postal_code: registrationPackage.mother_postal_code || registrationPackage.parent1_postal_code,
                    mother_work_phone: registrationPackage.mother_work_phone || registrationPackage.parent1_work_phone,
                    // Father/Parent 2
                    father_name: registrationPackage.father_name || registrationPackage.parent2_name,
                    father_home_phone: registrationPackage.father_home_phone || registrationPackage.parent2_home_phone,
                    father_cell: registrationPackage.father_cell || registrationPackage.parent2_cell,
                    father_email: registrationPackage.father_email || registrationPackage.parent2_email,
                    father_home_address: registrationPackage.father_home_address || registrationPackage.parent2_home_address,
                    father_city: registrationPackage.father_city || registrationPackage.parent2_city,
                    father_province: registrationPackage.father_province || registrationPackage.parent2_province,
                    father_state: registrationPackage.father_state || registrationPackage.parent2_state,
                    father_postal_code: registrationPackage.father_postal_code || registrationPackage.parent2_postal_code,
                    father_work_phone: registrationPackage.father_work_phone || registrationPackage.parent2_work_phone,
                    same_address: registrationPackage.same_address,
                    // Emergency Contact
                    emergency_contact_name: registrationPackage.emergency_contact_name,
                    emergency_contact_relationship: registrationPackage.emergency_contact_relationship || registrationPackage.emergency_contact_relation,
                    emergency_contact_phone: registrationPackage.emergency_contact_phone || registrationPackage.emergency_contact_home_phone,
                    emergency_contact_cell: registrationPackage.emergency_contact_cell,
                    emergency_contact_email: registrationPackage.emergency_contact_email,
                    emergency_contact_home_address: registrationPackage.emergency_contact_home_address || registrationPackage.emergency_contact_address,
                    emergency_contact_city: registrationPackage.emergency_contact_city,
                    emergency_contact_province: registrationPackage.emergency_contact_province,
                    emergency_contact_state: registrationPackage.emergency_contact_state,
                    emergency_contact_postal_code: registrationPackage.emergency_contact_postal_code,
                    emergency_contact_work_phone: registrationPackage.emergency_contact_work_phone,
                    emergency_contact_work_address: registrationPackage.emergency_contact_work_address,
                    // Pickup Persons
                    pickup1_name: registrationPackage.pickup1_name || registrationPackage.pickup_person1_name,
                    pickup1_relation: registrationPackage.pickup1_relation || registrationPackage.pickup_person1_relation,
                    pickup1_phone: registrationPackage.pickup1_phone || registrationPackage.pickup_person1_phone,
                    pickup1_cell: registrationPackage.pickup1_cell || registrationPackage.pickup_person1_cell,
                    pickup1_address: registrationPackage.pickup1_address || registrationPackage.pickup_person1_address,
                    pickup1_city: registrationPackage.pickup1_city || registrationPackage.pickup_person1_city,
                    pickup1_zip: registrationPackage.pickup1_zip || registrationPackage.pickup_person1_postal_code,
                    pickup2_name: registrationPackage.pickup2_name || registrationPackage.pickup_person2_name,
                    pickup2_relation: registrationPackage.pickup2_relation || registrationPackage.pickup_person2_relation,
                    pickup2_phone: registrationPackage.pickup2_phone || registrationPackage.pickup_person2_phone,
                    pickup2_cell: registrationPackage.pickup2_cell || registrationPackage.pickup_person2_cell,
                    pickup2_address: registrationPackage.pickup2_address || registrationPackage.pickup_person2_address,
                    pickup2_city: registrationPackage.pickup2_city || registrationPackage.pickup_person2_city,
                    pickup2_zip: registrationPackage.pickup2_zip || registrationPackage.pickup_person2_postal_code,
                    pickup3_name: registrationPackage.pickup3_name || registrationPackage.pickup_person3_name,
                    pickup3_relation: registrationPackage.pickup3_relation || registrationPackage.pickup_person3_relation,
                    pickup3_phone: registrationPackage.pickup3_phone || registrationPackage.pickup_person3_phone,
                    pickup3_cell: registrationPackage.pickup3_cell || registrationPackage.pickup_person3_cell,
                    pickup3_address: registrationPackage.pickup3_address || registrationPackage.pickup_person3_address,
                    pickup3_city: registrationPackage.pickup3_city || registrationPackage.pickup_person3_city,
                    pickup3_zip: registrationPackage.pickup3_zip || registrationPackage.pickup_person3_postal_code,
                    pickup4_name: registrationPackage.pickup4_name || registrationPackage.pickup_person4_name,
                    pickup4_relation: registrationPackage.pickup4_relation || registrationPackage.pickup_person4_relation,
                    pickup4_phone: registrationPackage.pickup4_phone || registrationPackage.pickup_person4_phone,
                    pickup4_cell: registrationPackage.pickup4_cell || registrationPackage.pickup_person4_cell,
                    pickup4_address: registrationPackage.pickup4_address || registrationPackage.pickup_person4_address,
                    pickup4_city: registrationPackage.pickup4_city || registrationPackage.pickup_person4_city,
                    pickup4_zip: registrationPackage.pickup4_zip || registrationPackage.pickup_person4_postal_code,
                    // Arrival and Departure
                    dropoff_time: registrationPackage.dropoff_time || registrationPackage.drop_off_time,
                    pickup_time: registrationPackage.pickup_time || registrationPackage.pick_up_time,
                    start_date: registrationPackage.start_date,
                    withdrawal_date: registrationPackage.withdrawal_date,
                    parent_guardian_signature: registrationPackage.parent_guardian_signature || registrationPackage.parent_signature,
                    executive_director_signature: registrationPackage.executive_director_signature,
                    // Medical Information
                    family_physician_name: registrationPackage.family_physician_name || registrationPackage.pediatrician_name,
                    physician_phone_number: registrationPackage.physician_phone_number || registrationPackage.pediatrician_phone,
                    physician_address: registrationPackage.physician_address,
                    current_medications: registrationPackage.current_medications || registrationPackage.medications,
                    allergies_health_info: registrationPackage.allergies_health_info || registrationPackage.allergies,
                    sleep_time_night: registrationPackage.sleep_time_night || registrationPackage.sleep_time,
                    wake_time_morning: registrationPackage.wake_time_morning || registrationPackage.wake_time,
                    child_favourite_activity: registrationPackage.child_favourite_activity,
                    emergency_auth_signature: registrationPackage.emergency_auth_signature,
                    emergency_auth_date: registrationPackage.emergency_auth_date,
                    // Child Information Page
                    agency_involvement: registrationPackage.agency_involvement || registrationPackage.child_related_agencies_involvement,
                    vision_history: registrationPackage.vision_history || registrationPackage.vision_history_glasses,
                    hearing_concerns: registrationPackage.hearing_concerns || registrationPackage.hearing_concerns_audiologist,
                    diagnoses: registrationPackage.diagnoses || registrationPackage.diagnoses_adhd_delays,
                    communicable_disease: registrationPackage.communicable_disease || registrationPackage.communicable_disease_history,
                    eating_concerns: registrationPackage.eating_concerns || registrationPackage.eating_appetite_concerns,
                    developmental_concerns: registrationPackage.developmental_concerns,
                    pets_at_home: registrationPackage.pets_at_home,
                    siblings_info: registrationPackage.siblings_info || registrationPackage.siblings_family_info,
                    favourite_toy: registrationPackage.favourite_toy || registrationPackage.child_favourite_toy_activity,
                    enrollment_date: registrationPackage.enrollment_date,
                    // Media Release Waiver
                    media_release_agree: registrationPackage.media_release_agree,
                    media_release_disagree: registrationPackage.media_release_disagree,
                    media_release_child_name: registrationPackage.media_release_child_name,
                    media_release_child_name_agree: registrationPackage.media_release_child_name_agree,
                    media_release_child_name_disagree: registrationPackage.media_release_child_name_disagree,
                    media_release_parent_name: registrationPackage.media_release_parent_name,
                    media_release_parent_name_agree: registrationPackage.media_release_parent_name_agree,
                    media_release_parent_name_disagree: registrationPackage.media_release_parent_name_disagree,
                    media_release_date: registrationPackage.media_release_date,
                    media_release_date_agree: registrationPackage.media_release_date_agree,
                    media_release_date_disagree: registrationPackage.media_release_date_disagree,
                    media_release_signature: registrationPackage.media_release_signature,
                    media_release_signature_agree: registrationPackage.media_release_signature_agree,
                    media_release_signature_disagree: registrationPackage.media_release_signature_disagree,
                    // Off-Site Permission
                    offsite_permission: registrationPackage.offsite_permission,
                    offsite_parent_name: registrationPackage.offsite_parent_name,
                    offsite_permission_parent_name: registrationPackage.offsite_permission_parent_name,
                    offsite_child_name: registrationPackage.offsite_child_name,
                    offsite_permission_child_name: registrationPackage.offsite_permission_child_name,
                    offsite_date: registrationPackage.offsite_date,
                    offsite_permission_date: registrationPackage.offsite_permission_date,
                    offsite_signature: registrationPackage.offsite_signature,
                    offsite_permission_signature: registrationPackage.offsite_permission_signature,
                    offsite_signature: registrationPackage.offsite_signature,
                    // Contract Terms
                    contract_terms_initials: registrationPackage.contract_terms_initials,
                    contract_initial_1: registrationPackage.contract_initial_1,
                    contract_initial_2: registrationPackage.contract_initial_2,
                    contract_initial_3: registrationPackage.contract_initial_3,
                    contract_initial_4: registrationPackage.contract_initial_4,
                    contract_initial_5: registrationPackage.contract_initial_5,
                    contract_initial_6: registrationPackage.contract_initial_6,
                    contract_initial_7: registrationPackage.contract_initial_7,
                    contract_initial_8: registrationPackage.contract_initial_8,
                    contract_initial_9: registrationPackage.contract_initial_9,
                    contract_initial_10: registrationPackage.contract_initial_10,
                    contract_initial_11: registrationPackage.contract_initial_11,
                    contract_initial_12: registrationPackage.contract_initial_12,
                    contract_initial_13: registrationPackage.contract_initial_13,
                    contract_parent_name: registrationPackage.contract_parent_name,
                    contract_date: registrationPackage.contract_date,
                    contract_signature: registrationPackage.contract_signature,
                    financially_responsible_name: registrationPackage.financially_responsible_name,
                    financially_responsible_agency: registrationPackage.financially_responsible_agency,
                    financially_responsible_date: registrationPackage.financially_responsible_date,
                    financially_responsible_signature: registrationPackage.financially_responsible_signature,
                    // Registration Checklist
                    checklist_submitted: registrationPackage.checklist_submitted,
                    checklist_items: registrationPackage.checklist_items,
                    checklist_registration_form: registrationPackage.checklist_registration_form,
                    checklist_emergency_form: registrationPackage.checklist_emergency_form,
                    checklist_health_forms: registrationPackage.checklist_health_forms,
                    checklist_immunization_records: registrationPackage.checklist_immunization_records,
                    checklist_physical_exam: registrationPackage.checklist_physical_exam,
                    checklist_allergy_action_plan: registrationPackage.checklist_allergy_action_plan,
                    checklist_medication_authorization: registrationPackage.checklist_medication_authorization,
                    checklist_photo_release: registrationPackage.checklist_photo_release,
                    checklist_contract_signed: registrationPackage.checklist_contract_signed,
                    checklist_tuition_payment: registrationPackage.checklist_tuition_payment,
                    checklist_no_peanut_policy: registrationPackage.checklist_no_peanut_policy,
                    checklist_offsite_permission: registrationPackage.checklist_offsite_permission,
                    checklist_meal_waiver: registrationPackage.checklist_meal_waiver,
                    checklist_parent_date: registrationPackage.checklist_parent_date,
                    checklist_parent_signature: registrationPackage.checklist_parent_signature,
                    checklist_staff_date: registrationPackage.checklist_staff_date,
                    checklist_staff_signature: registrationPackage.checklist_staff_signature
                };
                
                console.log('Flattened Registration data:', flattenedData);
                setRegistrationData(flattenedData);
                setSelectedStudent(student);
                setRegistrationLoading(false);
                // Remove focus from button
                if (document.activeElement) {
                    document.activeElement.blur();
                }
            } else {
                setRegistrationLoading(false);
                setShowRegistrationModal(false);
                Swal.fire({
                    title: 'Info',
                    text: response.data?.response?.message || 'No registration form found for this student',
                    icon: 'info',
                    confirmButtonText: 'OK'
                });
            }
        } catch (error) {
            setRegistrationLoading(false);
            setShowRegistrationModal(false);
            console.error('Error loading registration form:', error);
            Swal.fire({
                title: 'Error',
                text: 'Failed to load registration form',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    };

    const viewMeditationExercises = (student) => {
        setMeditationData({
            student: {
                id: student.id,
                name: student.name,
                photo: student.profile_photo_url
            },
            exercises: [
                { id: 1, name: 'Deep Breathing', duration: '5 minutes', description: 'Inhale deeply through nose, exhale through mouth' },
                { id: 2, name: 'Body Scan', duration: '10 minutes', description: 'Focus attention on different parts of the body' },
                { id: 3, name: 'Mindful Sitting', duration: '5 minutes', description: 'Sit quietly and observe thoughts without judgment' },
                { id: 4, name: 'Loving Kindness', duration: '7 minutes', description: 'Send positive wishes to self and others' }
            ]
        });
        setSelectedStudent(student);
        setShowMeditationModal(true);
        // Remove focus from button
        if (document.activeElement) {
            document.activeElement.blur();
        }
    };

    const viewPeanutPolicy = async (student) => {
        try {
            const response = await apiHandler(TEACHERS_PEANUT_POLICY_API, 'POST', {
                student_id: student.id
            });
            if (response.data?.response?.status === 200) {
                // Handle new API response structure
                setPeanutPolicyData({
                    student: response.data.data.student,
                    policy: response.data.data.policy
                });
                setSelectedStudent(student);
                setShowPeanutPolicyModal(true);
            } else {
                Swal.fire({
                    title: 'Info',
                    text: response.data?.response?.message || 'No peanut policy found',
                    icon: 'info',
                    confirmButtonText: 'OK'
                });
            }
        } catch (error) {
            console.error('Error loading peanut policy:', error);
            Swal.fire({
                title: 'Error',
                text: 'Failed to load peanut policy',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    };

    // View Accident Reports for a student
    const viewAccidentReports = async (student) => {
        setLoadingAccidentReports(true);
        setShowAccidentReportsModal(true);
        setSelectedStudent(student);
        try {
            const formData = new FormData();
            formData.append('page', 1);
            formData.append('limit', 100);
            formData.append('user_id', student.id);
            
            const response = await apiHandler(ACCIDENT_REPORTS_LIST, 'POST', formData);
            if (response.data?.response?.status === 200) {
                const reports = response.data.data.data.data || [];
                setAccidentReports(reports);
                setLoadingAccidentReports(false);
            } else {
                setLoadingAccidentReports(false);
                setAccidentReports([]);
            }
        } catch (error) {
            console.error('Error loading accident reports:', error);
            setLoadingAccidentReports(false);
            setAccidentReports([]);
            Swal.fire({
                title: 'Error',
                text: 'Failed to load accident reports',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    };

    // View Illness Reports for a student
    const viewIllnessReports = async (student) => {
        setLoadingIllnessReports(true);
        setShowIllnessReportsModal(true);
        setSelectedStudent(student);
        try {
            const formData = new FormData();
            formData.append('page', 1);
            formData.append('limit', 100);
            formData.append('user_id', student.id);
            
            const response = await apiHandler(ILLNESS_REPORTS_LIST, 'POST', formData);
            if (response.data?.response?.status === 200) {
                const reports = response.data.data.data.data || [];
                setIllnessReports(reports);
                setLoadingIllnessReports(false);
            } else {
                setLoadingIllnessReports(false);
                setIllnessReports([]);
            }
        } catch (error) {
            console.error('Error loading illness reports:', error);
            setLoadingIllnessReports(false);
            setIllnessReports([]);
            Swal.fire({
                title: 'Error',
                text: 'Failed to load illness reports',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    };

    // Handle signing accident report
    const handleSignAccidentReport = (report) => {
        setSelectedAccidentReport(report);
        setAccidentSignatureDate('');
        setShowAccidentSignatureModal(true);
    };

    // Submit accident report signature
    const submitAccidentReportSignature = async () => {
        if (!accidentSignaturePadRef.current || accidentSignaturePadRef.current.isEmpty()) {
            Swal.fire({
                icon: 'warning',
                title: 'Signature Required',
                text: 'Please provide your signature before submitting.'
            });
            return;
        }

        if (!accidentSignatureDate) {
            Swal.fire({
                icon: 'warning',
                title: 'Date Required',
                text: 'Please select a signature date.'
            });
            return;
        }

        try {
            const signatureDataURL = accidentSignaturePadRef.current.toDataURL('image/png');
            const response = await fetch(signatureDataURL);
            const blob = await response.blob();
            const timestamp = new Date().getTime();
            const fileName = `signature_${timestamp}.png`;
            const file = new File([blob], fileName, { type: 'image/png' });
            const signatureUrl = await handleImageUpload(file, 'signatures/', 'image/png');

            const formData = new FormData();
            formData.append('id', selectedAccidentReport.id);
            formData.append('parent_signature', signatureUrl);
            formData.append('parent_signature_date', accidentSignatureDate);

            const submitResponse = await apiHandler(ACCIDENT_REPORT_SIGNATURE, 'POST', formData);

            if (submitResponse.data?.response?.status === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: 'Signature submitted successfully.',
                    timer: 2000,
                    showConfirmButton: false
                });

                setShowAccidentSignatureModal(false);
                // Reload accident reports
                await viewAccidentReports(selectedStudent);
            } else {
                throw new Error(submitResponse.data?.response?.message || 'Signature submission failed');
            }
        } catch (error) {
            console.error('Error submitting signature:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message || 'Failed to submit signature. Please try again.'
            });
        }
    };

    // Handle signing illness report
    const handleSignIllnessReport = (report) => {
        setSelectedIllnessReport(report);
        setIllnessSignatureDate('');
        setShowIllnessSignatureModal(true);
    };

    // Submit illness report signature
    const submitIllnessReportSignature = async () => {
        if (!illnessSignaturePadRef.current || illnessSignaturePadRef.current.isEmpty()) {
            Swal.fire({
                icon: 'warning',
                title: 'Signature Required',
                text: 'Please provide your signature before submitting.'
            });
            return;
        }

        if (!illnessSignatureDate) {
            Swal.fire({
                icon: 'warning',
                title: 'Date Required',
                text: 'Please select a signature date.'
            });
            return;
        }

        try {
            const signatureDataURL = illnessSignaturePadRef.current.toDataURL('image/png');
            const response = await fetch(signatureDataURL);
            const blob = await response.blob();
            const timestamp = new Date().getTime();
            const fileName = `signature_${timestamp}.png`;
            const file = new File([blob], fileName, { type: 'image/png' });
            const signatureUrl = await handleImageUpload(file, 'signatures/', 'image/png');

            const formData = new FormData();
            formData.append('id', selectedIllnessReport.id);
            formData.append('parent_signature', signatureUrl);
            formData.append('parent_signature_date', illnessSignatureDate);

            const submitResponse = await apiHandler(ILLNESS_REPORT_SIGNATURE, 'POST', formData);

            if (submitResponse.data?.response?.status === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: 'Signature submitted successfully.',
                    timer: 2000,
                    showConfirmButton: false
                });

                setShowIllnessSignatureModal(false);
                // Reload illness reports
                await viewIllnessReports(selectedStudent);
            } else {
                throw new Error(submitResponse.data?.response?.message || 'Signature submission failed');
            }
        } catch (error) {
            console.error('Error submitting signature:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message || 'Failed to submit signature. Please try again.'
            });
        }
    };

    // Open create accident report modal
    const handleCreateAccidentReport = (student) => {
        setSelectedStudent(student);
        setIsEditingAccidentReport(false);
        setEditingAccidentReportId(null);
        setAccidentFormData({
            classroom: '',
            child_name: student.name,
            incident_date: Moment().format('YYYY-MM-DD'),
            incident_time: Moment().format('HH:mm'),
            location: '',
            incident_description: '',
            first_aid: '',
            parent_contacted: false,
            parent_contacted_time: '',
            follow_up_information: '',
            staff_name: profileData?.first_name + ' ' + profileData?.last_name || '',
            staff_position: '',
            existing_staff_signature: '',
            existing_supervisor_signature: ''
        });
        if (accidentStaffSignaturePadRef.current) {
            accidentStaffSignaturePadRef.current.clear();
        }
        if (accidentSupervisorSignaturePadRef.current) {
            accidentSupervisorSignaturePadRef.current.clear();
        }
        setShowCreateAccidentModal(true);
    };

    // Open edit accident report modal
    const handleEditAccidentReport = (report) => {
        setSelectedStudent({ id: report.user_id, name: report.child_name || 'Student' });
        setIsEditingAccidentReport(true);
        setEditingAccidentReportId(report.id);
        setAccidentFormData({
            classroom: report.classroom || '',
            child_name: report.child_name || '',
            incident_date: Moment(report.incident_date).format('YYYY-MM-DD'),
            incident_time: report.incident_time || '',
            location: report.location || '',
            incident_description: (report.incident_description || '').replace(/<[^>]*>/g, ''),
            first_aid: (report.first_aid || '').replace(/<[^>]*>/g, ''),
            parent_contacted: report.parent_contacted === 1,
            parent_contacted_time: report.parent_contacted_time || '',
            follow_up_information: (report.follow_up_information || '').replace(/<[^>]*>/g, ''),
            staff_name: report.staff_name || '',
            staff_position: report.staff_position || '',
            existing_staff_signature: report.staff_signature || '',
            existing_supervisor_signature: report.supervisor_signature || ''
        });
        if (accidentStaffSignaturePadRef.current) {
            accidentStaffSignaturePadRef.current.clear();
        }
        if (accidentSupervisorSignaturePadRef.current) {
            accidentSupervisorSignaturePadRef.current.clear();
        }
        setShowCreateAccidentModal(true);
    };

    // Submit accident report (create or update)
    const submitAccidentReport = async () => {
        // Validation
        if (!accidentFormData.incident_date || !accidentFormData.incident_time || !accidentFormData.location || !accidentFormData.incident_description) {
            Swal.fire({
                icon: 'warning',
                title: 'Required Fields',
                text: 'Please fill in all required fields: Date, Time, Location, and Description.'
            });
            return;
        }

        try {
            const formData = new FormData();
            formData.append('user_id', selectedStudent.id);
            formData.append('incident_date', accidentFormData.incident_date);
            formData.append('incident_time', accidentFormData.incident_time);
            formData.append('location', accidentFormData.location);
            formData.append('incident_description', accidentFormData.incident_description);
            formData.append('first_aid', accidentFormData.first_aid || '');
            formData.append('parent_contacted', accidentFormData.parent_contacted ? 1 : 0);
            formData.append('parent_contacted_time', accidentFormData.parent_contacted_time || '');
            formData.append('follow_up_information', accidentFormData.follow_up_information || '');
            formData.append('staff_name', accidentFormData.staff_name || '');
            formData.append('staff_position', accidentFormData.staff_position || '');

            // If editing, include the report ID
            if (isEditingAccidentReport && editingAccidentReportId) {
                formData.append('id', editingAccidentReportId);
            }

            // Handle staff signature
            if (accidentStaffSignaturePadRef.current && !accidentStaffSignaturePadRef.current.isEmpty()) {
                const signatureDataURL = accidentStaffSignaturePadRef.current.toDataURL('image/png');
                const response = await fetch(signatureDataURL);
                const blob = await response.blob();
                const timestamp = new Date().getTime();
                const fileName = `staff_signature_${timestamp}.png`;
                const file = new File([blob], fileName, { type: 'image/png' });
                const signatureUrl = await handleImageUpload(file, 'signatures/', 'image/png');
                formData.append('staff_signature', signatureUrl);
            } else if (isEditingAccidentReport && accidentFormData.existing_staff_signature) {
                // Keep existing signature if editing and no new signature drawn
                formData.append('staff_signature', accidentFormData.existing_staff_signature);
            }

            // Handle supervisor signature
            if (accidentSupervisorSignaturePadRef.current && !accidentSupervisorSignaturePadRef.current.isEmpty()) {
                const signatureDataURL = accidentSupervisorSignaturePadRef.current.toDataURL('image/png');
                const response = await fetch(signatureDataURL);
                const blob = await response.blob();
                const timestamp = new Date().getTime();
                const fileName = `supervisor_signature_${timestamp}.png`;
                const file = new File([blob], fileName, { type: 'image/png' });
                const signatureUrl = await handleImageUpload(file, 'signatures/', 'image/png');
                formData.append('supervisor_signature', signatureUrl);
            } else if (isEditingAccidentReport && accidentFormData.existing_supervisor_signature) {
                // Keep existing signature if editing and no new signature drawn
                formData.append('supervisor_signature', accidentFormData.existing_supervisor_signature);
            }

            const submitResponse = await apiHandler(ACCIDENT_REPORT_STORE, 'POST', formData);

            if (submitResponse.data?.response?.status === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: isEditingAccidentReport ? 'Accident report updated successfully.' : 'Accident report created successfully.',
                    timer: 2000,
                    showConfirmButton: false
                });

                setShowCreateAccidentModal(false);
                setIsEditingAccidentReport(false);
                setEditingAccidentReportId(null);
                // Reset form
                setAccidentFormData({
                    classroom: '',
                    child_name: '',
                    incident_date: '',
                    incident_time: '',
                    location: '',
                    incident_description: '',
                    first_aid: '',
                    parent_contacted: false,
                    parent_contacted_time: '',
                    follow_up_information: '',
                    staff_name: '',
                    staff_position: '',
                    existing_staff_signature: '',
                    existing_supervisor_signature: ''
                });
                // Reload reports if we're viewing the list
                if (showAccidentReportsModal) {
                    await viewAccidentReports(selectedStudent);
                }
            } else {
                throw new Error(submitResponse.data?.response?.message || `Failed to ${isEditingAccidentReport ? 'update' : 'create'} accident report`);
            }
        } catch (error) {
            console.error(`Error ${isEditingAccidentReport ? 'updating' : 'creating'} accident report:`, error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message || `Failed to ${isEditingAccidentReport ? 'update' : 'create'} accident report. Please try again.`
            });
        }
    };

    // Open create illness report modal
    const handleCreateIllnessReport = (student) => {
        setSelectedStudent(student);
        setIsEditingIllnessReport(false);
        setEditingIllnessReportId(null);
        setIllnessFormData({
            classroom: '',
            student_name: student.name,
            symptoms: '',
            requested_action_parent: '',
            return_date: Moment().format('YYYY-MM-DD'),
            teacher_signature_date: Moment().format('YYYY-MM-DD'),
            existing_teacher_signature: ''
        });
        if (illnessTeacherSignaturePadRef.current) {
            illnessTeacherSignaturePadRef.current.clear();
        }
        setShowCreateIllnessModal(true);
    };

    // Open edit illness report modal
    const handleEditIllnessReport = (report) => {
        setSelectedStudent({ id: report.user_id, name: report.student_name || 'Student' });
        setIsEditingIllnessReport(true);
        setEditingIllnessReportId(report.id);
        setIllnessFormData({
            classroom: report.classroom || '',
            student_name: report.student_name || '',
            symptoms: report.symptoms || '',
            requested_action_parent: report.requested_action_parent || '',
            return_date: Moment(report.return_date).format('YYYY-MM-DD'),
            teacher_signature_date: Moment(report.teacher_signature_date).format('YYYY-MM-DD'),
            existing_teacher_signature: report.teacher_signature || ''
        });
        if (illnessTeacherSignaturePadRef.current) {
            illnessTeacherSignaturePadRef.current.clear();
        }
        setShowCreateIllnessModal(true);
    };

    // Submit illness report (create or update)
    const submitIllnessReport = async () => {
        // Validation
        if (!illnessFormData.symptoms || !illnessFormData.requested_action_parent || !illnessFormData.return_date) {
            Swal.fire({
                icon: 'warning',
                title: 'Required Fields',
                text: 'Please fill in all required fields: Symptoms, Requested Action, and Return Date.'
            });
            return;
        }

        // Only require signature for new reports, not when editing
        if (!isEditingIllnessReport && (!illnessTeacherSignaturePadRef.current || illnessTeacherSignaturePadRef.current.isEmpty())) {
            Swal.fire({
                icon: 'warning',
                title: 'Signature Required',
                text: 'Please provide your teacher signature.'
            });
            return;
        }

        try {
            const formData = new FormData();
            formData.append('user_id', selectedStudent.id);
            formData.append('symptoms', illnessFormData.symptoms);
            formData.append('requested_action_parent', illnessFormData.requested_action_parent);
            formData.append('return_date', illnessFormData.return_date);
            formData.append('teacher_signature_date', illnessFormData.teacher_signature_date);

            // If editing, include the report ID
            if (isEditingIllnessReport && editingIllnessReportId) {
                formData.append('id', editingIllnessReportId);
            }

            // Handle teacher signature (only if provided)
            if (illnessTeacherSignaturePadRef.current && !illnessTeacherSignaturePadRef.current.isEmpty()) {
                const signatureDataURL = illnessTeacherSignaturePadRef.current.toDataURL('image/png');
                const response = await fetch(signatureDataURL);
                const blob = await response.blob();
                const timestamp = new Date().getTime();
                const fileName = `teacher_signature_${timestamp}.png`;
                const file = new File([blob], fileName, { type: 'image/png' });
                const signatureUrl = await handleImageUpload(file, 'signatures/', 'image/png');
                formData.append('teacher_signature', signatureUrl);
            } else if (isEditingIllnessReport && illnessFormData.existing_teacher_signature) {
                // Keep existing signature if editing and no new signature drawn
                formData.append('teacher_signature', illnessFormData.existing_teacher_signature);
            }

            const submitResponse = await apiHandler(ILLNESS_REPORT_STORE, 'POST', formData);

            if (submitResponse.data?.response?.status === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: isEditingIllnessReport ? 'Illness report updated successfully.' : 'Illness report created successfully.',
                    timer: 2000,
                    showConfirmButton: false
                });

                setShowCreateIllnessModal(false);
                setIsEditingIllnessReport(false);
                setEditingIllnessReportId(null);
                // Reset form
                setIllnessFormData({
                    classroom: '',
                    student_name: '',
                    symptoms: '',
                    requested_action_parent: '',
                    return_date: '',
                    teacher_signature_date: '',
                    existing_teacher_signature: ''
                });
                if (illnessTeacherSignaturePadRef.current) {
                    illnessTeacherSignaturePadRef.current.clear();
                }
                // Reload reports if we're viewing the list
                if (showIllnessReportsModal) {
                    await viewIllnessReports(selectedStudent);
                }
            } else {
                throw new Error(submitResponse.data?.response?.message || `Failed to ${isEditingIllnessReport ? 'update' : 'create'} illness report`);
            }
        } catch (error) {
            console.error(`Error ${isEditingIllnessReport ? 'updating' : 'creating'} illness report:`, error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message || `Failed to ${isEditingIllnessReport ? 'update' : 'create'} illness report. Please try again.`
            });
        }
    };

    // Delete accident report
    const deleteAccidentReport = async (reportId) => {
        try {
            const result = await Swal.fire({
                title: 'Are you sure?',
                text: 'Do you want to delete this accident report?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'Cancel'
            });

            if (result.isConfirmed) {
                const formData = new FormData();
                formData.append('id', reportId);

                const response = await apiHandler(ACCIDENT_REPORT_DELETE, 'DELETE', formData);

                if (response.data?.response?.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Deleted!',
                        text: 'Accident report has been deleted.',
                        timer: 2000,
                        showConfirmButton: false
                    });

                    // Reload accident reports
                    await viewAccidentReports(selectedStudent);
                } else {
                    throw new Error(response.data?.response?.message || 'Failed to delete accident report');
                }
            }
        } catch (error) {
            console.error('Error deleting accident report:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message || 'Failed to delete accident report. Please try again.'
            });
        }
    };

    // Delete illness report
    const deleteIllnessReport = async (reportId) => {
        try {
            const result = await Swal.fire({
                title: 'Are you sure?',
                text: 'Do you want to delete this illness report?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'Cancel'
            });

            if (result.isConfirmed) {
                const formData = new FormData();
                formData.append('id', reportId);

                const response = await apiHandler(ILLNESS_REPORT_DELETE, 'DELETE', formData);

                if (response.data?.response?.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Deleted!',
                        text: 'Illness report has been deleted.',
                        timer: 2000,
                        showConfirmButton: false
                    });

                    // Reload illness reports
                    await viewIllnessReports(selectedStudent);
                } else {
                    throw new Error(response.data?.response?.message || 'Failed to delete illness report');
                }
            }
        } catch (error) {
            console.error('Error deleting illness report:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message || 'Failed to delete illness report. Please try again.'
            });
        }
    };

    const viewLunchPlan = async (student) => {
        try {
            const response = await apiHandler(TEACHERS_LUNCH_PLAN_WAIVER_API, 'POST', {
                student_id: student.id
            });
            if (response.data?.response?.status === 200 && response.data?.data?.waiver) {
                // Set the waiver data with combined student and waiver information
                const combinedData = {
                    ...response.data.data.waiver,
                    student: response.data.data.student
                };
                setLunchPlanData(combinedData);
                setSelectedStudent(student);
                setShowLunchPlanModal(true);
            } else {
                Swal.fire({
                    title: 'Info',
                    text: response.data?.response?.message || 'No lunch plan waiver found',
                    icon: 'info',
                    confirmButtonText: 'OK'
                });
            }
        } catch (error) {
            console.error('Error loading lunch plan:', error);
            Swal.fire({
                title: 'Error',
                text: 'Failed to load lunch plan',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    };

    const viewAssignedGames = async (student) => {
        try {
            const response = await apiHandler(TEACHERS_GET_ASSIGNED_GAMES_API, 'POST', {
                student_id: student.id
            });
            if (response.data?.response?.status === 200) {
                setGameData(response.data?.data || {});
                setSelectedStudent(student);
                // Load game names for assignment
                loadGameNames();
                setShowGameModal(true);
            } else {
                Swal.fire({
                    title: 'Info',
                    text: response.data?.response?.message || 'No games assigned',
                    icon: 'info',
                    confirmButtonText: 'OK'
                });
            }
        } catch (error) {
            console.error('Error loading games:', error);
            Swal.fire({
                title: 'Error',
                text: 'Failed to load games',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    };

    const loadGameNames = async () => {
        try {
            const response = await apiHandler(TEACHERS_ASSIGN_GAMES_NAME_API, 'POST', {});
            if (response.data?.response?.status === 200) {
                setGameNames(response.data?.data?.games || []);
            }
        } catch (error) {
            console.error('Error loading game names:', error);
        }
    };

    const assignGame = async () => {
        if (!selectedGame || !selectedStudent) return;
        try {
            const response = await apiHandler(TEACHERS_ASSIGN_GAME_API, 'POST', {
                student_id: selectedStudent.id,
                game_id: selectedGame
            });
            if (response.data?.response?.status === 200) {
                Swal.fire({
                    title: 'Success!',
                    text: 'Game assigned successfully!',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });
                // Reload assigned games
                viewAssignedGames(selectedStudent);
            } else {
                Swal.fire({
                    title: 'Error',
                    text: response.data?.response?.message || 'Failed to assign game',
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            }
        } catch (error) {
            console.error('Error assigning game:', error);
            Swal.fire({
                title: 'Error',
                text: 'Failed to assign game',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    };

    const viewObservation = async (student) => {
        try {
            const response = await apiHandler(TEACHERS_OBSERVATION_API, 'POST', {
                student_id: student.id
            });
            if (response.data?.response?.status === 200) {
                setObservationData(response.data?.data || {});
                setSelectedStudent(student);
                setShowObservationViewModal(true);
            } else {
                Swal.fire({
                    title: 'Info',
                    text: response.data?.response?.message || 'No observation found',
                    icon: 'info',
                    confirmButtonText: 'OK'
                });
            }
        } catch (error) {
            console.error('Error loading observation:', error);
            Swal.fire({
                title: 'Error',
                text: 'Failed to load observation',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    };

    const handleShowEmergencyContacts = async (contacts, student) => {
        setSelectedEmergencyContacts(contacts);
        
        // Fetch parent information
        if (student) {
            try {
                const response = await apiHandler(PROFILE_DETAILS, 'POST', {
                    user_id: student.id
                });
                if (response.data?.response?.status === 200 && response.data.data) {
                    setParentInfoData(response.data.data || {});
                }
            } catch (error) {
                console.error('Error loading parent information:', error);
                setParentInfoData(null);
            }
        }
        
        setShowEmergencyModal(true);
    };

    const handleOpenObservation = async (student) => {
        setSelectedStudent(student);
        setObservationNotes('');
        setObservationText('');

        try {
            // Try to load existing observation data
            const response = await apiHandler(TEACHERS_OBSERVATION_API, 'POST', {
                student_id: student.id,
                report_date: new Date().toISOString().split('T')[0]
            });

            if (response.data?.response?.status === 200 && response.data?.data) {
                // Load existing data into form
                setObservationNotes(response.data.data.notes || '');
                setObservationText(response.data.data.observation || '');
            }
        } catch (error) {
            console.error('Error loading existing observation:', error);
            // Continue with empty form if loading fails
        }

        setShowObservationModal(true);
    };

    const saveObservation = async () => {
        if (!selectedStudent) {
            Swal.fire({
                title: 'Error',
                text: 'No student selected',
                icon: 'error',
                confirmButtonText: 'OK'
            });
            return;
        }

        if (!observationNotes.trim() && !observationText.trim()) {
            Swal.fire({
                title: 'Validation Error',
                text: 'Please enter either notes or observation details',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }

        try {
            const response = await apiHandler(TEACHERS_OBSERVATION_SAVE_API, 'POST', {
                student_id: selectedStudent.id,
                report_date: new Date().toISOString().split('T')[0],
                notes: observationNotes.trim(),
                observation: observationText.trim()
            });

            if (response.data?.response?.status === 200) {
                Swal.fire({
                    title: 'Success!',
                    text: response.data?.data?.message || 'Observation saved successfully!',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });
                setShowObservationModal(false);
                setSelectedStudent(null);
                setObservationNotes('');
                setObservationText('');
            } else {
                throw new Error(response.data?.response?.message || 'Failed to save observation');
            }
        } catch (error) {
            console.error('Error saving observation:', error);
            Swal.fire({
                title: 'Error',
                text: error.message || 'Failed to save observation. Please try again.',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    };

    const renderStudentItem = (student, index) => (
        <div key={student.id} style={{
            background: '#ffffff',
            borderRadius: '10px',
            padding: '14px',
            marginBottom: '10px',
            border: '1px solid #e9ecef',
            boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
            transition: 'all 0.2s ease',
        }}
            onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(80, 180, 152, 0.15)';
                e.currentTarget.style.borderColor = 'var(--bs-primary)';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.08)';
                e.currentTarget.style.borderColor = '#e9ecef';
            }}
        >
            {/* Header Section with Avatar and Info */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                marginBottom: '12px',
                paddingBottom: '12px',
                borderBottom: '1px solid #f1f3f5'
            }}>
                {/* Avatar with Status Indicator */}
                <div style={{ position: 'relative', flexShrink: 0 }}>
                    <img
                        src={student.avatar}
                        alt={student.name}
                        style={{
                            width: '52px',
                            height: '52px',
                            borderRadius: '50%',
                            objectFit: 'cover',
                            border: '2px solid #e9ecef',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.08)'
                        }}
                    />
                    {student.attendance && (
                        <div style={{
                            position: 'absolute',
                            bottom: '0',
                            right: '0',
                            width: '14px',
                            height: '14px',
                            borderRadius: '50%',
                            background: student.attendance === 'present' ? 'var(--bs-primary)' :
                                student.attendance === 'late' ? 'var(--bs-warning)' : 'var(--bs-danger)',
                            border: '2px solid white',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                        }} />
                    )}
                </div>

                {/* Student Info */}
                <div style={{
                    flex: '1',
                    minWidth: 0
                }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        marginBottom: '5px'
                    }}>
                        <h6 className="mb-0 fw-bold" style={{
                            fontSize: '15px',
                            color: '#212529',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}>
                            {student.name}
                        </h6>
                        {student.is_on_leave && (
                            <Badge bg="secondary" style={{
                                fontSize: '10px',
                                padding: '4px 8px',
                                fontWeight: '600'
                            }}>
                                On Leave
                            </Badge>
                        )}
                        {!student.is_on_leave && student.swap_room !== undefined && (
                            <Badge bg={student.swap_room ? 'warning' : 'info'} style={{
                                fontSize: '10px',
                                padding: '4px 8px',
                                fontWeight: '600'
                            }}>
                                {student.swap_room ? 'Swapped' : 'Home'}
                            </Badge>
                        )}
                    </div>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        flexWrap: 'wrap'
                    }}>
                        <small className="text-muted d-flex align-items-center" style={{ fontSize: '12px', fontWeight: '500' }}>
                            <i className="ri-hashtag me-1" style={{ fontSize: '13px' }}></i>
                            {student.rollNumber}
                        </small>
                        {student.attendance_time && (
                            <small className="badge" style={{ fontSize: '10px', padding: '4px 7px', backgroundColor: '#d4edda', color: '#155724', fontWeight: '600' }}>
                                <i className="ri-login-circle-line me-1"></i>
                                {formatTime(student.attendance_time)}
                            </small>
                        )}
                        {student.exit_time && (
                            <small className="badge" style={{ fontSize: '10px', padding: '4px 7px', backgroundColor: '#f8d7da', color: '#721c24', fontWeight: '600' }}>
                                <i className="ri-logout-circle-r-line me-1"></i>
                                {formatTime(student.exit_time)}
                            </small>
                        )}
                    </div>
                </div>
            </div>

            {/* Attendance Buttons Section */}
            {student.is_on_leave ? (
                <div style={{
                    padding: '12px',
                    background: '#f8f9fa',
                    borderRadius: '6px',
                    marginBottom: '12px',
                    textAlign: 'center',
                    border: '1px dashed #6c757d'
                }}>
                    <i className="ri-calendar-close-line" style={{ fontSize: '20px', color: '#6c757d' }}></i>
                    <p className="mb-0 mt-1" style={{ fontSize: '13px', color: '#6c757d', fontWeight: '500' }}>
                        Student is on leave - Attendance not applicable
                    </p>
                </div>
            ) : (
                <div style={{
                    display: 'flex',
                    gap: '8px',
                    marginBottom: '12px'
                }}>
                    <Button
                        variant={student.attendance === 'present' ? 'primary' : 'outline-secondary'}
                        size="sm"
                        disabled={!canEditAttendance()}
                        onClick={(e) => {
                            e.currentTarget.blur();
                            if (canEditAttendance()) {
                                updateAttendance(student.id, 'present');
                            }
                        }}
                        className="flex-fill d-flex align-items-center justify-content-center gap-1"
                        style={{
                            minWidth: '85px',
                            fontSize: '13px',
                            fontWeight: '600',
                            padding: '8px 12px',
                            borderRadius: '6px'
                        }}
                    >
                        <i className="ri-checkbox-circle-line" style={{ fontSize: '17px' }}></i>
                        Present
                    </Button>

                    <Button
                        variant={student.attendance === 'late' ? 'warning' : 'outline-secondary'}
                        size="sm"
                        disabled={!canEditAttendance()}
                        onClick={(e) => {
                            e.currentTarget.blur();
                            if (canEditAttendance()) {
                                updateAttendance(student.id, 'late');
                            }
                        }}
                        className="flex-fill d-flex align-items-center justify-content-center gap-1"
                        style={{
                            minWidth: '75px',
                            fontSize: '13px',
                            fontWeight: '600',
                            padding: '8px 12px',
                            borderRadius: '6px',
                            color: student.attendance === 'late' ? 'white' : undefined
                        }}
                    >
                        <i className="ri-time-line" style={{ fontSize: '17px' }}></i>
                        Late
                    </Button>

                    <Button
                        variant={student.attendance === 'absent' ? 'danger' : 'outline-secondary'}
                        size="sm"
                        disabled={!canEditAttendance()}
                        onClick={(e) => {
                            e.currentTarget.blur();
                            if (canEditAttendance()) {
                                updateAttendance(student.id, 'absent');
                            }
                        }}
                        className="flex-fill d-flex align-items-center justify-content-center gap-1"
                        style={{
                            minWidth: '80px',
                            fontSize: '13px',
                            fontWeight: '600',
                            padding: '8px 12px',
                            borderRadius: '6px'
                        }}
                    >
                        <i className="ri-close-circle-line" style={{ fontSize: '17px' }}></i>
                        Absent
                    </Button>
                </div>
            )}

            {/* Quick Actions Section */}
            <div style={{
                display: 'flex',
                gap: '6px',
                flexWrap: 'wrap'
            }}>
                {/* <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={(e) => {
                        e.currentTarget.blur();
                        handleShowEmergencyContacts(student.emergency_contacts || [], student);
                    }}
                    className="d-flex align-items-center gap-1"
                    style={{ fontSize: '10px', padding: '5px 8px' }}
                >
                    <i className="ri-alarm-warning-line"></i>
                    Emergency
                </Button> */}

                <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={(e) => {
                        e.currentTarget.blur();
                        viewMedication(student);
                    }}
                    className="d-flex align-items-center gap-1"
                    style={{ fontSize: '10px', padding: '5px 8px' }}
                >
                    <i className="ri-medicine-bottle-line"></i>
                    Medication
                </Button>

                <Button
                    variant="outline-warning"
                    size="sm"
                    onClick={(e) => {
                        e.currentTarget.blur();
                        viewNonMedication(student);
                    }}
                    className="d-flex align-items-center gap-1"
                    style={{ fontSize: '10px', padding: '5px 8px' }}
                >
                    <i className="ri-heart-pulse-line"></i>
                    Non-Med
                </Button>

                {student.allergy_report_id && (
                    <Button
                        variant="outline-info"
                        size="sm"
                        onClick={(e) => {
                            e.currentTarget.blur();
                            viewAllergy(student);
                        }}
                        className="d-flex align-items-center gap-1"
                        style={{ fontSize: '10px', padding: '5px 8px' }}
                    >
                        <i className="ri-alert-line"></i>
                        Allergy
                    </Button>
                )}

                {student.lunch_plan_waiver_id && (
                    <Button
                        variant="outline-success"
                        size="sm"
                        onClick={(e) => {
                            e.currentTarget.blur();
                            viewLunchPlan(student);
                        }}
                        className="d-flex align-items-center gap-1"
                        style={{ fontSize: '10px', padding: '5px 8px' }}
                    >
                        <i className="ri-restaurant-line"></i>
                        Lunch
                    </Button>
                )}

                {student.peanut_policy_id && (
                    <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={(e) => {
                            e.currentTarget.blur();
                            viewPeanutPolicy(student);
                        }}
                        className="d-flex align-items-center gap-1"
                        style={{ fontSize: '10px', padding: '5px 8px' }}
                    >
                        <i className="ri-forbid-line"></i>
                        Peanut
                    </Button>
                )}

                <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={(e) => {
                        e.currentTarget.blur();
                        viewAccidentReports(student);
                    }}
                    className="d-flex align-items-center gap-1"
                    style={{ fontSize: '10px', padding: '5px 8px' }}
                    title="View Accident Reports"
                >
                    <i className="ri-eye-line"></i>
                    Accident
                </Button>

                <Button
                    variant="danger"
                    size="sm"
                    onClick={(e) => {
                        e.currentTarget.blur();
                        handleCreateAccidentReport(student);
                    }}
                    className="d-flex align-items-center gap-1"
                    style={{ fontSize: '10px', padding: '5px 8px' }}
                    title="Create Accident Report"
                >
                    <i className="ri-add-line"></i>
                    Accident
                </Button>

                <Button
                    variant="outline-warning"
                    size="sm"
                    onClick={(e) => {
                        e.currentTarget.blur();
                        viewIllnessReports(student);
                    }}
                    className="d-flex align-items-center gap-1"
                    style={{ fontSize: '10px', padding: '5px 8px' }}
                    title="View Illness Reports"
                >
                    <i className="ri-eye-line"></i>
                    Illness
                </Button>

                <Button
                    variant="warning"
                    size="sm"
                    onClick={(e) => {
                        e.currentTarget.blur();
                        handleCreateIllnessReport(student);
                    }}
                    className="d-flex align-items-center gap-1"
                    style={{ fontSize: '10px', padding: '5px 8px' }}
                    title="Create Illness Report"
                >
                    <i className="ri-add-line"></i>
                    Illness
                </Button>

                <Button
                    variant="outline-info"
                    size="sm"
                    onClick={(e) => {
                        e.currentTarget.blur();
                        viewAssignedGames(student);
                    }}
                    className="d-flex align-items-center gap-1"
                    style={{ fontSize: '10px', padding: '5px 8px' }}
                >
                    <i className="ri-gamepad-line"></i>
                    Game
                </Button>

                <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={(e) => {
                        e.currentTarget.blur();
                        isToday(selectedDate) ? handleOpenObservation(student) : viewObservation(student);
                    }}
                    className="d-flex align-items-center gap-1"
                    style={{ fontSize: '10px', padding: '5px 8px' }}
                >
                    <i className="ri-file-edit-line"></i>
                    Observation
                </Button>

                <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={(e) => {
                        e.currentTarget.blur();
                        viewRegistration(student);
                    }}
                    className="d-flex align-items-center gap-1"
                    style={{ fontSize: '10px', padding: '5px 8px' }}
                    title="View Registration Form"
                >
                    <i className="ri-file-user-line"></i>
                    Registration
                </Button>

                <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={(e) => {
                        e.currentTarget.blur();
                        viewDailyReport(student);
                    }}
                    className="d-flex align-items-center gap-1"
                    style={{ fontSize: '10px', padding: '5px 8px' }}
                    title="View Daily Report"
                >
                    <i className="ri-file-list-3-line"></i>
                    View Report
                </Button>

                {isToday(selectedDate) && (
                    <Button
                        variant="outline-success"
                        size="sm"
                        onClick={(e) => {
                            e.currentTarget.blur();
                            handleAddReport(student);
                        }}
                        className="d-flex align-items-center gap-1"
                        style={{ fontSize: '10px', padding: '5px 8px' }}
                        title="Add Daily Report"
                    >
                        <i className="ri-file-add-line"></i>
                        Add Report
                    </Button>
                )}

                {student.dailyReport && isToday(student.dailyReport.report_date) && (
                    <Button
                        variant="outline-warning"
                        size="sm"
                        onClick={(e) => {
                            e.currentTarget.blur();
                            setSelectedStudent(student);
                            // Set the form data from existing report
                            setDailyReportFormData({
                                feeling_id: student.dailyReport.daily_report_fealings?.[0]?.fealing_id || 1,
                                learned: student.dailyReport.learned || '',
                                comments: student.dailyReport.comments || '',
                                diapers: student.dailyReport.daily_report_diapers?.map(d => ({
                                    diaper_time: d.diaper_time,
                                    diaper_check: d.diaper_check
                                })) || [],
                                meals: student.dailyReport.daily_report_meals?.map(m => ({
                                    meal_time: m.meal_time,
                                    meal_type_id: m.meal_type_id,
                                    meal_amount: m.meal_amount
                                })) || [],
                                sleeps: student.dailyReport.daily_report_sleeps?.map(s => ({
                                    start_time: s.start_time,
                                    end_time: s.end_time
                                })) || [],
                                bring_diapers: student.dailyReport.daily_report_bring_mores?.some(item => item.things === 1) || false,
                                bring_wipes: student.dailyReport.daily_report_bring_mores?.some(item => item.things === 2) || false,
                                bring_ointment: student.dailyReport.daily_report_bring_mores?.some(item => item.things === 3) || false,
                                bring_clothes: student.dailyReport.daily_report_bring_mores?.some(item => item.things === 4) || false,
                                bring_blanket: student.dailyReport.daily_report_bring_mores?.some(item => item.things === 5) || false,
                                bring_other: student.dailyReport.daily_report_bring_mores?.find(item => item.things === 6)?.other || ''
                            });
                            setIsEditingDailyReport(true);
                            setShowDailyReportFormModal(true);
                        }}
                        className="d-flex align-items-center gap-1"
                        style={{ fontSize: '10px', padding: '5px 8px' }}
                        title="Edit Today's Daily Report"
                    >
                        <i className="ri-file-edit-line"></i>
                        Edit Report
                    </Button>
                )}

                {isToday(selectedDate) && !student.is_on_leave && (
                    <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={(e) => {
                            e.currentTarget.blur();
                            handleSetExitTime(student);
                        }}
                        className="d-flex align-items-center gap-1"
                        style={{ fontSize: '10px', padding: '5px 8px' }}
                    >
                        <i className="ri-logout-circle-r-line"></i>
                        Exit
                    </Button>
                )}
            </div>
        </div>
    );

    const renderStudentsList = () => (
        <Card>
            <Card.Header className="py-3">
                <h5 className="card-title mb-0 fw-bold">Students ({filteredStudents.length})</h5>
            </Card.Header>
            <Card.Body className="p-2">
                {/* Search Bar */}
                <div className="mb-2">
                    <div className="d-flex align-items-center bg-light p-2 rounded border">
                        <i className="ri-search-line text-muted me-2" style={{ fontSize: '18px' }}></i>
                        <input
                            type="text"
                            placeholder="Search students..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            className="form-control form-control-sm border-0 bg-transparent shadow-none"
                            style={{ fontSize: '13px' }}
                        />
                        {searchQuery && (
                            <button
                                onClick={() => setSearchQuery('')}
                                className="btn btn-sm p-1 border-0"
                                style={{ background: 'transparent' }}
                            >
                                <i className="ri-close-line text-muted" style={{ fontSize: '18px' }}></i>
                            </button>
                        )}
                    </div>
                </div>

                {/* Students List */}
                {!selectedRoom ? (
                    <div className="text-center py-5 text-muted">
                        <i className="material-symbols-outlined" style={{ fontSize: '48px', opacity: 0.3 }}>
                            meeting_room
                        </i>
                        <p className="mt-2 mb-0" style={{ fontSize: '13px' }}>
                            Please select a room to view students
                        </p>
                    </div>
                ) : filteredStudents.length === 0 ? (
                    <div className="text-center py-5 text-muted">
                        <i className="material-symbols-outlined" style={{ fontSize: '48px', opacity: 0.3 }}>
                            group_off
                        </i>
                        <p className="mt-2 mb-0" style={{ fontSize: '13px' }}>
                            No students found for this room
                        </p>
                    </div>
                ) : (
                    <div>
                        {filteredStudents.map((student, index) => renderStudentItem(student, index))}
                    </div>
                )}
            </Card.Body>
        </Card>
    );

    const renderSaveButton = () => (
        <Card className="mt-2">
            <Card.Body className="p-2">
                <Button
                    onClick={saveAttendance}
                    disabled={loading || students.length === 0 || !canEditAttendance()}
                    variant="primary"
                    className="w-100 py-2"
                    style={{
                        fontSize: '14px',
                        fontWeight: '600',
                        boxShadow: (loading || students.length === 0 || !canEditAttendance()) ? 'none' : '0 2px 8px rgba(80, 180, 152, 0.3)'
                    }}
                    title={!canEditAttendance() ? 'This attendance is view-only and cannot be modified' : ''}
                >
                    {loading ? (
                        <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    ) : (
                        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                            <i className="material-symbols-outlined" style={{ fontSize: '20px' }}>
                                save
                            </i>
                            Save Attendance
                        </span>
                    )}
                </Button>
            </Card.Body>
        </Card>
    );

    const renderBulkModal = () => (
        <Modal show={showBulkModal} onHide={() => setShowBulkModal(false)} centered style={{ marginTop: 10 }}>
            <Modal.Header closeButton style={{ borderBottom: '1px solid #e9ecef', padding: '16px 50px 16px 20px' }}>
                <Modal.Title style={{ fontSize: '17px', fontWeight: '600', color: '#212529', lineHeight: '1.4', width: '100%', maxWidth: 'calc(100% - 40px)' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
                        <i className="material-symbols-outlined" style={{ fontSize: '20px', color: '#50b498', flexShrink: 0 }}>
                            fact_check
                        </i>
                        <span style={{ wordBreak: 'break-word', flex: '1' }}>Bulk Actions</span>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{
                padding: '20px'
            }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
                    <button
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            padding: '16px',
                            background: 'transparent',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            transition: 'background 0.2s ease',
                            width: '100%'
                        }}
                        onClick={() => {
                            bulkUpdateAttendance('present');
                            setShowBulkModal(false);
                        }}
                        onMouseEnter={(e) => e.target.style.background = '#f8f9fa'}
                        onMouseLeave={(e) => e.target.style.background = 'transparent'}
                    >
                        <i className="material-symbols-outlined" style={{
                            fontSize: '20px',
                            color: '#28a745'
                        }}>
                            check_circle
                        </i>
                        <span style={{
                            fontSize: '14px',
                            color: '#212529',
                            flex: 1,
                            textAlign: 'left'
                        }}>
                            Mark All Present
                        </span>
                    </button>
                    <button
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            padding: '16px',
                            background: 'transparent',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            transition: 'background 0.2s ease',
                            width: '100%'
                        }}
                        onClick={() => {
                            bulkUpdateAttendance('absent');
                            setShowBulkModal(false);
                        }}
                        onMouseEnter={(e) => e.target.style.background = '#f8f9fa'}
                        onMouseLeave={(e) => e.target.style.background = 'transparent'}
                    >
                        <i className="material-symbols-outlined" style={{
                            fontSize: '20px',
                            color: '#dc3545'
                        }}>
                            cancel
                        </i>
                        <span style={{
                            fontSize: '14px',
                            color: '#212529',
                            flex: 1,
                            textAlign: 'left'
                        }}>
                            Mark All Absent
                        </span>
                    </button>
                    <button
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            padding: '16px',
                            background: 'transparent',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            transition: 'background 0.2s ease',
                            width: '100%'
                        }}
                        onClick={() => {
                            bulkUpdateAttendance('late');
                            setShowBulkModal(false);
                        }}
                        onMouseEnter={(e) => e.target.style.background = '#f8f9fa'}
                        onMouseLeave={(e) => e.target.style.background = 'transparent'}
                    >
                        <i className="material-symbols-outlined" style={{
                            fontSize: '20px',
                            color: '#fd7e14'
                        }}>
                            schedule
                        </i>
                        <span style={{
                            fontSize: '14px',
                            color: '#212529',
                            flex: 1,
                            textAlign: 'left'
                        }}>
                            Mark All Late
                        </span>
                    </button>
                    <hr style={{ margin: '8px 0', borderColor: '#e9ecef' }} />
                    <button
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            padding: '16px',
                            background: 'transparent',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            transition: 'background 0.2s ease',
                            width: '100%'
                        }}
                        onClick={() => setShowBulkModal(false)}
                        onMouseEnter={(e) => e.target.style.background = '#f8f9fa'}
                        onMouseLeave={(e) => e.target.style.background = 'transparent'}
                    >
                        <i className="material-symbols-outlined" style={{
                            fontSize: '20px',
                            color: '#6c757d'
                        }}>
                            close
                        </i>
                        <span style={{
                            fontSize: '14px',
                            color: '#212529',
                            flex: 1,
                            textAlign: 'left'
                        }}>
                            Cancel
                        </span>
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );

    const renderEmergencyContactsModal = () => (
        <Modal show={showEmergencyModal} onHide={() => {
            setShowEmergencyModal(false);
            setParentInfoData(null);
        }} centered size="xl" style={{ marginTop: '30px', marginBottom: '30px' }}>
            <Modal.Header closeButton style={{
                background: 'white',
                borderBottom: '1px solid #e9ecef',
                padding: '20px 25px',
                borderRadius: '0'
            }}>
                <Modal.Title style={{ 
                    fontSize: '18px', 
                    fontWeight: '700', 
                    color: '#212529', 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '12px',
                    letterSpacing: '0.3px'
                }}>
                    <div style={{
                        width: '42px',
                        height: '42px',
                        background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 2px 8px rgba(220, 53, 69, 0.3)'
                    }}>
                        <i className="ri-alarm-warning-fill" style={{ fontSize: '22px', color: 'white' }}></i>
                    </div>
                    <span>Emergency Contacts & Parent Information</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '0', background: '#f0f2f5', maxHeight: '75vh', overflowY: 'auto' }}>
                {/* Student Profile Section */}
                {parentInfoData && parentInfoData.user && (
                    <div style={{
                        padding: '25px',
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        borderBottom: '1px solid rgba(255,255,255,0.1)'
                    }}>
                        <div style={{
                            background: 'rgba(255, 255, 255, 0.95)',
                            padding: '20px',
                            borderRadius: '16px',
                            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '18px',
                            position: 'relative',
                            overflow: 'hidden'
                        }}>
                            <div style={{
                                position: 'absolute',
                                top: '-20px',
                                right: '-20px',
                                width: '120px',
                                height: '120px',
                                background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, transparent 100%)',
                                borderRadius: '50%'
                            }}></div>
                            <div style={{
                                position: 'absolute',
                                bottom: '-30px',
                                left: '40%',
                                width: '100px',
                                height: '100px',
                                background: 'linear-gradient(135deg, rgba(118, 75, 162, 0.08) 0%, transparent 100%)',
                                borderRadius: '50%'
                            }}></div>
                            
                            <div style={{
                                width: '70px',
                                height: '70px',
                                minWidth: '70px',
                                borderRadius: '50%',
                                overflow: 'hidden',
                                border: '4px solid #667eea',
                                boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
                                position: 'relative',
                                zIndex: 1
                            }}>
                                <img
                                    src={parentInfoData.user.user_setting?.photo || "https://uzone360live.s3.amazonaws.com/noimage.png"}
                                    alt={`${parentInfoData.user.first_name} ${parentInfoData.user.last_name}`}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover'
                                    }}
                                />
                            </div>
                            <div style={{ flex: 1, position: 'relative', zIndex: 1 }}>
                                <div style={{
                                    fontSize: '11px',
                                    fontWeight: '600',
                                    color: '#667eea',
                                    textTransform: 'uppercase',
                                    letterSpacing: '1px',
                                    marginBottom: '4px'
                                }}>
                                    Student Information
                                </div>
                                <div style={{ fontSize: '20px', fontWeight: '700', color: '#212529', marginBottom: '6px', letterSpacing: '0.3px' }}>
                                    {parentInfoData.user.first_name} {parentInfoData.user.last_name}
                                </div>
                                <div style={{
                                    fontSize: '13px',
                                    color: '#6c757d',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    background: '#f8f9fa',
                                    padding: '6px 12px',
                                    borderRadius: '20px',
                                    width: 'fit-content',
                                    border: '1px solid #e9ecef'
                                }}>
                                    <i className="ri-mail-line"></i>
                                    <span>{parentInfoData.user.email}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Emergency Contacts Section */}
                <div style={{ 
                    padding: '25px',
                    background: 'linear-gradient(180deg, #fff5f5 0%, #f0f2f5 100%)',
                    borderBottom: '1px solid #e0e0e0'
                }}>
                    <div style={{
                        fontSize: '16px',
                        fontWeight: '700',
                        color: '#dc3545',
                        marginBottom: '18px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        paddingBottom: '10px',
                        borderBottom: '3px solid #dc3545',
                        width: 'fit-content'
                    }}>
                        <i className="ri-alarm-warning-line" style={{ fontSize: '20px' }}></i>
                        <span>Emergency Contacts</span>
                    </div>
                    {selectedEmergencyContacts.length > 0 ? (
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px' }}>
                            {selectedEmergencyContacts.map((contact, index) => (
                                <div key={index} style={{
                                    padding: '18px',
                                    background: 'linear-gradient(135deg, #ffffff 0%, #fafafa 100%)',
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 12px rgba(220, 53, 69, 0.15)',
                                    border: '1px solid rgba(220, 53, 69, 0.1)',
                                    transition: 'all 0.3s ease',
                                    position: 'relative',
                                    overflow: 'hidden'
                                }}>
                                    <div style={{
                                        position: 'absolute',
                                        top: 0,
                                        right: 0,
                                        width: '60px',
                                        height: '60px',
                                        background: 'linear-gradient(135deg, rgba(220, 53, 69, 0.1) 0%, transparent 100%)',
                                        borderRadius: '0 0 0 100%'
                                    }}></div>
                                    
                                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px', marginBottom: '16px', position: 'relative' }}>
                                        <div style={{
                                            width: '56px',
                                            height: '56px',
                                            minWidth: '56px',
                                            borderRadius: '50%',
                                            background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            boxShadow: '0 4px 12px rgba(220, 53, 69, 0.4)',
                                            border: '3px solid white'
                                        }}>
                                            <i className="ri-user-heart-fill" style={{ fontSize: '26px', color: 'white' }}></i>
                                        </div>
                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            <div style={{ 
                                                fontSize: '16px', 
                                                fontWeight: '700', 
                                                color: '#212529', 
                                                marginBottom: '4px',
                                                lineHeight: '1.3'
                                            }}>
                                                {contact.name}
                                            </div>
                                            <div style={{
                                                fontSize: '13px',
                                                color: '#6c757d',
                                                fontWeight: '500',
                                                display: 'inline-block',
                                                padding: '3px 10px',
                                                background: 'rgba(220, 53, 69, 0.08)',
                                                borderRadius: '12px',
                                                border: '1px solid rgba(220, 53, 69, 0.15)'
                                            }}>
                                                <i className="ri-heart-line" style={{ fontSize: '11px', marginRight: '4px' }}></i>
                                                {contact.relationship}
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px',
                                            padding: '12px 14px',
                                            background: 'linear-gradient(135deg, #fff 0%, #f8f9fa 100%)',
                                            borderRadius: '12px',
                                            border: '1px solid #e9ecef',
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.04)'
                                        }}>
                                            <div style={{
                                                width: '36px',
                                                height: '36px',
                                                minWidth: '36px',
                                                borderRadius: '50%',
                                                background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                boxShadow: '0 2px 8px rgba(40, 167, 69, 0.3)'
                                            }}>
                                                <i className="ri-phone-fill" style={{ fontSize: '16px', color: 'white' }}></i>
                                            </div>
                                            <a href={`tel:${contact.phone}`} style={{
                                                fontSize: '15px',
                                                fontWeight: '700',
                                                color: '#212529',
                                                textDecoration: 'none',
                                                letterSpacing: '0.3px',
                                                flex: 1
                                            }}>
                                                {contact.phone}
                                            </a>
                                            <i className="ri-external-link-line" style={{ fontSize: '16px', color: '#6c757d' }}></i>
                                        </div>

                                        {contact.email && (
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px',
                                                padding: '12px 14px',
                                                background: 'linear-gradient(135deg, #fff 0%, #f8f9fa 100%)',
                                                borderRadius: '12px',
                                                border: '1px solid #e9ecef',
                                                boxShadow: '0 2px 4px rgba(0,0,0,0.04)'
                                            }}>
                                                <div style={{
                                                    width: '36px',
                                                    height: '36px',
                                                    minWidth: '36px',
                                                    borderRadius: '50%',
                                                    background: 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    boxShadow: '0 2px 8px rgba(0, 123, 255, 0.3)'
                                                }}>
                                                    <i className="ri-mail-fill" style={{ fontSize: '16px', color: 'white' }}></i>
                                                </div>
                                                <a href={`mailto:${contact.email}`} style={{
                                                    fontSize: '14px',
                                                    fontWeight: '600',
                                                    color: '#212529',
                                                    textDecoration: 'none',
                                                    flex: 1,
                                                    wordBreak: 'break-all'
                                                }}>
                                                    {contact.email}
                                                </a>
                                                <i className="ri-external-link-line" style={{ fontSize: '16px', color: '#6c757d' }}></i>
                                            </div>
                                        )}

                                        {contact.address && (
                                            <div style={{
                                                padding: '12px 14px',
                                                background: 'linear-gradient(135deg, #fff 0%, #f8f9fa 100%)',
                                                borderRadius: '12px',
                                                border: '1px solid #e9ecef',
                                                boxShadow: '0 2px 4px rgba(0,0,0,0.04)'
                                            }}>
                                                <div style={{
                                                    display: 'flex',
                                                    alignItems: 'flex-start',
                                                    gap: '10px'
                                                }}>
                                                    <div style={{
                                                        width: '36px',
                                                        height: '36px',
                                                        minWidth: '36px',
                                                        borderRadius: '50%',
                                                        background: 'linear-gradient(135deg, #ffc107 0%, #ff9800 100%)',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        boxShadow: '0 2px 8px rgba(255, 193, 7, 0.3)'
                                                    }}>
                                                        <i className="ri-map-pin-fill" style={{ fontSize: '16px', color: 'white' }}></i>
                                                    </div>
                                                    <div style={{
                                                        fontSize: '14px',
                                                        fontWeight: '500',
                                                        color: '#495057',
                                                        flex: 1,
                                                        lineHeight: '1.5'
                                                    }}>
                                                        {contact.address}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {contact.work_phone && (
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px',
                                                padding: '12px 14px',
                                                background: 'linear-gradient(135deg, #fff 0%, #f8f9fa 100%)',
                                                borderRadius: '12px',
                                                border: '1px solid #e9ecef',
                                                boxShadow: '0 2px 4px rgba(0,0,0,0.04)'
                                            }}>
                                                <div style={{
                                                    width: '36px',
                                                    height: '36px',
                                                    minWidth: '36px',
                                                    borderRadius: '50%',
                                                    background: 'linear-gradient(135deg, #6c757d 0%, #495057 100%)',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    boxShadow: '0 2px 8px rgba(108, 117, 125, 0.3)'
                                                }}>
                                                    <i className="ri-building-fill" style={{ fontSize: '16px', color: 'white' }}></i>
                                                </div>
                                                <div style={{ flex: 1 }}>
                                                    <div style={{ fontSize: '10px', color: '#6c757d', marginBottom: '2px', textTransform: 'uppercase', fontWeight: '600' }}>
                                                        Work Phone
                                                    </div>
                                                    <a href={`tel:${contact.work_phone}`} style={{
                                                        fontSize: '14px',
                                                        fontWeight: '700',
                                                        color: '#212529',
                                                        textDecoration: 'none'
                                                    }}>
                                                        {contact.work_phone}
                                                    </a>
                                                </div>
                                                <i className="ri-external-link-line" style={{ fontSize: '16px', color: '#6c757d' }}></i>
                                            </div>
                                        )}

                                        {contact.notes && (
                                            <div style={{
                                                padding: '12px 14px',
                                                background: 'linear-gradient(135deg, #fff3cd 0%, #fff8e1 100%)',
                                                borderRadius: '12px',
                                                border: '1px solid #ffc107',
                                                boxShadow: '0 2px 4px rgba(255, 193, 7, 0.1)'
                                            }}>
                                                <div style={{
                                                    display: 'flex',
                                                    alignItems: 'flex-start',
                                                    gap: '10px'
                                                }}>
                                                    <i className="ri-information-fill" style={{ fontSize: '18px', color: '#ff9800', marginTop: '2px' }}></i>
                                                    <div>
                                                        <div style={{ fontSize: '10px', color: '#856404', marginBottom: '4px', textTransform: 'uppercase', fontWeight: '700', letterSpacing: '0.5px' }}>
                                                            Notes
                                                        </div>
                                                        <div style={{
                                                            fontSize: '13px',
                                                            fontWeight: '500',
                                                            color: '#856404',
                                                            lineHeight: '1.5'
                                                        }}>
                                                            {contact.notes}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div style={{
                            textAlign: 'center',
                            padding: '40px 20px',
                            color: '#6c757d',
                            fontSize: '14px',
                            background: 'white',
                            borderRadius: '16px',
                            border: '2px dashed #dee2e6'
                        }}>
                            <i className="ri-contacts-line" style={{ fontSize: '48px', color: '#dee2e6', marginBottom: '12px', display: 'block' }}></i>
                            <div style={{ fontWeight: '600' }}>No emergency contacts available</div>
                            <div style={{ fontSize: '12px', color: '#adb5bd', marginTop: '4px' }}>Add emergency contacts to ensure quick access in case of emergencies</div>
                        </div>
                    )}
                </div>

                {/* Parent Information Section */}
                {parentInfoData && parentInfoData.user && (
                    <div style={{ padding: '25px', background: '#f0f2f5' }}>
                        <div style={{
                            fontSize: '16px',
                            fontWeight: '700',
                            color: '#495057',
                            marginBottom: '18px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            paddingBottom: '10px',
                            borderBottom: '3px solid #6c63ff',
                            width: 'fit-content'
                        }}>
                            <i className="ri-parent-line" style={{ fontSize: '20px' }}></i>
                            <span>Parent & Guardian Information</span>
                        </div>

                        {parentInfoData.user.user_setting && (
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '16px' }}>
                                {/* Father's Information Card */}
                                <div style={{
                                    background: 'linear-gradient(135deg, #fff 0%, #f8f9ff 100%)',
                                    padding: '20px',
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 12px rgba(102, 126, 234, 0.12)',
                                    border: '1px solid rgba(102, 126, 234, 0.15)',
                                    position: 'relative',
                                    overflow: 'hidden'
                                }}>
                                    <div style={{
                                        position: 'absolute',
                                        top: 0,
                                        right: 0,
                                        width: '80px',
                                        height: '80px',
                                        background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, transparent 100%)',
                                        borderRadius: '0 0 0 100%'
                                    }}></div>
                                    
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '12px',
                                        marginBottom: '18px',
                                        paddingBottom: '14px',
                                        borderBottom: '2px solid rgba(102, 126, 234, 0.2)',
                                        position: 'relative'
                                    }}>
                                        <div style={{
                                            width: '40px',
                                            height: '40px',
                                            borderRadius: '50%',
                                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            boxShadow: '0 4px 8px rgba(102, 126, 234, 0.3)'
                                        }}>
                                            <i className="ri-user-3-fill" style={{ fontSize: '20px', color: 'white' }}></i>
                                        </div>
                                        <span style={{
                                            fontSize: '16px',
                                            fontWeight: '700',
                                            color: '#667eea',
                                            letterSpacing: '0.3px'
                                        }}>
                                            Father's Information
                                        </span>
                                    </div>
                                    
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                                        <div>
                                            <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>
                                                Full Name
                                            </div>
                                            <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <i className="ri-user-line" style={{ color: '#667eea' }}></i>
                                                {parentInfoData.user.user_setting.fathers_name || 'N/A'}
                                            </div>
                                        </div>
                                        <div>
                                            <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>
                                                Phone Number
                                            </div>
                                            <a href={`tel:${parentInfoData.user.user_setting.fathers_phone || ''}`} style={{
                                                fontSize: '14px',
                                                fontWeight: '700',
                                                color: '#212529',
                                                textDecoration: 'none',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                padding: '8px 12px',
                                                background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                                                borderRadius: '8px',
                                                border: '1px solid #dee2e6',
                                                width: 'fit-content'
                                            }}>
                                                <i className="ri-phone-fill" style={{ color: '#28a745' }}></i>
                                                {parentInfoData.user.user_setting.fathers_phone || 'N/A'}
                                            </a>
                                        </div>
                                        <div>
                                            <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>
                                                Email Address
                                            </div>
                                            <div style={{ fontSize: '13px', fontWeight: '500', color: '#495057', wordBreak: 'break-all', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <i className="ri-mail-line" style={{ color: '#667eea' }}></i>
                                                {parentInfoData.user.user_setting.fathers_email || 'N/A'}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Mother's Information Card */}
                                <div style={{
                                    background: 'linear-gradient(135deg, #fff 0%, #fff5f8 100%)',
                                    padding: '20px',
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 12px rgba(233, 30, 99, 0.12)',
                                    border: '1px solid rgba(233, 30, 99, 0.15)',
                                    position: 'relative',
                                    overflow: 'hidden'
                                }}>
                                    <div style={{
                                        position: 'absolute',
                                        top: 0,
                                        right: 0,
                                        width: '80px',
                                        height: '80px',
                                        background: 'linear-gradient(135deg, rgba(233, 30, 99, 0.08) 0%, transparent 100%)',
                                        borderRadius: '0 0 0 100%'
                                    }}></div>
                                    
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '12px',
                                        marginBottom: '18px',
                                        paddingBottom: '14px',
                                        borderBottom: '2px solid rgba(233, 30, 99, 0.2)',
                                        position: 'relative'
                                    }}>
                                        <div style={{
                                            width: '40px',
                                            height: '40px',
                                            borderRadius: '50%',
                                            background: 'linear-gradient(135deg, #e91e63 0%, #ad1457 100%)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            boxShadow: '0 4px 8px rgba(233, 30, 99, 0.3)'
                                        }}>
                                            <i className="ri-user-3-fill" style={{ fontSize: '20px', color: 'white' }}></i>
                                        </div>
                                        <span style={{
                                            fontSize: '16px',
                                            fontWeight: '700',
                                            color: '#e91e63',
                                            letterSpacing: '0.3px'
                                        }}>
                                            Mother's Information
                                        </span>
                                    </div>
                                    
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                                        <div>
                                            <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>
                                                Full Name
                                            </div>
                                            <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <i className="ri-user-line" style={{ color: '#e91e63' }}></i>
                                                {parentInfoData.user.user_setting.mothers_name || 'N/A'}
                                            </div>
                                        </div>
                                        <div>
                                            <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>
                                                Phone Number
                                            </div>
                                            <a href={`tel:${parentInfoData.user.user_setting.mothers_phone || ''}`} style={{
                                                fontSize: '14px',
                                                fontWeight: '700',
                                                color: '#212529',
                                                textDecoration: 'none',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                padding: '8px 12px',
                                                background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                                                borderRadius: '8px',
                                                border: '1px solid #dee2e6',
                                                width: 'fit-content'
                                            }}>
                                                <i className="ri-phone-fill" style={{ color: '#28a745' }}></i>
                                                {parentInfoData.user.user_setting.mothers_phone || 'N/A'}
                                            </a>
                                        </div>
                                        <div>
                                            <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>
                                                Email Address
                                            </div>
                                            <div style={{ fontSize: '13px', fontWeight: '500', color: '#495057', wordBreak: 'break-all', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <i className="ri-mail-line" style={{ color: '#e91e63' }}></i>
                                                {parentInfoData.user.user_setting.mothers_email || 'N/A'}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Guardian's Information Card */}
                                {(parentInfoData.user.user_setting.guardian_name ||
                                    parentInfoData.user.user_setting.guardian_phone ||
                                    parentInfoData.user.user_setting.guardian_email) && (
                                        <div style={{
                                            background: 'linear-gradient(135deg, #fff 0%, #fff8f0 100%)',
                                            padding: '20px',
                                            borderRadius: '16px',
                                            boxShadow: '0 4px 12px rgba(255, 152, 0, 0.12)',
                                            border: '1px solid rgba(255, 152, 0, 0.15)',
                                            position: 'relative',
                                            overflow: 'hidden',
                                            gridColumn: 'span 1'
                                        }}>
                                            <div style={{
                                                position: 'absolute',
                                                top: 0,
                                                right: 0,
                                                width: '80px',
                                                height: '80px',
                                                background: 'linear-gradient(135deg, rgba(255, 152, 0, 0.08) 0%, transparent 100%)',
                                                borderRadius: '0 0 0 100%'
                                            }}></div>
                                            
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '12px',
                                                marginBottom: '18px',
                                                paddingBottom: '14px',
                                                borderBottom: '2px solid rgba(255, 152, 0, 0.2)',
                                                position: 'relative'
                                            }}>
                                                <div style={{
                                                    width: '40px',
                                                    height: '40px',
                                                    borderRadius: '50%',
                                                    background: 'linear-gradient(135deg, #ff9800 0%, #f57c00 100%)',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    boxShadow: '0 4px 8px rgba(255, 152, 0, 0.3)'
                                                }}>
                                                    <i className="ri-shield-user-fill" style={{ fontSize: '20px', color: 'white' }}></i>
                                                </div>
                                                <span style={{
                                                    fontSize: '16px',
                                                    fontWeight: '700',
                                                    color: '#ff9800',
                                                    letterSpacing: '0.3px'
                                                }}>
                                                    Guardian's Information
                                                </span>
                                            </div>
                                            
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                                                <div>
                                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>
                                                        Full Name
                                                    </div>
                                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                        <i className="ri-user-line" style={{ color: '#ff9800' }}></i>
                                                        {parentInfoData.user.user_setting.guardian_name || 'N/A'}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>
                                                        Phone Number
                                                    </div>
                                                    <a href={`tel:${parentInfoData.user.user_setting.guardian_phone || ''}`} style={{
                                                        fontSize: '14px',
                                                        fontWeight: '700',
                                                        color: '#212529',
                                                        textDecoration: 'none',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '8px',
                                                        padding: '8px 12px',
                                                        background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                                                        borderRadius: '8px',
                                                        border: '1px solid #dee2e6',
                                                        width: 'fit-content'
                                                    }}>
                                                        <i className="ri-phone-fill" style={{ color: '#28a745' }}></i>
                                                        {parentInfoData.user.user_setting.guardian_phone || 'N/A'}
                                                    </a>
                                                </div>
                                                <div>
                                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>
                                                        Email Address
                                                    </div>
                                                    <div style={{ fontSize: '13px', fontWeight: '500', color: '#495057', wordBreak: 'break-all', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                        <i className="ri-mail-line" style={{ color: '#ff9800' }}></i>
                                                        {parentInfoData.user.user_setting.guardian_email || 'N/A'}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                            </div>
                        )}
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );

    const renderObservationModal = () => (
        <Modal show={showObservationModal} onHide={() => setShowObservationModal(false)} centered size="lg"
            style={{ marginTop: '20px' }}>
            <Modal.Header closeButton style={{
                borderBottom: '1px solid #e5e7eb',
                padding: '16px 20px',
                background: 'white'
            }}>
                <Modal.Title style={{
                    fontSize: '15px',
                    fontWeight: '700',
                    color: '#111827',
                    lineHeight: '1.3',
                    width: '100%',
                    maxWidth: 'calc(100% - 40px)'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div style={{
                            background: '#f3f4f6',
                            borderRadius: '8px',
                            padding: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <i className="ri-edit-2-line" style={{ fontSize: '18px', color: '#6366f1' }}></i>
                        </div>
                        <div>
                            <div style={{ fontSize: '15px', fontWeight: '700', marginBottom: '2px' }}>
                                Student Observation
                            </div>
                            <div style={{ fontSize: '12px', color: '#6b7280', fontWeight: '400' }}>
                                {selectedStudent?.name} • {new Date().toLocaleDateString('en-US', {
                                    month: 'short',
                                    day: 'numeric',
                                    year: 'numeric'
                                })}
                            </div>
                        </div>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '0', maxHeight: '65vh', overflowY: 'auto', background: '#f9fafb' }}>
                <div style={{ padding: '16px' }}>
                    <div style={{
                        background: 'white',
                        borderRadius: '8px',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                        overflow: 'hidden',
                        border: '1px solid #e5e7eb',
                        marginBottom: '12px'
                    }}>
                        <div style={{
                            background: '#f9fafb',
                            padding: '10px 16px',
                            borderBottom: '1px solid #e5e7eb'
                        }}>
                            <h6 style={{
                                fontSize: '13px',
                                fontWeight: '600',
                                marginBottom: '0',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                color: '#374151'
                            }}>
                                <i className="ri-sticky-note-line" style={{ fontSize: '16px', color: '#6366f1' }}></i>
                                General Notes
                            </h6>
                        </div>
                        <div style={{ padding: '16px' }}>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                placeholder="Enter general notes about the student's behavior, mood, or observations..."
                                value={observationNotes}
                                onChange={(e) => setObservationNotes(e.target.value)}
                                style={{
                                    fontSize: '13px',
                                    borderRadius: '6px',
                                    border: '1px solid #e5e7eb',
                                    padding: '12px',
                                    fontFamily: 'inherit',
                                    transition: 'border-color 0.2s ease',
                                    resize: 'vertical',
                                    lineHeight: '1.5'
                                }}
                                onFocus={(e) => e.target.style.borderColor = '#6366f1'}
                                onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                            />
                        </div>
                    </div>

                    <div style={{
                        background: 'white',
                        borderRadius: '8px',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                        overflow: 'hidden',
                        border: '1px solid #e5e7eb',
                        marginBottom: '12px'
                    }}>
                        <div style={{
                            background: '#f9fafb',
                            padding: '10px 16px',
                            borderBottom: '1px solid #e5e7eb'
                        }}>
                            <h6 style={{
                                fontSize: '13px',
                                fontWeight: '600',
                                marginBottom: '0',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                color: '#374151'
                            }}>
                                <i className="ri-eye-line" style={{ fontSize: '16px', color: '#6366f1' }}></i>
                                Detailed Observation
                            </h6>
                        </div>
                        <div style={{ padding: '16px' }}>
                            <Form.Control
                                as="textarea"
                                rows={4}
                                placeholder="Provide detailed observations about learning progress, social interactions, developmental milestones..."
                                value={observationText}
                                onChange={(e) => setObservationText(e.target.value)}
                                style={{
                                    fontSize: '13px',
                                    borderRadius: '6px',
                                    border: '1px solid #e5e7eb',
                                    padding: '12px',
                                    fontFamily: 'inherit',
                                    transition: 'border-color 0.2s ease',
                                    resize: 'vertical',
                                    lineHeight: '1.5'
                                }}
                                onFocus={(e) => e.target.style.borderColor = '#6366f1'}
                                onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                            />
                        </div>
                    </div>
                </div>
                <div style={{ marginTop: '24px', marginBottom: '18px', display: 'flex', gap: '12px', justifyContent: 'flex-end', paddingRight: '14px' }}>
                    <Button
                        variant="outline-secondary"
                        onClick={() => setShowObservationModal(false)}
                        style={{
                            borderRadius: '6px',
                            padding: '10px 20px',
                            fontSize: '13px',
                            fontWeight: '600'
                        }}
                    >
                        <i className="ri-close-line me-1"></i>
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={saveObservation}
                        style={{
                            borderRadius: '6px',
                            padding: '10px 24px',
                            fontSize: '13px',
                            fontWeight: '600'
                        }}
                    >
                        <i className="ri-save-line me-1"></i>
                        Save Observation
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );

    const renderExitTimeModal = () => (
        <Modal show={showExitTimeModal} onHide={() => setShowExitTimeModal(false)} centered style={{ marginTop: 10 }}>
            <Modal.Header closeButton style={{ borderBottom: '1px solid #e9ecef', padding: '16px 20px' }}>
                <Modal.Title style={{ fontSize: '18px', fontWeight: '600', color: '#E74C3C', paddingRight: '30px', lineHeight: '1.4' }}>
                    <i className="material-symbols-outlined" style={{ fontSize: '20px', verticalAlign: 'middle', marginRight: '6px' }}>
                        logout
                    </i>
                    <span style={{ wordBreak: 'break-word' }}>Set Exit Time</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '20px' }}>
                <div style={{ marginBottom: '12px' }}>
                    <div style={{ fontSize: '14px', color: '#6c757d', marginBottom: '4px' }}>
                        Student
                    </div>
                    <div style={{ fontSize: '16px', fontWeight: '600', color: '#212529' }}>
                        {selectedStudent?.name}
                    </div>
                </div>
                <Form.Group>
                    <Form.Label style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>
                        Exit Time
                    </Form.Label>
                    <DatePicker
                        selected={exitTime ? Moment(exitTime, 'HH:mm').toDate() : null}
                        onChange={(time) => setExitTime(time ? Moment(time).format('HH:mm') : '')}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={15}
                        timeCaption="Time"
                        dateFormat="h:mm aa"
                        placeholderText="Select exit time"
                        className="form-control"
                        style={{
                            fontSize: '14px',
                            borderRadius: '8px',
                            border: '1px solid #e9ecef',
                            padding: '10px',
                            width: '100%'
                        }}
                    />
                </Form.Group>
                <div style={{ marginTop: '20px', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                    <Button
                        variant="secondary"
                        onClick={() => setShowExitTimeModal(false)}
                        style={{
                            borderRadius: '8px',
                            padding: '10px 24px',
                            fontSize: '14px',
                            fontWeight: '600'
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="danger"
                        onClick={saveExitTime}
                        style={{
                            borderRadius: '8px',
                            padding: '10px 24px',
                            fontSize: '14px',
                            fontWeight: '600',
                            background: '#E74C3C',
                            border: 'none'
                        }}
                    >
                        <i className="material-symbols-outlined" style={{ fontSize: '16px', verticalAlign: 'middle', marginRight: '6px' }}>
                            save
                        </i>
                        Save Exit Time
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );

    const renderDailyReportModal = () => (
        <Modal show={showDailyReportModal} onHide={() => setShowDailyReportModal(false)} size="lg" centered
            style={{ marginTop: '30px' }}>
            <Modal.Header closeButton style={{
                borderBottom: '1px solid #e5e7eb',
                padding: '16px 20px',
                background: 'white'
            }}>
                <Modal.Title style={{
                    fontSize: '16px',
                    fontWeight: '700',
                    color: '#1f2937',
                    lineHeight: '1.3',
                    width: '100%',
                    maxWidth: 'calc(100% - 40px)'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <i className="ri-file-text-line" style={{ fontSize: '20px', color: '#6366f1' }}></i>
                            <div>
                                <div style={{ fontSize: '15px', fontWeight: '700', color: '#111827' }}>
                                    Daily Report
                                </div>
                                <div style={{ fontSize: '11px', color: '#6b7280', fontWeight: '500' }}>
                                    {selectedStudent?.name}
                                </div>
                            </div>
                        </div>
                        <div style={{ 
                            fontSize: '12px', 
                            color: '#6366f1', 
                            fontWeight: '600',
                            background: '#eef2ff',
                            padding: '4px 12px',
                            borderRadius: '6px'
                        }}>
                            {dailyReportData?.report_date ? Moment(dailyReportData.report_date).format('MMM D YYYY') : Moment().format('MMM D YYYY')}
                        </div>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '0', maxHeight: '65vh', overflowY: 'auto', background: '#f9fafb' }}>
                <div style={{ padding: '16px' }}>
                    {dailyReportData ? (
                        <div>
                            {/* Student & Class Info Card */}
                            <div style={{
                                marginBottom: '12px',
                                background: 'white',
                                borderRadius: '8px',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                border: '1px solid #e5e7eb',
                                padding: '12px'
                            }}>
                                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                    <div style={{
                                        flex: '1',
                                        minWidth: '120px',
                                        padding: '8px 12px',
                                        background: '#f9fafb',
                                        borderRadius: '6px',
                                        border: '1px solid #e5e7eb'
                                    }}>
                                        <div style={{ fontSize: '10px', color: '#6b7280', fontWeight: '600', marginBottom: '2px' }}>STUDENT</div>
                                        <div style={{ fontSize: '13px', fontWeight: '600', color: '#111827' }}>{dailyReportData.student?.name || 'N/A'}</div>
                                    </div>
                                    <div style={{
                                        flex: '1',
                                        minWidth: '120px',
                                        padding: '8px 12px',
                                        background: '#f9fafb',
                                        borderRadius: '6px',
                                        border: '1px solid #e5e7eb'
                                    }}>
                                        <div style={{ fontSize: '10px', color: '#6b7280', fontWeight: '600', marginBottom: '2px' }}>CLASS</div>
                                        <div style={{ fontSize: '13px', fontWeight: '600', color: '#111827' }}>{dailyReportData.class?.name || 'N/A'}</div>
                                    </div>
                                    <div style={{
                                        flex: '1',
                                        minWidth: '120px',
                                        padding: '8px 12px',
                                        background: '#f9fafb',
                                        borderRadius: '6px',
                                        border: '1px solid #e5e7eb'
                                    }}>
                                        <div style={{ fontSize: '10px', color: '#6b7280', fontWeight: '600', marginBottom: '2px' }}>STATUS</div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <div style={{
                                                width: '6px',
                                                height: '6px',
                                                borderRadius: '50%',
                                                background: dailyReportData.is_present ? '#10b981' : '#ef4444'
                                            }}></div>
                                            <span style={{ fontSize: '13px', fontWeight: '600', color: '#111827' }}>
                                                {dailyReportData.is_present ? 'Present' : 'Absent'}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {dailyReportData.daily_report ? (
                                <div>
                                    {/* Today I Felt Section */}
                                    {dailyReportData.daily_report.daily_report_fealings && dailyReportData.daily_report.daily_report_fealings.length > 0 && (
                                        <div style={{
                                            marginBottom: '12px',
                                            background: 'white',
                                            borderRadius: '8px',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                            border: '1px solid #e5e7eb',
                                            padding: '12px'
                                        }}>
                                            <div style={{
                                                fontSize: '12px',
                                                fontWeight: '700',
                                                color: '#374151',
                                                marginBottom: '8px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px'
                                            }}>
                                                <i className="ri-emotion-happy-line" style={{ fontSize: '14px', color: '#6366f1' }}></i>
                                                Today I Felt
                                            </div>
                                            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                                                {dailyReportData.daily_report.daily_report_fealings.map((feeling, index) => (
                                                    <div key={index} style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '6px',
                                                        padding: '6px 12px',
                                                        background: feeling.fealing.name === 'Happy' ? '#dcfce7' : '#fee2e2',
                                                        color: feeling.fealing.name === 'Happy' ? '#166534' : '#991b1b',
                                                        borderRadius: '6px',
                                                        border: `1px solid ${feeling.fealing.name === 'Happy' ? '#bbf7d0' : '#fecaca'}`
                                                    }}>
                                                        <i className={feeling.fealing.name === 'Happy' ? 'ri-emotion-happy-line' : 'ri-emotion-unhappy-line'} style={{ fontSize: '14px' }}></i>
                                                        <span style={{ fontSize: '12px', fontWeight: '600' }}>{feeling.fealing.name}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                    {/* Today I Learned Section */}
                                    {dailyReportData.daily_report.learned && (
                                        <div style={{
                                            marginBottom: '12px',
                                            background: 'white',
                                            borderRadius: '8px',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                            border: '1px solid #e5e7eb',
                                            padding: '12px'
                                        }}>
                                            <div style={{
                                                fontSize: '12px',
                                                fontWeight: '700',
                                                color: '#374151',
                                                marginBottom: '8px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px'
                                            }}>
                                                <i className="ri-lightbulb-line" style={{ fontSize: '14px', color: '#6366f1' }}></i>
                                                Today I Learned
                                            </div>
                                            <div
                                                style={{
                                                    padding: '10px',
                                                    background: '#f9fafb',
                                                    borderRadius: '6px',
                                                    border: '1px solid #e5e7eb',
                                                    fontSize: '12px',
                                                    lineHeight: '1.5',
                                                    color: '#4b5563'
                                                }}
                                                dangerouslySetInnerHTML={{ __html: dailyReportData.daily_report.learned }}
                                            />
                                        </div>
                                    )}
                                    {/* Diapers/Toilet Section */}
                                    {dailyReportData.daily_report.daily_report_diapers && dailyReportData.daily_report.daily_report_diapers.length > 0 && (
                                        <div style={{
                                            marginBottom: '12px',
                                            background: 'white',
                                            borderRadius: '8px',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                            border: '1px solid #e5e7eb',
                                            padding: '12px'
                                        }}>
                                            <div style={{
                                                fontSize: '12px',
                                                fontWeight: '700',
                                                color: '#374151',
                                                marginBottom: '8px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px'
                                            }}>
                                                <i className="ri-baby-line" style={{ fontSize: '14px', color: '#6366f1' }}></i>
                                                Diapers/Toilet
                                                <span style={{
                                                    marginLeft: 'auto',
                                                    fontSize: '11px',
                                                    color: '#6b7280',
                                                    background: '#f3f4f6',
                                                    padding: '2px 8px',
                                                    borderRadius: '4px'
                                                }}>
                                                    {dailyReportData.daily_report.daily_report_diapers.length}
                                                </span>
                                            </div>
                                            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                                                {dailyReportData.daily_report.daily_report_diapers.map((diaper, index) => (
                                                    <div key={index} style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '8px',
                                                        padding: '6px 10px',
                                                        background: '#f9fafb',
                                                        borderRadius: '6px',
                                                        border: '1px solid #e5e7eb'
                                                    }}>
                                                        <span style={{ fontSize: '11px', fontWeight: '600', color: '#111827' }}>
                                                            {Moment(diaper.diaper_time, 'HH:mm').format('h:mm A')}
                                                        </span>
                                                        <span style={{
                                                            padding: '2px 6px',
                                                            borderRadius: '4px',
                                                            fontSize: '10px',
                                                            fontWeight: '600',
                                                            background: diaper.diaper_check === 1 ? '#fef3c7' :
                                                                diaper.diaper_check === 2 ? '#dcfce7' :
                                                                    diaper.diaper_check === 3 ? '#dbeafe' : '#fecaca',
                                                            color: diaper.diaper_check === 1 ? '#92400e' :
                                                                diaper.diaper_check === 2 ? '#166534' :
                                                                    diaper.diaper_check === 3 ? '#1e40af' : '#991b1b'
                                                        }}>
                                                            {diaper.diaper_check === 1 ? 'D/T' :
                                                                diaper.diaper_check === 2 ? 'Dry' :
                                                                    diaper.diaper_check === 3 ? 'Wet' : 'BM'}
                                                        </span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                    {/* Sleep Section */}
                                    {dailyReportData.daily_report.daily_report_sleeps && dailyReportData.daily_report.daily_report_sleeps.length > 0 && (
                                        <div style={{
                                            marginBottom: '12px',
                                            background: 'white',
                                            borderRadius: '8px',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                            border: '1px solid #e5e7eb',
                                            padding: '12px'
                                        }}>
                                            <div style={{
                                                fontSize: '12px',
                                                fontWeight: '700',
                                                color: '#374151',
                                                marginBottom: '8px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px'
                                            }}>
                                                <i className="ri-zzz-line" style={{ fontSize: '14px', color: '#6366f1' }}></i>
                                                Sleep
                                                <span style={{
                                                    marginLeft: 'auto',
                                                    fontSize: '11px',
                                                    color: '#6b7280',
                                                    background: '#f3f4f6',
                                                    padding: '2px 8px',
                                                    borderRadius: '4px'
                                                }}>
                                                    {dailyReportData.daily_report.daily_report_sleeps.length}
                                                </span>
                                            </div>
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                                {dailyReportData.daily_report.daily_report_sleeps.map((sleep, index) => {
                                                    const start = new Date(`2000-01-01T${sleep.start_time}`);
                                                    const end = new Date(`2000-01-01T${sleep.end_time}`);
                                                    const duration = Math.abs(end - start) / (1000 * 60);
                                                    const hours = Math.floor(duration / 60);
                                                    const minutes = Math.floor(duration % 60);

                                                    return (
                                                        <div key={index} style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '8px',
                                                            padding: '8px 10px',
                                                            background: '#f9fafb',
                                                            borderRadius: '6px',
                                                            border: '1px solid #e5e7eb'
                                                        }}>
                                                            <span style={{ fontSize: '11px', fontWeight: '600', color: '#111827' }}>
                                                                {Moment(sleep.start_time, 'HH:mm').format('h:mm A')}
                                                            </span>
                                                            <i className="ri-arrow-right-s-line" style={{ fontSize: '12px', color: '#9ca3af' }}></i>
                                                            <span style={{ fontSize: '11px', fontWeight: '600', color: '#111827' }}>
                                                                {Moment(sleep.end_time, 'HH:mm').format('h:mm A')}
                                                            </span>
                                                            <span style={{
                                                                marginLeft: 'auto',
                                                                padding: '2px 8px',
                                                                borderRadius: '4px',
                                                                fontSize: '10px',
                                                                fontWeight: '600',
                                                                background: '#dbeafe',
                                                                color: '#1e40af'
                                                            }}>
                                                                {hours > 0 ? `${hours}h ` : ''}{minutes}m
                                                            </span>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    )}
                                    {/* Please Bring More Section */}
                                    {dailyReportData.daily_report.daily_report_bring_mores && dailyReportData.daily_report.daily_report_bring_mores.length > 0 && (
                                        <div style={{
                                            marginBottom: '12px',
                                            background: 'white',
                                            borderRadius: '8px',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                            border: '1px solid #e5e7eb',
                                            padding: '12px'
                                        }}>
                                            <div style={{
                                                fontSize: '12px',
                                                fontWeight: '700',
                                                color: '#374151',
                                                marginBottom: '8px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px'
                                            }}>
                                                <i className="ri-shopping-bag-line" style={{ fontSize: '14px', color: '#6366f1' }}></i>
                                                Please Bring More
                                            </div>
                                            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                                                {dailyReportData.daily_report.daily_report_bring_mores.map((item, index) => {
                                                    const getItemName = (thingId, other) => {
                                                        const names = { 1: 'Diapers', 2: 'Wipes', 3: 'Ointment', 4: 'Clothes', 5: 'Blanket', 6: other || 'Other' };
                                                        return names[thingId] || 'Unknown';
                                                    };
                                                    const getItemIcon = (thingId) => {
                                                        const icons = { 1: 'ri-baby-line', 2: 'ri-drop-line', 3: 'ri-medicine-bottle-line', 4: 'ri-shirt-line', 5: 'ri-hotel-bed-line', 6: 'ri-add-box-line' };
                                                        return icons[thingId] || 'ri-checkbox-circle-line';
                                                    };
                                                    return (
                                                        <div key={index} style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '6px',
                                                            padding: '6px 10px',
                                                            background: '#fef3c7',
                                                            borderRadius: '6px',
                                                            border: '1px solid #fde68a'
                                                        }}>
                                                            <i className={getItemIcon(item.things)} style={{ fontSize: '12px', color: '#92400e' }}></i>
                                                            <span style={{ fontSize: '11px', fontWeight: '600', color: '#92400e' }}>
                                                                {getItemName(item.things, item.other)}
                                                            </span>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    )}

                                    {/* Comments Section */}
                                    {dailyReportData.daily_report.comments && (
                                        <div style={{
                                            marginBottom: '12px',
                                            background: 'white',
                                            borderRadius: '8px',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                            border: '1px solid #e5e7eb',
                                            padding: '12px'
                                        }}>
                                            <div style={{
                                                fontSize: '12px',
                                                fontWeight: '700',
                                                color: '#374151',
                                                marginBottom: '8px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px'
                                            }}>
                                                <i className="ri-chat-3-line" style={{ fontSize: '14px', color: '#6366f1' }}></i>
                                                Comments
                                            </div>
                                            <div
                                                style={{
                                                    padding: '10px',
                                                    background: '#f9fafb',
                                                    borderRadius: '6px',
                                                    border: '1px solid #e5e7eb',
                                                    fontSize: '12px',
                                                    lineHeight: '1.5',
                                                    color: '#4b5563'
                                                }}
                                                dangerouslySetInnerHTML={{ __html: dailyReportData.daily_report.comments }}
                                            />
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div style={{
                                    textAlign: 'center',
                                    padding: '60px 20px',
                                    background: 'white',
                                    borderRadius: '20px',
                                    margin: '24px',
                                    boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
                                }}>
                                    <i className="ri-file-text-line" style={{
                                        fontSize: '64px',
                                        color: '#cbd5e1',
                                        display: 'block',
                                        marginBottom: '16px'
                                    }}></i>
                                    <div style={{ fontSize: '20px', fontWeight: '600', color: '#475569', marginBottom: '8px' }}>
                                        No Daily Report Found
                                    </div>
                                    <div style={{ fontSize: '16px', color: '#64748b' }}>
                                        No report has been created for this student on this date.
                                    </div>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div style={{
                            textAlign: 'center',
                            padding: '60px 20px',
                            background: 'white',
                            borderRadius: '20px',
                            margin: '24px',
                            boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
                        }}>
                            <div className="spinner-border" role="status" style={{ color: '#667eea' }}>
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <div style={{ fontSize: '16px', color: '#64748b', marginTop: '16px' }}>
                                Loading daily report...
                            </div>
                        </div>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer style={{
                borderTop: '2px solid #f0f0f0',
                padding: '12px 16px',
                background: 'white',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                    {dailyReportData?.daily_report && (
                        <Button
                            variant="success"
                            onClick={printDailyReport}
                            style={{
                                borderRadius: '8px',
                                padding: '10px 18px',
                                fontSize: '13px',
                                fontWeight: '600',
                                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                                border: 'none',
                                boxShadow: '0 3px 12px rgba(16, 185, 129, 0.35)',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px'
                            }}
                        >
                            <i className="ri-printer-line" style={{ fontSize: '14px' }}></i>
                            Print
                        </Button>
                    )}
                    {dailyReportData?.daily_report && isToday(dailyReportData.report_date) && (
                        <Button
                            variant="warning"
                            onClick={() => editDailyReport()}
                            style={{
                                borderRadius: '8px',
                                padding: '10px 18px',
                                fontSize: '13px',
                                fontWeight: '600',
                                background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                                border: 'none',
                                boxShadow: '0 3px 12px rgba(245, 158, 11, 0.35)',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px'
                            }}
                        >
                            <i className="ri-edit-line" style={{ fontSize: '14px' }}></i>
                            Edit
                        </Button>
                    )}
                </div>
                <Button
                    variant="outline-secondary"
                    onClick={() => setShowDailyReportModal(false)}
                    style={{
                        borderRadius: '8px',
                        padding: '10px 18px',
                        fontSize: '13px',
                        fontWeight: '600',
                        border: '1px solid #d1d5db',
                        color: '#6b7280',
                        background: 'white'
                    }}
                >
                    <i className="ri-close-line me-1" style={{ fontSize: '14px' }}></i>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );

    const renderPeanutPolicyModal = () => {
        const formatDate = (dateString) => {
            if (!dateString) return 'N/A';
            return Moment(dateString).format('MMM D YYYY');
        };

        return (
            <Modal show={showPeanutPolicyModal} onHide={() => setShowPeanutPolicyModal(false)} size="lg" centered
                style={{ marginTop: '50px' }}>
                <Modal.Header closeButton style={{
                    borderBottom: '1px solid #e5e7eb',
                    padding: '16px 20px',
                    background: 'white'
                }}>
                    <Modal.Title style={{
                        fontSize: '15px',
                        fontWeight: '700',
                        color: '#111827',
                        margin: 0,
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                    }}>
                        <div style={{
                            width: '32px',
                            height: '32px',
                            borderRadius: '8px',
                            background: '#f3f4f6',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <i className="ri-forbid-line" style={{
                                fontSize: '18px',
                                color: '#ef4444'
                            }}></i>
                        </div>
                        Peanut Policy - {peanutPolicyData?.student?.name || selectedStudent?.name || 'Student'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{
                    padding: '20px',
                    maxHeight: '70vh',
                    overflowY: 'auto',
                    background: '#f9fafb'
                }}>
                    {peanutPolicyData ? (
                        peanutPolicyData.policy ? (
                            <div className="container-fluid">
                                <Row className="g-3">
                                    {/* Policy Information */}
                                    <Col xs={12}>
                                        <div style={{
                                            background: 'white',
                                            borderRadius: '8px',
                                            padding: '16px',
                                            border: '1px solid #e5e7eb',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                        }}>
                                            <h6 style={{
                                                margin: '0 0 12px 0',
                                                fontSize: '13px',
                                                fontWeight: '600',
                                                color: '#374151',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px'
                                            }}>
                                                <i className="ri-file-list-3-line" style={{ fontSize: '16px', color: '#6366f1' }}></i>
                                                Policy Information
                                            </h6>

                                            <Row className="g-3">
                                                <Col md={12}>
                                                    <div style={{
                                                        background: '#f9fafb',
                                                        borderRadius: '6px',
                                                        padding: '12px',
                                                        border: '1px solid #e5e7eb'
                                                    }}>
                                                        <div style={{
                                                            fontSize: '11px',
                                                            fontWeight: '600',
                                                            color: '#6b7280',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.5px',
                                                            marginBottom: '6px'
                                                        }}>Policy Description</div>
                                                        <div style={{
                                                            fontSize: '13px',
                                                            color: '#111827',
                                                            lineHeight: '1.6',
                                                            fontWeight: '400'
                                                        }}>
                                                            {peanutPolicyData.policy.description || 'No description provided'}
                                                        </div>
                                                    </div>
                                                </Col>

                                                <Col md={6}>
                                                    <div style={{
                                                        background: '#f9fafb',
                                                        borderRadius: '6px',
                                                        padding: '12px',
                                                        border: '1px solid #e5e7eb'
                                                    }}>
                                                        <div style={{
                                                            fontSize: '11px',
                                                            fontWeight: '600',
                                                            color: '#6b7280',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.5px',
                                                            marginBottom: '6px'
                                                        }}>Policy Status</div>
                                                        <span style={{
                                                            padding: '4px 10px',
                                                            borderRadius: '12px',
                                                            fontSize: '11px',
                                                            fontWeight: '600',
                                                            backgroundColor: peanutPolicyData.policy.status === 1 ? '#dcfce7' : '#fee2e2',
                                                            color: peanutPolicyData.policy.status === 1 ? '#166534' : '#991b1b'
                                                        }}>
                                                            {peanutPolicyData.policy.status === 1 ? 'Active' : 'Inactive'}
                                                        </span>
                                                    </div>
                                                </Col>

                                                <Col md={6}>
                                                    <div style={{
                                                        background: '#f9fafb',
                                                        borderRadius: '6px',
                                                        padding: '12px',
                                                        border: '1px solid #e5e7eb'
                                                    }}>
                                                        <div style={{
                                                            fontSize: '11px',
                                                            fontWeight: '600',
                                                            color: '#6b7280',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.5px',
                                                            marginBottom: '6px'
                                                        }}>Created Date</div>
                                                        <div style={{
                                                            fontSize: '13px',
                                                            color: '#111827',
                                                            fontWeight: '500'
                                                        }}>
                                                            {formatDate(peanutPolicyData.policy.created_at)}
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>

                                    {/* Signature Section */}
                                    <Col xs={12}>
                                        <div style={{
                                            background: 'white',
                                            borderRadius: '8px',
                                            padding: '16px',
                                            border: '1px solid #e5e7eb',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                        }}>
                                            <h6 style={{
                                                margin: '0 0 12px 0',
                                                fontSize: '13px',
                                                fontWeight: '600',
                                                color: '#374151',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px'
                                            }}>
                                                <i className="ri-quill-pen-line" style={{ fontSize: '16px', color: '#6366f1' }}></i>
                                                Parent Signature
                                            </h6>

                                            <Row className="g-3">
                                                <Col md={6}>
                                                    <div style={{
                                                        background: '#f9fafb',
                                                        borderRadius: '6px',
                                                        padding: '12px',
                                                        border: '1px solid #e5e7eb'
                                                    }}>
                                                        <div style={{
                                                            fontSize: '11px',
                                                            fontWeight: '600',
                                                            color: '#6b7280',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.5px',
                                                            marginBottom: '6px'
                                                        }}>Signature Date</div>
                                                        <div style={{
                                                            fontSize: '13px',
                                                            color: '#111827',
                                                            fontWeight: '500'
                                                        }}>
                                                            {formatDate(peanutPolicyData.policy.parent_signature_date)}
                                                        </div>
                                                    </div>
                                                </Col>

                                                <Col md={6}>
                                                    <div style={{
                                                        background: '#f9fafb',
                                                        borderRadius: '6px',
                                                        padding: '12px',
                                                        border: '1px solid #e5e7eb',
                                                        textAlign: 'center'
                                                    }}>
                                                        <div style={{
                                                            fontSize: '11px',
                                                            fontWeight: '600',
                                                            color: '#6b7280',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.5px',
                                                            marginBottom: '8px'
                                                        }}>Digital Signature</div>
                                                        {peanutPolicyData.policy.parent_signature ? (
                                                            <img
                                                                src={peanutPolicyData.policy.parent_signature}
                                                                alt="Parent Signature"
                                                                style={{
                                                                    maxWidth: '100%',
                                                                    maxHeight: '80px',
                                                                    border: '1px solid #e5e7eb',
                                                                    borderRadius: '4px',
                                                                    backgroundColor: 'white'
                                                                }}
                                                                onError={(e) => {
                                                                    e.target.style.display = 'none';
                                                                    e.target.nextSibling.style.display = 'flex';
                                                                }}
                                                            />
                                                        ) : null}
                                                        <div style={{
                                                            display: peanutPolicyData.policy.parent_signature ? 'none' : 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            padding: '16px',
                                                            color: '#6b7280',
                                                            fontSize: '12px'
                                                        }}>
                                                            <i className="ri-image-line" style={{ fontSize: '16px', marginRight: '6px', opacity: 0.5 }}></i>
                                                            No signature available
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>

                                    {/* Student Information */}
                                    <Col xs={12}>
                                        <div style={{
                                            background: 'white',
                                            borderRadius: '8px',
                                            padding: '16px',
                                            border: '1px solid #e5e7eb',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                        }}>
                                            <h6 style={{
                                                margin: '0 0 12px 0',
                                                fontSize: '13px',
                                                fontWeight: '600',
                                                color: '#374151',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px'
                                            }}>
                                                <i className="ri-user-line" style={{ fontSize: '16px', color: '#6366f1' }}></i>
                                                Student Information
                                            </h6>

                                            <Row className="g-3">
                                                <Col md={3}>
                                                    <div style={{ textAlign: 'center' }}>
                                                        <img
                                                            src={peanutPolicyData.student?.photo}
                                                            alt={peanutPolicyData.student?.name}
                                                            style={{
                                                                width: '70px',
                                                                height: '70px',
                                                                borderRadius: '50%',
                                                                objectFit: 'cover',
                                                                border: '2px solid #e5e7eb',
                                                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                                            }}
                                                            onError={(e) => {
                                                                e.target.src = '/images/default-avatar.png';
                                                            }}
                                                        />
                                                    </div>
                                                </Col>

                                                <Col md={4}>
                                                    <div style={{
                                                        background: '#f9fafb',
                                                        borderRadius: '6px',
                                                        padding: '12px',
                                                        border: '1px solid #e5e7eb'
                                                    }}>
                                                        <div style={{
                                                            fontSize: '11px',
                                                            fontWeight: '600',
                                                            color: '#6b7280',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.5px',
                                                            marginBottom: '6px'
                                                        }}>Student Name</div>
                                                        <div style={{
                                                            fontSize: '13px',
                                                            color: '#111827',
                                                            fontWeight: '600'
                                                        }}>
                                                            {peanutPolicyData.student?.name || 'N/A'}
                                                        </div>
                                                    </div>
                                                </Col>

                                                <Col md={5}>
                                                    <div style={{
                                                        background: '#f9fafb',
                                                        borderRadius: '6px',
                                                        padding: '12px',
                                                        border: '1px solid #e5e7eb'
                                                    }}>
                                                        <div style={{
                                                            fontSize: '11px',
                                                            fontWeight: '600',
                                                            color: '#6b7280',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.5px',
                                                            marginBottom: '6px'
                                                        }}>Student Email</div>
                                                        <div style={{
                                                            fontSize: '13px',
                                                            color: '#111827',
                                                            fontWeight: '500'
                                                        }}>
                                                            {peanutPolicyData.student?.email || 'N/A'}
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        ) : (
                            <div style={{
                                textAlign: 'center',
                                padding: '60px 20px',
                                color: '#6c757d'
                            }}>
                                <i className="ri-forbid-line" style={{
                                    fontSize: '48px',
                                    color: '#dc3545',
                                    opacity: 0.3,
                                    display: 'block',
                                    marginBottom: '16px'
                                }}></i>
                                <h6 style={{
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    color: '#495057',
                                    marginBottom: '8px'
                                }}>No Peanut Policy Data</h6>
                                <p style={{
                                    fontSize: '14px',
                                    color: '#6c757d',
                                    margin: 0
                                }}>No peanut policy information is available for this student.</p>
                            </div>
                        )
                    ) : (
                        <div style={{
                            textAlign: 'center',
                            padding: '60px 20px',
                            color: '#6c757d'
                        }}>
                            <div className="spinner-border" style={{ color: '#dc3545' }} role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p style={{
                                fontSize: '14px',
                                marginTop: '16px',
                                margin: 0
                            }}>Loading peanut policy data...</p>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        );
    };

    const renderLunchPlanModal = () => {
        const formatDate = (dateString) => {
            if (!dateString) return 'N/A';
            return Moment(dateString).format('MMM D YYYY');
        };

        const formatDateTime = (dateString) => {
            if (!dateString) return 'N/A';
            return Moment(dateString).format('MMM D YYYY h:mm A');
        };

        const getFieldDisplayName = (key) => {
            const fieldNames = {
                'fillup_date': 'Application Date',
                'reason': 'Waiver Reason',
                'parents_signature': 'Parent Signature',
                'parent_signature_date': 'Parent Signed Date',
                'supervisor_signature': 'Supervisor Signature',
                'status': 'Status'
            };
            return fieldNames[key] || key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
        };

        const getFieldDescription = (key) => {
            const descriptions = {
                'fillup_date': 'When this waiver was submitted',
                'reason': 'Explanation for lunch plan waiver',
                'parents_signature': 'Parent/Guardian authorization',
                'parent_signature_date': 'Date of parent authorization',
                'supervisor_signature': 'Administrative approval',
                'status': 'Current waiver status'
            };
            return descriptions[key] || 'Information details';
        };

        const renderFieldContent = (key, value) => {
            if (!value || (typeof value === 'string' && value.trim() === '')) {
                return <span style={{ color: '#9ca3af', fontStyle: 'italic' }}>Not provided</span>;
            }

            if (key === 'fillup_date') {
                return <span style={{ fontWeight: '600', color: '#059669' }}>{formatDateTime(value)}</span>;
            }

            if (key === 'parent_signature_date') {
                return <span style={{ fontWeight: '600', color: '#059669' }}>{formatDate(value)}</span>;
            }

            if (key === 'status') {
                const statusValue = parseInt(value);
                return (
                    <span style={{
                        padding: '6px 12px',
                        borderRadius: '20px',
                        fontSize: '12px',
                        fontWeight: '700',
                        background: statusValue === 1 ? '#d1fae5' : '#fee2e2',
                        color: statusValue === 1 ? '#065f46' : '#991b1b'
                    }}>
                        {statusValue === 1 ? '✅ Active' : '❌ Inactive'}
                    </span>
                );
            }

            if (key.includes('signature') && typeof value === 'string' && value !== 'N/A') {
                return (
                    <div style={{
                        padding: '16px',
                        background: '#f8fafc',
                        borderRadius: '12px',
                        border: '2px dashed #cbd5e1',
                        textAlign: 'center',
                        minHeight: '80px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <div>
                            <i className="ri-quill-pen-line" style={{ fontSize: '24px', color: '#64748b', marginBottom: '8px', display: 'block' }}></i>
                            <span style={{ color: '#475569', fontSize: '14px', fontWeight: '600' }}>Digital Signature On File</span>
                        </div>
                    </div>
                );
            }

            // Handle object values (like user data)
            if (typeof value === 'object' && value !== null) {
                if (value.name) {
                    return <span style={{ fontWeight: '500', color: '#374151' }}>{value.name}</span>;
                } else if (value.email) {
                    return <span style={{ fontWeight: '500', color: '#374151' }}>{value.email}</span>;
                } else if (Array.isArray(value)) {
                    return <span style={{ fontWeight: '500', color: '#374151' }}>{value.join(', ')}</span>;
                } else {
                    // Try to extract meaningful data from object
                    const objectKeys = Object.keys(value);
                    if (objectKeys.length > 0) {
                        const firstKey = objectKeys[0];
                        const firstValue = value[firstKey];
                        return <span style={{ fontWeight: '500', color: '#374151' }}>{String(firstValue)}</span>;
                    }
                    return <span style={{ color: '#9ca3af', fontStyle: 'italic' }}>Complex data</span>;
                }
            }

            // Ensure value is converted to string
            const displayValue = typeof value === 'string' ? value : String(value);
            return <span style={{ fontWeight: '500', color: '#374151' }}>{displayValue}</span>;
        };

        const filteredData = lunchPlanData ?
            Object.entries(lunchPlanData).filter(([key, value]) => {
                // Filter out unnecessary keys and null/empty values
                const excludeKeys = ['id', 'user_id'];
                return !excludeKeys.includes(key.toLowerCase()) && value != null && value !== '';
            }) : [];

        return (
            <Modal show={showLunchPlanModal} onHide={() => setShowLunchPlanModal(false)} size="lg" centered>
                <Modal.Header closeButton style={{
                    borderBottom: '1px solid #e5e7eb',
                    padding: '16px 20px',
                    background: 'white'
                }}>
                    <Modal.Title style={{
                        fontSize: '15px',
                        fontWeight: '700',
                        color: '#111827',
                        lineHeight: '1.3',
                        width: '100%',
                        maxWidth: 'calc(100% - 40px)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                    }}>
                        <div style={{
                            background: '#f3f4f6',
                            borderRadius: '8px',
                            padding: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <i className="ri-restaurant-line" style={{ fontSize: '18px', color: '#10b981' }}></i>
                        </div>
                        <div>
                            <div style={{ fontSize: '15px', fontWeight: '700', color: '#111827' }}>
                                Lunch Plan Waiver
                            </div>
                            <div style={{ fontSize: '12px', color: '#6b7280', fontWeight: '400' }}>
                                {selectedStudent?.name || 'Student'} • Dietary Documentation
                            </div>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ padding: '20px', maxHeight: 'calc(75vh - 140px)', overflowY: 'auto', background: '#f9fafb' }}>
                    {lunchPlanData ? (
                        <div>
                            {/* Waiver Information Section */}
                            <div style={{
                                background: 'white',
                                borderRadius: '8px',
                                padding: '16px',
                                border: '1px solid #e5e7eb',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                marginBottom: '12px'
                            }}>
                                <h6 style={{ color: '#374151', fontSize: '13px', fontWeight: '600', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <i className="ri-file-list-3-line" style={{ fontSize: '16px', color: '#6366f1' }}></i>
                                    Waiver Information
                                </h6>
                                {lunchPlanData.fillup_date && (
                                    <div style={{ marginBottom: '12px' }}>
                                        <div style={{ fontSize: '11px', fontWeight: '600', color: '#6b7280', marginBottom: '4px' }}>Submitted Date</div>
                                        <div style={{ fontSize: '13px', color: '#111827' }}>{formatDate(lunchPlanData.fillup_date)}</div>
                                    </div>
                                )}
                                {lunchPlanData.reason && (
                                    <div>
                                        <div style={{ fontSize: '11px', fontWeight: '600', color: '#6b7280', marginBottom: '4px' }}>Reason</div>
                                        <div style={{ fontSize: '13px', color: '#111827', background: '#f9fafb', padding: '12px', borderRadius: '6px', border: '1px solid #e5e7eb' }}>
                                            {lunchPlanData.reason}
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Signatures Section */}
                            <div style={{
                                background: 'white',
                                borderRadius: '8px',
                                padding: '16px',
                                border: '1px solid #e5e7eb',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                marginBottom: '12px'
                            }}>
                                <h6 style={{ color: '#374151', fontSize: '13px', fontWeight: '600', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <i className="ri-quill-pen-line" style={{ fontSize: '16px', color: '#6366f1' }}></i>
                                    Signatures
                                </h6>
                                <Row>
                                    <Col md="6">
                                        <div style={{ marginBottom: '12px' }}>
                                            <div style={{ fontSize: '11px', fontWeight: '600', color: '#6b7280', marginBottom: '8px' }}>Parent Signature</div>
                                            {lunchPlanData.parents_signature ? (
                                                <div style={{ border: '1px solid #e5e7eb', borderRadius: '6px', padding: '12px', backgroundColor: '#f9fafb', minHeight: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <img
                                                        src={lunchPlanData.parents_signature}
                                                        alt="Parent Signature"
                                                        style={{
                                                            maxWidth: '100%',
                                                            maxHeight: '80px',
                                                            display: 'block',
                                                            objectFit: 'contain'
                                                        }}
                                                        onError={(e) => {
                                                            e.target.style.display = 'none';
                                                            e.target.nextSibling.style.display = 'block';
                                                        }}
                                                    />
                                                    <div style={{ display: 'none', color: '#6b7280', textAlign: 'center' }}>
                                                        <i className="ri-image-line" style={{ fontSize: '20px', display: 'block', marginBottom: '6px' }}></i>
                                                        <small style={{ fontSize: '11px' }}>Image not available</small>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div style={{ border: '1px solid #e5e7eb', borderRadius: '6px', padding: '12px', backgroundColor: '#f9fafb', minHeight: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <div style={{ color: '#6b7280', textAlign: 'center' }}>
                                                        <i className="ri-file-text-line" style={{ fontSize: '20px', display: 'block', marginBottom: '6px' }}></i>
                                                        <small style={{ fontSize: '11px' }}>No signature provided</small>
                                                    </div>
                                                </div>
                                            )}
                                            {lunchPlanData.parent_signature_date && (
                                                <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '6px' }}>
                                                    Signed: {formatDate(lunchPlanData.parent_signature_date)}
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md="6">
                                        <div>
                                            <div style={{ fontSize: '11px', fontWeight: '600', color: '#6b7280', marginBottom: '8px' }}>Supervisor Signature</div>
                                            {lunchPlanData.supervisor_signature ? (
                                                <div style={{ border: '1px solid #e5e7eb', borderRadius: '6px', padding: '12px', backgroundColor: '#f9fafb', minHeight: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <img
                                                        src={lunchPlanData.supervisor_signature}
                                                        alt="Supervisor Signature"
                                                        style={{
                                                            maxWidth: '100%',
                                                            maxHeight: '80px',
                                                            display: 'block',
                                                            objectFit: 'contain'
                                                        }}
                                                        onError={(e) => {
                                                            e.target.style.display = 'none';
                                                            e.target.nextSibling.style.display = 'block';
                                                        }}
                                                    />
                                                    <div style={{ display: 'none', color: '#6b7280', textAlign: 'center' }}>
                                                        <i className="ri-image-line" style={{ fontSize: '20px', display: 'block', marginBottom: '6px' }}></i>
                                                        <small style={{ fontSize: '11px' }}>Image not available</small>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div style={{ border: '1px solid #e5e7eb', borderRadius: '6px', padding: '12px', backgroundColor: '#f9fafb', minHeight: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <div style={{ color: '#6b7280', textAlign: 'center' }}>
                                                        <i className="ri-file-text-line" style={{ fontSize: '20px', display: 'block', marginBottom: '6px' }}></i>
                                                        <small style={{ fontSize: '11px' }}>No signature provided</small>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </div>

                            {/* Additional waiver details if available */}
                            {lunchPlanData.student && (
                                <div style={{
                                    background: 'white',
                                    borderRadius: '8px',
                                    padding: '16px',
                                    border: '1px solid #e5e7eb',
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                }}>
                                    <h6 style={{ color: '#374151', fontSize: '13px', fontWeight: '600', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <i className="ri-user-line" style={{ fontSize: '16px', color: '#6366f1' }}></i>
                                        Student Information
                                    </h6>
                                    <Row>
                                        <Col md="6">
                                            <div style={{ marginBottom: '8px' }}>
                                                <div style={{ fontSize: '11px', fontWeight: '600', color: '#6b7280', marginBottom: '4px' }}>Name</div>
                                                <div style={{ fontSize: '13px', color: '#111827' }}>{lunchPlanData.student.name}</div>
                                            </div>
                                        </Col>
                                        <Col md="6">
                                            <div>
                                                <div style={{ fontSize: '11px', fontWeight: '600', color: '#6b7280', marginBottom: '4px' }}>Email</div>
                                                <div style={{ fontSize: '13px', color: '#111827' }}>{lunchPlanData.student.email}</div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div style={{ textAlign: 'center', padding: '40px 20px', color: '#6c757d' }}>
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        );
    };

    const renderGameModal = () => (
        <Modal show={showGameModal} onHide={() => setShowGameModal(false)} size="lg" centered style={{ marginTop: 10 }}>
            <Modal.Header closeButton style={{ borderBottom: '1px solid #e9ecef', padding: '16px 50px 16px 20px' }}>
                <Modal.Title style={{ fontSize: '17px', fontWeight: '700', color: '#212529', lineHeight: '1.4', width: '100%', maxWidth: 'calc(100% - 40px)' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
                        <i className="material-symbols-outlined" style={{ fontSize: '20px', color: '#1e3a8a', flexShrink: 0 }}>
                            sports_esports
                        </i>
                        <span style={{ wordBreak: 'break-word', flex: '1' }}>Games - {selectedStudent?.name}</span>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '24px' }}>
                <div style={{ marginBottom: '24px', maxHeight: '50vh', overflowY: 'auto' }}>
                    <h6 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '12px' }}>Assigned Games</h6>
                    {gameData && Object.keys(gameData).length > 0 ? (
                        Object.entries(gameData).map(([key, value]) => (
                            <div key={key} style={{ marginBottom: '12px', padding: '12px', background: '#f8f9fa', borderRadius: '8px' }}>
                                <div style={{ fontSize: '12px', color: '#6c757d', marginBottom: '8px', textTransform: 'capitalize', fontWeight: '600' }}>
                                    {key.replace(/_/g, ' ')}
                                </div>
                                <div style={{ fontSize: '14px', color: '#212529' }}>
                                    {renderFieldValue(key, value)}
                                </div>
                            </div>
                        ))
                    ) : (
                        <div style={{ textAlign: 'center', padding: '20px', color: '#6c757d', background: '#f8f9fa', borderRadius: '8px' }}>
                            No games assigned yet
                        </div>
                    )}
                </div>
                <div>
                    <h6 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '12px' }}>Assign New Game</h6>
                    <Form.Group>
                        <Form.Label style={{ fontSize: '14px', fontWeight: '600' }}>Select Game</Form.Label>
                        <Form.Select
                            value={selectedGame}
                            onChange={(e) => setSelectedGame(e.target.value)}
                            style={{ fontSize: '14px', borderRadius: '8px', padding: '10px' }}
                        >
                            <option value="">-- Select a game --</option>
                            {gameNames.map((game) => (
                                <option key={game.id} value={game.id}>
                                    {game.name}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                    <Button
                        variant="primary"
                        onClick={assignGame}
                        disabled={!selectedGame}
                        style={{
                            marginTop: '12px',
                            borderRadius: '8px',
                            padding: '10px 24px',
                            fontSize: '14px',
                            fontWeight: '600',
                            background: '#1e3a8a',
                            border: 'none'
                        }}
                    >
                        <i className="material-symbols-outlined" style={{ fontSize: '16px', verticalAlign: 'middle', marginRight: '6px' }}>
                            add
                        </i>
                        Assign Game
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );

    const renderObservationViewModal = () => (
        <Modal show={showObservationViewModal} onHide={() => setShowObservationViewModal(false)} size="lg" centered
            style={{ marginTop: "50px", marginBottom: "50px" }}>
            <Modal.Header closeButton style={{
                borderBottom: '3px solid #8b5cf6',
                padding: '20px 24px',
                background: 'white'
            }}>
                <Modal.Title style={{
                    fontSize: '24px',
                    fontWeight: '800',
                    color: '#8b5cf6',
                    lineHeight: '1.2',
                    width: '100%',
                    maxWidth: 'calc(100% - 40px)'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                        <div style={{
                            background: '#8b5cf6',
                            borderRadius: '12px',
                            padding: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <i className="ri-eye-line" style={{ fontSize: '24px', color: 'white' }}></i>
                        </div>
                        <div>
                            <div style={{ fontSize: '24px', fontWeight: '800', marginBottom: '4px' }}>
                                View Observation
                            </div>
                            <div style={{ fontSize: '14px', opacity: 0.7, fontWeight: '500' }}>
                                {selectedStudent?.name} • {new Date(selectedDate).toLocaleDateString('en-US', {
                                    weekday: 'long',
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric'
                                })}
                            </div>
                        </div>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '32px', maxHeight: '60vh', overflowY: 'auto' }}>
                {observationData ? (
                    <div>
                        {observationData.notes || observationData.observation ? (
                            <div>
                                {/* Notes Section */}
                                {observationData.notes && (
                                    <div style={{ marginBottom: '24px' }}>
                                        <div style={{
                                            background: 'white',
                                            borderRadius: '20px',
                                            boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
                                            overflow: 'hidden'
                                        }}>
                                            <div style={{
                                                background: 'white',
                                                borderBottom: '3px solid #3498db',
                                                padding: '16px 20px',
                                                color: '#3498db'
                                            }}>
                                                <h6 style={{
                                                    fontSize: '18px',
                                                    fontWeight: '800',
                                                    marginBottom: '0',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '12px'
                                                }}>
                                                    <div style={{
                                                        background: '#3498db',
                                                        borderRadius: '12px',
                                                        padding: '8px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                        <i className="ri-sticky-note-line" style={{ fontSize: '20px', color: 'white' }}></i>
                                                    </div>
                                                    Notes
                                                </h6>
                                            </div>
                                            <div style={{ padding: '24px' }}>
                                                <div style={{
                                                    padding: '20px',
                                                    background: 'linear-gradient(135deg, #ebf8ff 0%, #dbeafe 100%)',
                                                    borderRadius: '12px',
                                                    border: '1px solid rgba(52, 152, 219, 0.2)',
                                                    fontSize: '16px',
                                                    lineHeight: '1.6',
                                                    color: '#374151',
                                                    fontWeight: '500',
                                                    whiteSpace: 'pre-wrap'
                                                }}>
                                                    {observationData.notes}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Observation Section */}
                                {observationData.observation && (
                                    <div style={{ marginBottom: '24px' }}>
                                        <div style={{
                                            background: 'white',
                                            borderRadius: '20px',
                                            boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
                                            overflow: 'hidden'
                                        }}>
                                            <div style={{
                                                background: 'white',
                                                borderBottom: '3px solid #e74c3c',
                                                padding: '16px 20px',
                                                color: '#e74c3c'
                                            }}>
                                                <h6 style={{
                                                    fontSize: '18px',
                                                    fontWeight: '800',
                                                    marginBottom: '0',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '12px'
                                                }}>
                                                    <div style={{
                                                        background: '#e74c3c',
                                                        borderRadius: '12px',
                                                        padding: '8px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                        <i className="ri-eye-line" style={{ fontSize: '20px', color: 'white' }}></i>
                                                    </div>
                                                    Detailed Observation
                                                </h6>
                                            </div>
                                            <div style={{ padding: '24px' }}>
                                                <div style={{
                                                    padding: '20px',
                                                    background: 'linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)',
                                                    borderRadius: '12px',
                                                    border: '1px solid rgba(231, 76, 60, 0.2)',
                                                    fontSize: '16px',
                                                    lineHeight: '1.6',
                                                    color: '#dc2626',
                                                    fontWeight: '500',
                                                    whiteSpace: 'pre-wrap'
                                                }}>
                                                    {observationData.observation}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div style={{
                                textAlign: 'center',
                                padding: '60px 20px',
                                background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
                                borderRadius: '20px',
                                border: '2px dashed #cbd5e1'
                            }}>
                                <div style={{
                                    background: '#64748b',
                                    borderRadius: '50%',
                                    width: '80px',
                                    height: '80px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    margin: '0 auto 20px',
                                    opacity: 0.7
                                }}>
                                    <i className="ri-file-search-line" style={{ fontSize: '36px', color: 'white' }}></i>
                                </div>
                                <h4 style={{ color: '#475569', marginBottom: '8px', fontSize: '20px', fontWeight: '700' }}>
                                    No Observation Available
                                </h4>
                                <p style={{ color: '#64748b', margin: '0', fontSize: '16px' }}>
                                    No observation data has been recorded for this student on this date.
                                </p>
                            </div>
                        )}
                    </div>
                ) : (
                    <div style={{
                        textAlign: 'center',
                        padding: '60px 20px',
                        background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
                        borderRadius: '20px'
                    }}>
                        <div style={{
                            background: '#0ea5e9',
                            borderRadius: '50%',
                            width: '60px',
                            height: '60px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto 20px',
                            animation: 'pulse 2s infinite'
                        }}>
                            <i className="ri-loader-4-line" style={{ fontSize: '24px', color: 'white' }}></i>
                        </div>
                        <h4 style={{ color: '#0369a1', marginBottom: '8px', fontSize: '18px', fontWeight: '700' }}>
                            Loading Observation...
                        </h4>
                        <p style={{ color: '#0ea5e9', margin: '0', fontSize: '14px' }}>
                            Please wait while we fetch the observation data.
                        </p>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );

    const renderDailyReportFormModal = () => (
        <Modal show={showDailyReportFormModal} onHide={handleCloseDailyReportModal} size="lg" centered
            style={{ marginTop: '20px', marginBottom: '20px' }}>
            <Modal.Header closeButton style={{
                borderBottom: '1px solid #e5e7eb',
                padding: '16px 20px',
                background: 'white'
            }}>
                <Modal.Title style={{
                    fontSize: '16px',
                    fontWeight: '700',
                    color: '#111827',
                    lineHeight: '1.3',
                    width: '100%',
                    maxWidth: 'calc(100% - 40px)'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div style={{
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            borderRadius: '8px',
                            padding: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <i className="ri-file-text-line" style={{ fontSize: '20px', color: 'white' }}></i>
                        </div>
                        <div>
                            <div style={{ fontSize: '16px', fontWeight: '700', marginBottom: '2px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                {isEditingDailyReport ? 'Edit Daily Report' : 'Create Daily Report'}
                                {isDraftMode && (
                                    <span style={{
                                        fontSize: '10px',
                                        fontWeight: '600',
                                        background: 'rgba(251, 191, 36, 0.9)',
                                        color: '#78350f',
                                        padding: '3px 8px',
                                        borderRadius: '4px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px'
                                    }}>
                                        <i className="ri-draft-line" style={{ fontSize: '10px', marginRight: '2px' }}></i>
                                        Draft
                                    </span>
                                )}
                            </div>
                            <div style={{ fontSize: '11px', opacity: 0.7, fontWeight: '400', color: '#6b7280' }}>
                                {selectedStudent?.name} • {new Date(selectedDate).toLocaleDateString('en-US', {
                                    month: 'short',
                                    day: 'numeric',
                                    year: 'numeric'
                                })}
                            </div>
                        </div>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{
                padding: '0',
                maxHeight: 'calc(75vh - 120px)',
                overflowY: 'auto',
                background: '#f8fafc'
            }}>
                <div style={{ padding: '12px' }}>
                    <Form>
                        {/* Today I Felt Section */}
                        <div style={{
                            marginBottom: '12px',
                            background: 'white',
                            borderRadius: '8px',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                            overflow: 'hidden',
                            border: '1px solid #e5e7eb'
                        }}>
                            <div style={{
                                background: 'white',
                                borderBottom: '1px solid #e5e7eb',
                                padding: '12px 16px'
                            }}>
                                <h6 style={{
                                    fontSize: '13px',
                                    fontWeight: '700',
                                    marginBottom: '0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    color: '#374151'
                                }}>
                                    <i className="ri-emotion-happy-line" style={{ fontSize: '16px', color: '#667eea' }}></i>
                                    Today I Felt
                                </h6>
                            </div>
                            <div style={{ padding: '16px' }}>
                                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                    <div
                                        onClick={() => setDailyReportFormData({ ...dailyReportFormData, feeling_id: 1 })}
                                        style={{
                                            flex: 1,
                                            minWidth: '110px',
                                            padding: '12px',
                                            background: dailyReportFormData.feeling_id === 1 ? '#667eea' : 'white',
                                            color: dailyReportFormData.feeling_id === 1 ? 'white' : '#6b7280',
                                            borderRadius: '8px',
                                            border: dailyReportFormData.feeling_id === 1 ? '2px solid #667eea' : '2px solid #e5e7eb',
                                            cursor: 'pointer',
                                            textAlign: 'center',
                                            transition: 'all 0.2s ease',
                                            boxShadow: dailyReportFormData.feeling_id === 1 ? '0 2px 8px rgba(102, 126, 234, 0.3)' : 'none'
                                        }}
                                    >
                                        <i className="ri-emotion-happy-line" style={{ fontSize: '24px', display: 'block', marginBottom: '4px' }}></i>
                                        <div style={{ fontSize: '12px', fontWeight: '600' }}>Happy</div>
                                    </div>
                                    <div
                                        onClick={() => setDailyReportFormData({ ...dailyReportFormData, feeling_id: 2 })}
                                        style={{
                                            flex: 1,
                                            minWidth: '110px',
                                            padding: '12px',
                                            background: dailyReportFormData.feeling_id === 2 ? '#667eea' : 'white',
                                            color: dailyReportFormData.feeling_id === 2 ? 'white' : '#6b7280',
                                            borderRadius: '8px',
                                            border: dailyReportFormData.feeling_id === 2 ? '2px solid #667eea' : '2px solid #e5e7eb',
                                            cursor: 'pointer',
                                            textAlign: 'center',
                                            transition: 'all 0.2s ease',
                                            boxShadow: dailyReportFormData.feeling_id === 2 ? '0 2px 8px rgba(102, 126, 234, 0.3)' : 'none'
                                        }}
                                    >
                                        <i className="ri-emotion-unhappy-line" style={{ fontSize: '24px', display: 'block', marginBottom: '4px' }}></i>
                                        <div style={{ fontSize: '12px', fontWeight: '600' }}>Sick</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Today I Learned Section */}
                        <div style={{
                            marginBottom: '12px',
                            background: 'white',
                            borderRadius: '8px',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                            overflow: 'hidden',
                            border: '1px solid #e5e7eb'
                        }}>
                            <div style={{
                                background: 'white',
                                borderBottom: '1px solid #e5e7eb',
                                padding: '12px 16px'
                            }}>
                                <h6 style={{
                                    fontSize: '13px',
                                    fontWeight: '700',
                                    marginBottom: '0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    color: '#374151'
                                }}>
                                    <i className="ri-lightbulb-line" style={{ fontSize: '16px', color: '#667eea' }}></i>
                                    Today I Learned
                                </h6>
                            </div>
                            <div style={{ padding: '16px' }}>
                                <Form.Control
                                    as="textarea"
                                    rows={2}
                                    placeholder="What did the student learn today?"
                                    value={dailyReportFormData.learned}
                                    onChange={(e) => setDailyReportFormData({ ...dailyReportFormData, learned: e.target.value })}
                                    style={{
                                        fontSize: '12px',
                                        borderRadius: '6px',
                                        border: '1px solid #e5e7eb',
                                        padding: '10px',
                                        fontFamily: 'inherit',
                                        transition: 'border-color 0.2s ease',
                                        resize: 'vertical'
                                    }}
                                    onFocus={(e) => e.target.style.borderColor = '#667eea'}
                                    onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                                />
                            </div>
                        </div>

                        {/* Diapers/Toilet Section */}
                        <div style={{
                            marginBottom: '12px',
                            background: 'white',
                            borderRadius: '8px',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                            overflow: 'hidden',
                            border: '1px solid #e5e7eb'
                        }}>
                            <div style={{
                                background: 'white',
                                borderBottom: '1px solid #e5e7eb',
                                padding: '12px 16px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}>
                                <h6 style={{
                                    fontSize: '13px',
                                    fontWeight: '700',
                                    marginBottom: '0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    color: '#374151'
                                }}>
                                    <i className="ri-baby-line" style={{ fontSize: '16px', color: '#667eea' }}></i>
                                    Diapers/Toilet
                                </h6>
                                <Button
                                    variant="primary"
                                    size="sm"
                                    onClick={() => setDailyReportFormData({
                                        ...dailyReportFormData,
                                        diapers: [...dailyReportFormData.diapers, { diaper_time: '', diaper_check: 1 }]
                                    })}
                                    style={{
                                        fontSize: '11px',
                                        fontWeight: '600',
                                        borderRadius: '6px',
                                        padding: '5px 10px',
                                        border: 'none',
                                        background: '#667eea'
                                    }}
                                >
                                    <i className="ri-add-line me-1"></i>
                                    Add Entry
                                </Button>
                            </div>
                            <div style={{ padding: '16px' }}>

                                {dailyReportFormData.diapers.length > 0 ? (
                                    <div style={{
                                        background: '#f9fafb',
                                        padding: '12px',
                                        borderRadius: '6px',
                                        border: '1px solid #e5e7eb'
                                    }}>
                                        <div style={{ overflowX: 'auto' }}>
                                            <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0 6px' }}>
                                                <thead>
                                                    <tr>
                                                        <th style={{
                                                            padding: '8px 10px',
                                                            fontSize: '11px',
                                                            fontWeight: '700',
                                                            color: '#374151',
                                                            background: 'white',
                                                            borderRadius: '8px 0 0 8px',
                                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                                        }}>Time</th>
                                                        <th style={{
                                                            padding: '8px 10px',
                                                            fontSize: '11px',
                                                            fontWeight: '700',
                                                            color: '#374151',
                                                            background: 'white',
                                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                                        }}>Check</th>
                                                        <th style={{
                                                            padding: '8px 10px',
                                                            fontSize: '11px',
                                                            fontWeight: '700',
                                                            color: '#374151',
                                                            background: 'white',
                                                            borderRadius: '0 8px 8px 0',
                                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                                        }}>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {dailyReportFormData.diapers.map((diaper, index) => (
                                                        <tr key={index}>
                                                            <td style={{
                                                                padding: '8px 10px',
                                                                background: 'white',
                                                                borderRadius: '8px 0 0 8px',
                                                                boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                                            }}>
                                                                <DatePicker
                                                                    selected={diaper.diaper_time ? Moment(diaper.diaper_time, 'HH:mm').toDate() : null}
                                                                    onChange={(time) => {
                                                                        const updatedDiapers = [...dailyReportFormData.diapers];
                                                                        updatedDiapers[index].diaper_time = time ? Moment(time).format('HH:mm') : '';
                                                                        setDailyReportFormData({ ...dailyReportFormData, diapers: updatedDiapers });
                                                                    }}
                                                                    showTimeSelect
                                                                    showTimeSelectOnly
                                                                    timeIntervals={15}
                                                                    timeCaption="Time"
                                                                    dateFormat="h:mm aa"
                                                                    placeholderText="Select time"
                                                                    className="form-control form-control-sm"
                                                                    style={{
                                                                        fontSize: '11px',
                                                                        border: '1px solid #e5e7eb',
                                                                        borderRadius: '6px',
                                                                        padding: '6px 8px',
                                                                        width: '100%'
                                                                    }}
                                                                />
                                                            </td>
                                                            <td style={{
                                                                padding: '8px 10px',
                                                                background: 'white',
                                                                boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                                            }}>
                                                                <Form.Select
                                                                    size="sm"
                                                                    value={diaper.diaper_check}
                                                                    onChange={(e) => {
                                                                        const updatedDiapers = [...dailyReportFormData.diapers];
                                                                        updatedDiapers[index].diaper_check = parseInt(e.target.value);
                                                                        setDailyReportFormData({ ...dailyReportFormData, diapers: updatedDiapers });
                                                                    }}
                                                                    style={{
                                                                        fontSize: '11px',
                                                                        border: '1px solid #e5e7eb',
                                                                        borderRadius: '6px',
                                                                        padding: '6px 8px'
                                                                    }}
                                                                >
                                                                    <option value={1}>D/T</option>
                                                                    <option value={2}>Dry</option>
                                                                    <option value={3}>Wet</option>
                                                                    <option value={4}>BM</option>
                                                                </Form.Select>
                                                            </td>
                                                            <td style={{
                                                                padding: '8px 10px',
                                                                background: 'white',
                                                                borderRadius: '0 8px 8px 0',
                                                                boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                                            }}>
                                                                <Button
                                                                    variant="outline-danger"
                                                                    size="sm"
                                                                    onClick={() => {
                                                                        const updatedDiapers = dailyReportFormData.diapers.filter((_, i) => i !== index);
                                                                        setDailyReportFormData({ ...dailyReportFormData, diapers: updatedDiapers });
                                                                    }}
                                                                    style={{
                                                                        fontSize: '10px',
                                                                        padding: '4px 8px',
                                                                        borderRadius: '6px',
                                                                        border: '1px solid #ef4444',
                                                                        color: '#ef4444'
                                                                    }}
                                                                >
                                                                    <i className="ri-delete-bin-line"></i>
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                ) : (
                                    <div style={{
                                        textAlign: 'center',
                                        padding: '25px 15px',
                                        color: '#6b7280',
                                        background: '#f9fafb',
                                        borderRadius: '10px',
                                        border: '2px dashed #d1d5db'
                                    }}>
                                        <i className="ri-baby-line" style={{ fontSize: '32px', opacity: 0.3, display: 'block', marginBottom: '8px' }}></i>
                                        <div style={{ fontSize: '13px', fontWeight: '600', marginBottom: '2px' }}>No diaper/toilet entries yet</div>
                                        <div style={{ fontSize: '11px', opacity: 0.7 }}>Click "Add Entry" to start tracking</div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Meals Section */}
                        <div style={{
                            marginBottom: '12px',
                            background: 'white',
                            borderRadius: '8px',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                            overflow: 'hidden',
                            border: '1px solid #e5e7eb'
                        }}>
                            <div style={{
                                background: 'white',
                                borderBottom: '1px solid #e5e7eb',
                                padding: '12px 16px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}>
                                <h6 style={{
                                    fontSize: '13px',
                                    fontWeight: '700',
                                    marginBottom: '0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    color: '#374151'
                                }}>
                                    <i className="ri-restaurant-line" style={{ fontSize: '16px', color: '#667eea' }}></i>
                                    Meals
                                </h6>
                                <Button
                                    variant="primary"
                                    size="sm"
                                    onClick={() => setDailyReportFormData({
                                        ...dailyReportFormData,
                                        meals: [...dailyReportFormData.meals, { meal_time: '', meal_type_id: 1, meal_amount: 50 }]
                                    })}
                                    style={{
                                        fontSize: '11px',
                                        fontWeight: '600',
                                        borderRadius: '6px',
                                        padding: '5px 10px',
                                        border: 'none',
                                        background: '#667eea'
                                    }}
                                >
                                    <i className="ri-add-line me-1"></i>
                                    Add Meal
                                </Button>
                            </div>
                            <div style={{ padding: '16px' }}>

                                {dailyReportFormData.meals.length > 0 ? (
                                    <div style={{
                                        background: '#f9fafb',
                                        padding: '12px',
                                        borderRadius: '6px',
                                        border: '1px solid #e5e7eb'
                                    }}>
                                        <div style={{ overflowX: 'auto' }}>
                                            <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0 6px' }}>
                                                <thead>
                                                    <tr>
                                                        <th style={{
                                                            padding: '8px 10px',
                                                            fontSize: '11px',
                                                            fontWeight: '700',
                                                            color: '#374151',
                                                            background: 'white',
                                                            borderRadius: '8px 0 0 8px',
                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                                        }}>Time</th>
                                                        <th style={{
                                                            padding: '8px 10px',
                                                            fontSize: '11px',
                                                            fontWeight: '700',
                                                            color: '#374151',
                                                            background: 'white',
                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                                        }}>Meal Type</th>
                                                        <th style={{
                                                            padding: '8px 10px',
                                                            fontSize: '11px',
                                                            fontWeight: '700',
                                                            color: '#374151',
                                                            background: 'white',
                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                                        }}>Amount (%)</th>
                                                        <th style={{
                                                            padding: '8px 10px',
                                                            fontSize: '11px',
                                                            fontWeight: '700',
                                                            color: '#374151',
                                                            background: 'white',
                                                            borderRadius: '0 8px 8px 0',
                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                                        }}>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {dailyReportFormData.meals.map((meal, index) => (
                                                        <tr key={index}>
                                                            <td style={{
                                                                padding: '8px 10px',
                                                                background: 'white',
                                                                borderRadius: '8px 0 0 8px',
                                                                boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                                            }}>
                                                                <DatePicker
                                                                    selected={meal.meal_time ? Moment(meal.meal_time, 'HH:mm').toDate() : null}
                                                                    onChange={(time) => {
                                                                        const updatedMeals = [...dailyReportFormData.meals];
                                                                        updatedMeals[index].meal_time = time ? Moment(time).format('HH:mm') : '';
                                                                        setDailyReportFormData({ ...dailyReportFormData, meals: updatedMeals });
                                                                    }}
                                                                    showTimeSelect
                                                                    showTimeSelectOnly
                                                                    timeIntervals={15}
                                                                    timeCaption="Time"
                                                                    dateFormat="h:mm aa"
                                                                    placeholderText="Select time"
                                                                    className="form-control form-control-sm"
                                                                    style={{
                                                                        fontSize: '11px',
                                                                        border: '1px solid #e5e7eb',
                                                                        borderRadius: '6px',
                                                                        padding: '6px 8px',
                                                                        width: '100%'
                                                                    }}
                                                                />
                                                            </td>
                                                            <td style={{
                                                                padding: '8px 10px',
                                                                background: 'white',
                                                                boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                                            }}>
                                                                <Form.Select
                                                                    size="sm"
                                                                    value={meal.meal_type_id}
                                                                    onChange={(e) => {
                                                                        const updatedMeals = [...dailyReportFormData.meals];
                                                                        updatedMeals[index].meal_type_id = parseInt(e.target.value);
                                                                        setDailyReportFormData({ ...dailyReportFormData, meals: updatedMeals });
                                                                    }}
                                                                    style={{
                                                                        fontSize: '11px',
                                                                        border: '1px solid #e5e7eb',
                                                                        borderRadius: '6px',
                                                                        padding: '6px 8px'
                                                                    }}
                                                                >
                                                                    <option value={1}>Morning Snack</option>
                                                                    <option value={2}>Lunch</option>
                                                                    <option value={3}>Afternoon Snack</option>
                                                                    <option value={4}>Dinner</option>
                                                                </Form.Select>
                                                            </td>
                                                            <td style={{
                                                                padding: '8px 10px',
                                                                background: 'white',
                                                                boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                                            }}>
                                                                <Form.Control
                                                                    type="number"
                                                                    size="sm"
                                                                    value={meal.meal_amount}
                                                                    onChange={(e) => {
                                                                        const updatedMeals = [...dailyReportFormData.meals];
                                                                        updatedMeals[index].meal_amount = parseInt(e.target.value) || 0;
                                                                        setDailyReportFormData({ ...dailyReportFormData, meals: updatedMeals });
                                                                    }}
                                                                    style={{
                                                                        fontSize: '11px',
                                                                        border: '1px solid #e5e7eb',
                                                                        borderRadius: '6px',
                                                                        padding: '6px 8px'
                                                                    }}
                                                                    min="0"
                                                                    max="100"
                                                                    placeholder="%"
                                                                />
                                                            </td>
                                                            <td style={{
                                                                padding: '8px 10px',
                                                                background: 'white',
                                                                borderRadius: '0 8px 8px 0',
                                                                boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                                            }}>
                                                                <Button
                                                                    variant="outline-danger"
                                                                    size="sm"
                                                                    onClick={() => {
                                                                        const updatedMeals = dailyReportFormData.meals.filter((_, i) => i !== index);
                                                                        setDailyReportFormData({ ...dailyReportFormData, meals: updatedMeals });
                                                                    }}
                                                                    style={{
                                                                        fontSize: '10px',
                                                                        padding: '4px 8px',
                                                                        borderRadius: '6px',
                                                                        border: '1px solid #ef4444',
                                                                        color: '#ef4444'
                                                                    }}
                                                                >
                                                                    <i className="ri-delete-bin-line"></i>
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                ) : (
                                    <div style={{
                                        textAlign: 'center',
                                        padding: '25px 15px',
                                        color: '#6b7280',
                                        background: '#f9fafb',
                                        borderRadius: '10px',
                                        border: '2px dashed #d1d5db'
                                    }}>
                                        <i className="ri-restaurant-line" style={{ fontSize: '32px', opacity: 0.3, display: 'block', marginBottom: '8px' }}></i>
                                        <div style={{ fontSize: '13px', fontWeight: '600', marginBottom: '2px' }}>No meal entries yet</div>
                                        <div style={{ fontSize: '11px', opacity: 0.7 }}>Click "Add Meal" to start tracking</div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Sleep Section */}
                        <div style={{
                            marginBottom: '12px',
                            background: 'white',
                            borderRadius: '8px',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                            overflow: 'hidden',
                            border: '1px solid #e5e7eb'
                        }}>
                            <div style={{
                                background: 'white',
                                borderBottom: '1px solid #e5e7eb',
                                padding: '12px 16px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}>
                                <h6 style={{
                                    fontSize: '13px',
                                    fontWeight: '700',
                                    marginBottom: '0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    color: '#374151'
                                }}>
                                    <i className="ri-zzz-line" style={{ fontSize: '16px', color: '#667eea' }}></i>
                                    Sleep
                                </h6>
                                <Button
                                    variant="primary"
                                    size="sm"
                                    onClick={() => setDailyReportFormData({
                                        ...dailyReportFormData,
                                        sleeps: [...dailyReportFormData.sleeps, { start_time: '', end_time: '' }]
                                    })}
                                    style={{
                                        fontSize: '11px',
                                        fontWeight: '600',
                                        borderRadius: '6px',
                                        padding: '5px 10px',
                                        border: 'none',
                                        background: '#667eea'
                                    }}
                                >
                                    <i className="ri-add-line me-1"></i>
                                    Add Sleep
                                </Button>
                            </div>
                            <div style={{ padding: '16px' }}>
                                {dailyReportFormData.sleeps.length > 0 ? (
                                    <div style={{
                                        background: '#f9fafb',
                                        padding: '12px',
                                        borderRadius: '6px',
                                        border: '1px solid #e5e7eb'
                                    }}>
                                        <div style={{ overflowX: 'auto' }}>
                                            <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0 6px' }}>
                                                <thead>
                                                    <tr>
                                                        <th style={{
                                                            padding: '8px 10px',
                                                            fontSize: '11px',
                                                            fontWeight: '700',
                                                            color: '#374151',
                                                            background: 'white',
                                                            borderRadius: '8px 0 0 8px',
                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                                        }}>Start Time</th>
                                                        <th style={{
                                                            padding: '8px 10px',
                                                            fontSize: '11px',
                                                            fontWeight: '700',
                                                            color: '#374151',
                                                            background: 'white',
                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                                        }}>End Time</th>
                                                        <th style={{
                                                            padding: '8px 10px',
                                                            fontSize: '11px',
                                                            fontWeight: '700',
                                                            color: '#374151',
                                                            background: 'white',
                                                            borderRadius: '0 8px 8px 0',
                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                                        }}>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {dailyReportFormData.sleeps.map((sleep, index) => (
                                                        <tr key={index}>
                                                            <td style={{
                                                                padding: '8px 10px',
                                                                background: 'white',
                                                                borderRadius: '8px 0 0 8px',
                                                                boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                                            }}>
                                                                <DatePicker
                                                                    selected={sleep.start_time ? Moment(sleep.start_time, 'HH:mm').toDate() : null}
                                                                    onChange={(time) => {
                                                                        const updatedSleeps = [...dailyReportFormData.sleeps];
                                                                        updatedSleeps[index].start_time = time ? Moment(time).format('HH:mm') : '';
                                                                        setDailyReportFormData({ ...dailyReportFormData, sleeps: updatedSleeps });
                                                                    }}
                                                                    showTimeSelect
                                                                    showTimeSelectOnly
                                                                    timeIntervals={15}
                                                                    timeCaption="Time"
                                                                    dateFormat="h:mm aa"
                                                                    placeholderText="Start time"
                                                                    className="form-control form-control-sm"
                                                                    style={{
                                                                        fontSize: '11px',
                                                                        border: '1px solid #e5e7eb',
                                                                        borderRadius: '6px',
                                                                        padding: '6px 8px',
                                                                        width: '100%'
                                                                    }}
                                                                />
                                                            </td>
                                                            <td style={{
                                                                padding: '8px 10px',
                                                                background: 'white',
                                                                boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                                            }}>
                                                                <DatePicker
                                                                    selected={sleep.end_time ? Moment(sleep.end_time, 'HH:mm').toDate() : null}
                                                                    onChange={(time) => {
                                                                        const updatedSleeps = [...dailyReportFormData.sleeps];
                                                                        updatedSleeps[index].end_time = time ? Moment(time).format('HH:mm') : '';
                                                                        setDailyReportFormData({ ...dailyReportFormData, sleeps: updatedSleeps });
                                                                    }}
                                                                    showTimeSelect
                                                                    showTimeSelectOnly
                                                                    timeIntervals={15}
                                                                    timeCaption="Time"
                                                                    dateFormat="h:mm aa"
                                                                    placeholderText="End time"
                                                                    className="form-control form-control-sm"
                                                                    style={{
                                                                        fontSize: '11px',
                                                                        border: '1px solid #e5e7eb',
                                                                        borderRadius: '6px',
                                                                        padding: '6px 8px',
                                                                        width: '100%'
                                                                    }}
                                                                />
                                                            </td>
                                                            <td style={{
                                                                padding: '8px 10px',
                                                                background: 'white',
                                                                borderRadius: '0 8px 8px 0',
                                                                boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                                            }}>
                                                                <Button
                                                                    variant="outline-danger"
                                                                    size="sm"
                                                                    onClick={() => {
                                                                        const updatedSleeps = dailyReportFormData.sleeps.filter((_, i) => i !== index);
                                                                        setDailyReportFormData({ ...dailyReportFormData, sleeps: updatedSleeps });
                                                                    }}
                                                                    style={{
                                                                        fontSize: '10px',
                                                                        padding: '4px 8px',
                                                                        borderRadius: '6px',
                                                                        border: '1px solid #ef4444',
                                                                        color: '#ef4444'
                                                                    }}
                                                                >
                                                                    <i className="ri-delete-bin-line"></i>
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                ) : (
                                    <div style={{
                                        textAlign: 'center',
                                        padding: '25px 15px',
                                        color: '#6b7280',
                                        background: '#f9fafb',
                                        borderRadius: '10px',
                                        border: '2px dashed #d1d5db'
                                    }}>
                                        <i className="ri-zzz-line" style={{ fontSize: '32px', opacity: 0.3, display: 'block', marginBottom: '8px' }}></i>
                                        <div style={{ fontSize: '13px', fontWeight: '600', marginBottom: '2px' }}>No sleep entries yet</div>
                                        <div style={{ fontSize: '11px', opacity: 0.7 }}>Click "Add Sleep" to start tracking</div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Please Bring More Section */}
                        <div style={{
                            marginBottom: '12px',
                            background: 'white',
                            borderRadius: '8px',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                            overflow: 'hidden',
                            border: '1px solid #e5e7eb'
                        }}>
                            <div style={{
                                background: 'white',
                                borderBottom: '1px solid #e5e7eb',
                                padding: '12px 16px'
                            }}>
                                <h6 style={{
                                    fontSize: '13px',
                                    fontWeight: '700',
                                    marginBottom: '0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    color: '#374151'
                                }}>
                                    <i className="ri-shopping-bag-line" style={{ fontSize: '16px', color: '#667eea' }}></i>
                                    Please Bring More
                                </h6>
                            </div>
                            <div style={{ padding: '16px' }}>
                                <Row>
                                    <Col md={6}>
                                        {[
                                            { key: 'bring_diapers', label: 'Diapers', icon: 'ri-baby-line' },
                                            { key: 'bring_ointment', label: 'Ointment', icon: 'ri-medicine-bottle-line' },
                                            { key: 'bring_blanket', label: 'Blanket', icon: 'ri-hotel-bed-line' }
                                        ].map((item) => (
                                            <div
                                                key={item.key}
                                                onClick={() => setDailyReportFormData({
                                                    ...dailyReportFormData,
                                                    [item.key]: !dailyReportFormData[item.key]
                                                })}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px',
                                                    padding: '8px',
                                                    background: dailyReportFormData[item.key] ? '#f3f4f6' : 'white',
                                                    color: '#374151',
                                                    borderRadius: '6px',
                                                    cursor: 'pointer',
                                                    marginBottom: '6px',
                                                    border: dailyReportFormData[item.key] ? '2px solid #667eea' : '1px solid #e5e7eb',
                                                    transition: 'all 0.2s ease'
                                                }}
                                            >
                                                <div style={{
                                                    width: '20px',
                                                    height: '20px',
                                                    borderRadius: '5px',
                                                    background: dailyReportFormData[item.key] ? '#667eea' : '#e5e7eb',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}>
                                                    {dailyReportFormData[item.key] ? (
                                                        <i className="ri-check-line" style={{ fontSize: '13px', color: 'white' }}></i>
                                                    ) : (
                                                        <i className={item.icon} style={{ fontSize: '13px', color: '#9ca3af' }}></i>
                                                    )}
                                                </div>
                                                <span style={{ fontSize: '13px', fontWeight: '600', flex: 1 }}>{item.label}</span>
                                            </div>
                                        ))}
                                    </Col>
                                    <Col md={6}>
                                        {[
                                            { key: 'bring_wipes', label: 'Wipes', icon: 'ri-drop-line' },
                                            { key: 'bring_clothes', label: 'Clothes', icon: 'ri-shirt-line' }
                                        ].map((item) => (
                                            <div
                                                key={item.key}
                                                onClick={() => setDailyReportFormData({
                                                    ...dailyReportFormData,
                                                    [item.key]: !dailyReportFormData[item.key]
                                                })}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px',
                                                    padding: '8px',
                                                    background: dailyReportFormData[item.key] ? '#f3f4f6' : 'white',
                                                    color: '#374151',
                                                    borderRadius: '6px',
                                                    cursor: 'pointer',
                                                    marginBottom: '6px',
                                                    border: dailyReportFormData[item.key] ? '2px solid #667eea' : '1px solid #e5e7eb',
                                                    transition: 'all 0.2s ease'
                                                }}
                                            >
                                                <div style={{
                                                    width: '20px',
                                                    height: '20px',
                                                    borderRadius: '5px',
                                                    background: dailyReportFormData[item.key] ? '#667eea' : '#e5e7eb',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}>
                                                    {dailyReportFormData[item.key] ? (
                                                        <i className="ri-check-line" style={{ fontSize: '13px', color: 'white' }}></i>
                                                    ) : (
                                                        <i className={item.icon} style={{ fontSize: '13px', color: '#9ca3af' }}></i>
                                                    )}
                                                </div>
                                                <span style={{ fontSize: '13px', fontWeight: '600', flex: 1 }}>{item.label}</span>
                                            </div>
                                        ))}
                                    </Col>
                                </Row>
                                <div style={{ marginTop: '10px' }}>
                                    <Form.Group>
                                        <Form.Label style={{ color: '#374151', fontSize: '12px', fontWeight: '600', marginBottom: '6px' }}>Other Item</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Specify other item..."
                                            value={dailyReportFormData.other_item}
                                            onChange={(e) => setDailyReportFormData({ ...dailyReportFormData, other_item: e.target.value })}
                                            style={{
                                                fontSize: '12px',
                                                borderRadius: '8px',
                                                border: '1px solid #e0e0e0',
                                                padding: '8px',
                                                fontFamily: 'inherit',
                                                transition: 'border-color 0.2s ease'
                                            }}
                                            onFocus={(e) => e.target.style.borderColor = '#f59e0b'}
                                            onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
                                        />
                                    </Form.Group>
                                </div>
                            </div>
                        </div>

                        {/* Comments Section */}
                        <div style={{
                            marginBottom: '12px',
                            background: 'white',
                            borderRadius: '8px',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                            overflow: 'hidden',
                            border: '1px solid #e5e7eb'
                        }}>
                            <div style={{
                                background: 'white',
                                borderBottom: '1px solid #e5e7eb',
                                padding: '12px 16px'
                            }}>
                                <h6 style={{
                                    fontSize: '13px',
                                    fontWeight: '700',
                                    marginBottom: '0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    color: '#374151'
                                }}>
                                    <i className="ri-chat-3-line" style={{ fontSize: '16px', color: '#667eea' }}></i>
                                    Comments
                                </h6>
                            </div>
                            <div style={{ padding: '16px' }}>
                                <Form.Control
                                    as="textarea"
                                    rows={2}
                                    placeholder="Additional comments..."
                                    value={dailyReportFormData.comments}
                                    onChange={(e) => setDailyReportFormData({ ...dailyReportFormData, comments: e.target.value })}
                                    style={{
                                        fontSize: '12px',
                                        borderRadius: '6px',
                                        border: '1px solid #e5e7eb',
                                        padding: '10px',
                                        fontFamily: 'inherit',
                                        transition: 'border-color 0.2s ease',
                                        resize: 'vertical'
                                    }}
                                    onFocus={(e) => e.target.style.borderColor = '#667eea'}
                                    onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                                />
                            </div>
                        </div>
                    </Form>
                </div>
            </Modal.Body>
            <Modal.Footer style={{
                borderTop: '2px solid #f0f0f0',
                padding: '12px 16px',
                background: 'white',
                display: 'flex',
                gap: '10px',
                position: 'sticky',
                bottom: 0,
                zIndex: 10,
                justifyContent: 'flex-end',
                flexWrap: 'wrap'
            }}>
                <Button
                    variant="outline-warning"
                    onClick={() => saveDailyReport(true)}
                    style={{
                        borderRadius: '8px',
                        padding: '10px 20px',
                        fontSize: '13px',
                        fontWeight: '600',
                        border: '2px solid #f59e0b',
                        color: '#f59e0b',
                        background: 'white',
                        minWidth: '140px'
                    }}
                >
                    <i className="ri-draft-line me-1" style={{ fontSize: '14px' }}></i>
                    Save as Draft
                </Button>
                <Button
                    variant="primary"
                    onClick={() => saveDailyReport(false)}
                    style={{
                        borderRadius: '8px',
                        padding: '10px 24px',
                        fontSize: '13px',
                        fontWeight: '600',
                        minWidth: '140px'
                    }}
                >
                    <i className="ri-send-plane-fill me-1" style={{ fontSize: '14px' }}></i>
                    {isEditingDailyReport ? 'Publish Report' : 'Publish Report'}
                </Button>
            </Modal.Footer>
        </Modal>
    );

    const renderMedicationModal = () => (
        <Modal show={showMedicationModal} onHide={() => setShowMedicationModal(false)} size="xl" centered
            style={{ marginTop: "30px" }}>
            <Modal.Header closeButton style={{
                borderBottom: '1px solid #e5e7eb',
                padding: '16px 20px',
                background: 'white'
            }}>
                <Modal.Title style={{
                    fontSize: '16px',
                    fontWeight: '700',
                    color: '#111827',
                    lineHeight: '1.3',
                    width: '100%',
                    maxWidth: 'calc(100% - 40px)'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <i className="ri-medicine-bottle-line" style={{ fontSize: '20px', color: '#6366f1' }}></i>
                            <div>
                                <div style={{ fontSize: '15px', fontWeight: '700', color: '#111827' }}>
                                    Medication Overview
                                </div>
                                <div style={{ fontSize: '11px', color: '#6b7280', fontWeight: '500' }}>
                                    {medicationData?.first_name} {medicationData?.last_name}
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '16px', background: '#f9fafb', maxHeight: '65vh', overflowY: 'auto' }}>
                {medicationData ? (
                    <Row>
                        <Col md={12}>
                            <Card style={{
                                borderRadius: '8px',
                                border: '1px solid #e5e7eb',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                marginBottom: '16px',
                                background: 'white'
                            }}>
                                <Card.Header style={{
                                    background: 'white',
                                    borderBottom: '1px solid #e5e7eb',
                                    borderRadius: '8px 8px 0 0',
                                    padding: '12px 16px',
                                    fontSize: '13px',
                                    fontWeight: '700',
                                    color: '#374151'
                                }}>
                                    <i className="ri-medicine-bottle-fill me-2" style={{ color: '#6366f1' }}></i>
                                    Medication Information
                                </Card.Header>
                                <Card.Body style={{ padding: '16px' }}>
                                    <Row>
                                        <Col md={6}>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Student Name
                                                </div>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                                                    {medicationData.first_name} {medicationData.last_name}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Parent Name
                                                </div>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                                                    {medicationData.parent_name || 'N/A'}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Medication Name
                                                </div>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#667eea' }}>
                                                    {medicationData.medication_name || 'Not specified'}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Times to be Administered
                                                </div>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                                                    {medicationData.times_to_be_administered || 'Not specified'}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Date Range
                                                </div>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                                                    {medicationData.date_start !== 'N/A' ? Moment(medicationData.date_start).format('MMM D YYYY') : 'N/A'} to {medicationData.date_end !== 'N/A' ? Moment(medicationData.date_end).format('MMM D YYYY') : 'N/A'}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Expiry Date
                                                </div>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                                                    {medicationData.expiry_date && medicationData.expiry_date !== 'N/A' ? Moment(medicationData.expiry_date).format('MMM D YYYY') : 'N/A'}
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Reason for Administering
                                                </div>
                                                <div style={{ fontSize: '13px', color: '#666', lineHeight: '1.5' }}>
                                                    {medicationData.reason_for_administering || 'No reason specified'}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Parent's Consent & Instructions
                                                </div>
                                                <div style={{ fontSize: '13px', color: '#666', lineHeight: '1.5' }}>
                                                    {medicationData.parents_consent_and_instruction || 'No instructions provided'}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Additional Instructions
                                                </div>
                                                <div style={{ fontSize: '13px', color: '#666', lineHeight: '1.5' }}>
                                                    {medicationData.additional_instructions || 'No additional instructions'}
                                                </div>
                                            </div>
                                            {medicationData.signiture_of_parent && medicationData.signiture_of_parent !== 'null' && medicationData.signiture_of_parent !== '' && (
                                                <div style={{ marginBottom: '15px' }}>
                                                    <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                        Parent Signature
                                                    </div>
                                                    <img 
                                                        src={medicationData.signiture_of_parent} 
                                                        alt="Parent Signature" 
                                                        onError={(e) => { e.target.style.display = 'none'; }}
                                                        style={{ maxWidth: '200px', maxHeight: '100px', border: '1px solid #dee2e6', borderRadius: '4px', padding: '8px', background: 'white', display: 'block' }}
                                                    />
                                                    <div style={{ fontSize: '12px', color: '#999', marginTop: '4px' }}>
                                                        Signed on: {medicationData.signature_date}
                                                    </div>
                                                </div>
                                            )}
                                            {medicationData.doctor_note && (
                                                <div style={{ marginBottom: '15px' }}>
                                                    <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                        Doctor's Note
                                                    </div>
                                                    <a href={medicationData.doctor_note} target="_blank" rel="noopener noreferrer" style={{ fontSize: '13px', color: '#667eea' }}>
                                                        <i className="ri-file-text-line me-1"></i>
                                                        View Doctor's Note
                                                    </a>
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={12}>
                            <Card style={{
                                borderRadius: '12px',
                                border: 'none',
                                boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                            }}>
                                <Card.Header style={{
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    color: 'white',
                                    borderRadius: '12px 12px 0 0',
                                    padding: '16px 20px',
                                    fontSize: '18px',
                                    fontWeight: '600',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                }}>
                                    <span>
                                        <i className="ri-file-list-line me-2"></i>
                                        Medication Log
                                    </span>
                                    <Button
                                        variant="light"
                                        size="sm"
                                        onClick={() => {
                                            setIsEditingMedicationLog(false);
                                            setMedicationLogData({
                                                medication_date: new Date().toISOString().split('T')[0],
                                                medication: medicationData.medication_name || '',
                                                is_dosage_given: 1,
                                                time_given: new Date().toTimeString().slice(0, 5),
                                                staff_signiture: '',
                                                comments: ''
                                            });
                                            if (medicationSignaturePadRef.current) {
                                                medicationSignaturePadRef.current.clear();
                                            }
                                            setShowMedicationLogFormModal(true);
                                        }}
                                        style={{
                                            borderRadius: '8px',
                                            fontWeight: '600',
                                            padding: '6px 16px'
                                        }}
                                    >
                                        <i className="ri-add-line me-1"></i>
                                        Add Log Entry
                                    </Button>
                                </Card.Header>
                                <Card.Body style={{ padding: '0' }}>
                                    {medicationLogs && medicationLogs.length > 0 ? (
                                        <div style={{ overflowX: 'auto' }}>
                                            <Table hover style={{ margin: 0 }}>
                                                <thead style={{
                                                    background: '#f8f9fa',
                                                    borderBottom: '2px solid #dee2e6'
                                                }}>
                                                    <tr>
                                                        <th style={{ padding: '16px', fontWeight: '600', color: '#333' }}>Date</th>
                                                        <th style={{ padding: '16px', fontWeight: '600', color: '#333' }}>Medication</th>
                                                        <th style={{ padding: '16px', fontWeight: '600', color: '#333' }}>Dosage Given</th>
                                                        <th style={{ padding: '16px', fontWeight: '600', color: '#333' }}>Time</th>
                                                        <th style={{ padding: '16px', fontWeight: '600', color: '#333' }}>Staff Signature</th>
                                                        <th style={{ padding: '16px', fontWeight: '600', color: '#333' }}>Comments</th>
                                                        <th style={{ padding: '16px', fontWeight: '600', color: '#333', textAlign: 'center' }}>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {medicationLogs.map((log, index) => (
                                                        <tr key={index} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                                            <td style={{ padding: '16px', color: '#333' }}>
                                                                {log.medication_date ? Moment(log.medication_date).format('MMM D YYYY') : 'N/A'}
                                                            </td>
                                                            <td style={{ padding: '16px', color: '#333', fontWeight: '600' }}>
                                                                {log.medication || 'N/A'}
                                                            </td>
                                                            <td style={{ padding: '16px', textAlign: 'center' }}>
                                                                <span style={{
                                                                    padding: '4px 12px',
                                                                    borderRadius: '12px',
                                                                    fontSize: '12px',
                                                                    fontWeight: '600',
                                                                    background: log.is_dosage_given === 1 || log.is_dosage_given === '1' ? '#d1fae5' : '#fee2e2',
                                                                    color: log.is_dosage_given === 1 || log.is_dosage_given === '1' ? '#065f46' : '#991b1b'
                                                                }}>
                                                                    {log.is_dosage_given === 1 || log.is_dosage_given === '1' ? 'Yes' : 'No'}
                                                                </span>
                                                            </td>
                                                            <td style={{ padding: '16px', color: '#333' }}>
                                                                {log.time_given ? Moment(log.time_given, 'HH:mm:ss').format('h:mm A') : 'N/A'}
                                                            </td>
                                                            <td style={{ padding: '16px', color: '#333' }}>
                                                                {log.staff_signiture ? (
                                                                    <img 
                                                                        src={log.staff_signiture} 
                                                                        alt="Staff Signature" 
                                                                        style={{ maxWidth: '80px', maxHeight: '40px' }}
                                                                    />
                                                                ) : 'N/A'}
                                                            </td>
                                                            <td style={{ padding: '16px', color: '#666', maxWidth: '200px' }}>
                                                                {log.comments && log.comments.length > 40
                                                                    ? `${log.comments.substring(0, 40)}...`
                                                                    : log.comments || '-'
                                                                }
                                                            </td>
                                                            <td style={{ padding: '16px', textAlign: 'center' }}>
                                                                <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                                                                    <Button
                                                                        variant="outline-primary"
                                                                        size="sm"
                                                                        onClick={() => {
                                                                            setSelectedMedicationLog(log);
                                                                            setShowMedicationLogViewModal(true);
                                                                        }}
                                                                        style={{ borderRadius: '6px' }}
                                                                        title="View Log"
                                                                    >
                                                                        <i className="ri-eye-line"></i>
                                                                    </Button>
                                                                    <Button
                                                                        variant="outline-success"
                                                                        size="sm"
                                                                        onClick={() => editMedicationLog(log)}
                                                                        style={{ borderRadius: '6px' }}
                                                                        title="Edit Log"
                                                                    >
                                                                        <i className="ri-edit-line"></i>
                                                                    </Button>
                                                                    <Button
                                                                        variant="outline-danger"
                                                                        size="sm"
                                                                        onClick={() => deleteMedicationLog(log.id, medicationData.medication_id || medicationData.id)}
                                                                        style={{ borderRadius: '6px' }}
                                                                        title="Delete Log"
                                                                    >
                                                                        <i className="ri-delete-bin-line"></i>
                                                                    </Button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>
                                    ) : (
                                        <div style={{
                                            padding: '40px',
                                            textAlign: 'center',
                                            color: '#666'
                                        }}>
                                            <i className="ri-medicine-bottle-line" style={{ fontSize: '48px', color: '#ccc', marginBottom: '16px' }}></i>
                                            <p style={{ fontSize: '16px', marginBottom: '8px' }}>No medication logs found</p>
                                            <p style={{ fontSize: '14px', color: '#999' }}>
                                                Click "Add Log Entry" to record medication administration
                                            </p>
                                        </div>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                ) : (
                    <div style={{ textAlign: 'center', padding: '40px' }}>
                        <i className="ri-medicine-bottle-line" style={{ fontSize: '48px', color: '#ccc', marginBottom: '16px' }}></i>
                        <p>No medication data available</p>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );

    const renderMedicationLogFormModal = () => (
        <Modal show={showMedicationLogFormModal} onHide={() => {
            setShowMedicationLogFormModal(false);
            setIsEditingMedicationLog(false);
            if (medicationSignaturePadRef.current) {
                medicationSignaturePadRef.current.clear();
            }
        }} centered
            style={{ marginTop: "30px" }}>
            <Modal.Header closeButton style={{
                borderBottom: '1px solid #e5e7eb',
                padding: '16px 20px',
                background: 'white'
            }}>
                <Modal.Title style={{
                    fontSize: '15px',
                    fontWeight: '700',
                    color: '#111827'
                }}>
                    <i className={isEditingMedicationLog ? "ri-edit-line me-2" : "ri-add-circle-line me-2"} style={{ fontSize: '16px', color: '#6366f1' }}></i>
                    {isEditingMedicationLog ? 'Edit Medication Log' : 'Add Medication Log'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '20px', background: 'white' }}>
                <Form>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label style={{ fontWeight: '600', color: '#374151', marginBottom: '6px', fontSize: '13px' }}>
                                    <span style={{ color: '#dc3545' }}>* </span>Medication Date
                                </Form.Label>
                                <DatePicker
                                    selected={medicationLogData.medication_date ? Moment(medicationLogData.medication_date).toDate() : null}
                                    onChange={(date) => setMedicationLogData({
                                        ...medicationLogData,
                                        medication_date: date ? Moment(date).format('YYYY-MM-DD') : ''
                                    })}
                                    dateFormat="MMM d yyyy"
                                    placeholderText="Dec 17 2025"
                                    className="form-control"
                                    required
                                    style={{
                                        borderRadius: '6px',
                                        border: '1px solid #e5e7eb',
                                        padding: '10px 12px',
                                        fontSize: '13px',
                                        width: '100%'
                                    }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label style={{ fontWeight: '600', color: '#374151', marginBottom: '6px', fontSize: '13px' }}>
                                    Time Given
                                </Form.Label>
                                <DatePicker
                                    selected={medicationLogData.time_given ? Moment(medicationLogData.time_given, 'HH:mm').toDate() : null}
                                    onChange={(time) => setMedicationLogData({
                                        ...medicationLogData,
                                        time_given: time ? Moment(time).format('HH:mm') : ''
                                    })}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={15}
                                    timeCaption="Time"
                                    dateFormat="h:mm aa"
                                    placeholderText="2:30 PM"
                                    className="form-control"
                                    style={{
                                        borderRadius: '6px',
                                        border: '1px solid #e5e7eb',
                                        padding: '10px 12px',
                                        fontSize: '13px',
                                        width: '100%'
                                    }}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Form.Group className="mb-3">
                        <Form.Label style={{ fontWeight: '600', color: '#374151', marginBottom: '6px', fontSize: '13px' }}>
                            <span style={{ color: '#dc3545' }}>* </span>Medication
                        </Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter medication name"
                            value={medicationLogData.medication}
                            onChange={(e) => setMedicationLogData({
                                ...medicationLogData,
                                medication: e.target.value
                            })}
                            required
                            style={{
                                borderRadius: '6px',
                                border: '1px solid #e5e7eb',
                                padding: '10px 12px',
                                fontSize: '13px'
                            }}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={{ fontWeight: '600', color: '#333', marginBottom: '8px' }}>
                            <span style={{ color: '#dc3545' }}>* </span>Is Dosage Given?
                        </Form.Label>
                        <div style={{ display: 'flex', gap: '20px', padding: '12px 0' }}>
                            <Form.Check
                                type="radio"
                                label="Yes"
                                name="is_dosage_given"
                                checked={medicationLogData.is_dosage_given === 1 || medicationLogData.is_dosage_given === '1'}
                                onChange={() => setMedicationLogData({
                                    ...medicationLogData,
                                    is_dosage_given: 1
                                })}
                                style={{ fontSize: '14px', fontWeight: '500' }}
                            />
                            <Form.Check
                                type="radio"
                                label="No"
                                name="is_dosage_given"
                                checked={medicationLogData.is_dosage_given === 0 || medicationLogData.is_dosage_given === '0'}
                                onChange={() => setMedicationLogData({
                                    ...medicationLogData,
                                    is_dosage_given: 0
                                })}
                                style={{ fontSize: '14px', fontWeight: '500' }}
                            />
                        </div>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={{ fontWeight: '600', color: '#333', marginBottom: '8px' }}>
                            Staff Signature (Optional)
                        </Form.Label>
                        {medicationLogData.staff_signiture && medicationLogData.staff_signiture !== 'null' && medicationLogData.staff_signiture !== '' ? (
                            <div className="mb-2">
                                <img 
                                    src={medicationLogData.staff_signiture} 
                                    alt="Existing Signature" 
                                    style={{ 
                                        maxWidth: '200px', 
                                        maxHeight: '80px',
                                        border: '1px solid #e9ecef',
                                        borderRadius: '8px',
                                        padding: '8px',
                                        background: 'white'
                                    }}
                                    onError={(e) => { e.target.style.display = 'none'; }}
                                />
                                <div className="text-muted small mt-1">Existing signature (will be replaced if you draw a new one)</div>
                            </div>
                        ) : null}
                        <div style={{ 
                            border: '2px solid #e9ecef', 
                            borderRadius: '8px', 
                            padding: '8px', 
                            background: 'white',
                            marginBottom: '8px'
                        }}>
                            <SignatureCanvas
                                ref={medicationSignaturePadRef}
                                canvasProps={{
                                    style: { 
                                        width: '100%', 
                                        height: '150px',
                                        border: '1px dashed #dee2e6',
                                        borderRadius: '4px'
                                    }
                                }}
                            />
                        </div>
                        <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={() => {
                                if (medicationSignaturePadRef.current) {
                                    medicationSignaturePadRef.current.clear();
                                }
                            }}
                            type="button"
                            style={{ borderRadius: '6px' }}
                        >
                            <i className="ri-eraser-line me-1"></i>
                            Clear Signature
                        </Button>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={{ fontWeight: '600', color: '#333', marginBottom: '8px' }}>
                            Comments (Optional)
                        </Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            placeholder="Any additional comments or observations"
                            value={medicationLogData.comments}
                            onChange={(e) => setMedicationLogData({
                                ...medicationLogData,
                                comments: e.target.value
                            })}
                            style={{
                                borderRadius: '8px',
                                border: '2px solid #e9ecef',
                                padding: '12px 16px',
                                fontSize: '14px'
                            }}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer style={{
                borderTop: 'none',
                padding: '16px 24px',
                background: '#fafbfc'
            }}>
                <Button
                    variant="secondary"
                    onClick={() => {
                        setShowMedicationLogFormModal(false);
                        setIsEditingMedicationLog(false);
                        if (medicationSignaturePadRef.current) {
                            medicationSignaturePadRef.current.clear();
                        }
                    }}
                    style={{
                        borderRadius: '8px',
                        padding: '8px 20px',
                        fontSize: '14px',
                        fontWeight: '500'
                    }}
                >
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    onClick={saveMedicationLog}
                    disabled={isLoadingLogs}
                    style={{
                        borderRadius: '8px',
                        padding: '8px 20px',
                        fontSize: '14px',
                        fontWeight: '600',
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        border: 'none',
                        boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)'
                    }}
                >
                    {isLoadingLogs ? (
                        <>
                            <i className="ri-loader-4-line ri-spin me-2"></i>
                            Saving...
                        </>
                    ) : (
                        <>
                            <i className="ri-save-line me-2"></i>
                            Save Log Entry
                        </>
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );

    // Render Non-Medication Log Form Modal
    const renderNonMedicationLogFormModal = () => (
        <Modal show={showNonMedicationLogFormModal} onHide={() => {
            setShowNonMedicationLogFormModal(false);
            setIsEditingNonMedicationLog(false);
            if (nonMedicationSignaturePadRef.current) {
                nonMedicationSignaturePadRef.current.clear();
            }
        }} centered style={{ marginTop: "30px" }}>
            <Modal.Header closeButton style={{
                borderBottom: '1px solid #e5e7eb',
                padding: '16px 20px',
                background: 'white'
            }}>
                <Modal.Title style={{
                    fontSize: '15px',
                    fontWeight: '700',
                    color: '#111827'
                }}>
                    <i className={isEditingNonMedicationLog ? "ri-edit-line me-2" : "ri-add-circle-line me-2"} style={{ fontSize: '16px', color: '#10b981' }}></i>
                    {isEditingNonMedicationLog ? 'Edit Non-Medication Log' : 'Add Non-Medication Log'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '20px', background: 'white' }}>
                <Form>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label style={{ fontWeight: '600', color: '#374151', marginBottom: '6px', fontSize: '13px' }}>
                                    <span style={{ color: '#dc3545' }}>* </span>Medication Date
                                </Form.Label>
                                <DatePicker
                                    selected={nonMedicationLogData.medication_date ? Moment(nonMedicationLogData.medication_date).toDate() : null}
                                    onChange={(date) => setNonMedicationLogData({
                                        ...nonMedicationLogData,
                                        medication_date: date ? Moment(date).format('YYYY-MM-DD') : ''
                                    })}
                                    dateFormat="MMM d yyyy"
                                    placeholderText="Dec 17 2025"
                                    className="form-control"
                                    required
                                    style={{
                                        borderRadius: '6px',
                                        border: '1px solid #e5e7eb',
                                        padding: '10px 12px',
                                        fontSize: '13px',
                                        width: '100%'
                                    }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label style={{ fontWeight: '600', color: '#374151', marginBottom: '6px', fontSize: '13px' }}>
                                    Time Given
                                </Form.Label>
                                <DatePicker
                                    selected={nonMedicationLogData.time_given ? Moment(nonMedicationLogData.time_given, 'HH:mm').toDate() : null}
                                    onChange={(time) => setNonMedicationLogData({
                                        ...nonMedicationLogData,
                                        time_given: time ? Moment(time).format('HH:mm') : ''
                                    })}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={15}
                                    timeCaption="Time"
                                    dateFormat="h:mm aa"
                                    placeholderText="2:30 PM"
                                    className="form-control"
                                    style={{
                                        borderRadius: '8px',
                                        border: '2px solid #e9ecef',
                                        padding: '12px 16px',
                                        fontSize: '14px',
                                        width: '100%'
                                    }}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Form.Group className="mb-3">
                        <Form.Label style={{ fontWeight: '600', color: '#333', marginBottom: '8px' }}>
                            <span style={{ color: '#dc3545' }}>* </span>Medication
                        </Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter medication name"
                            value={nonMedicationLogData.medication}
                            onChange={(e) => setNonMedicationLogData({
                                ...nonMedicationLogData,
                                medication: e.target.value
                            })}
                            required
                            style={{
                                borderRadius: '8px',
                                border: '2px solid #e9ecef',
                                padding: '12px 16px',
                                fontSize: '14px'
                            }}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={{ fontWeight: '600', color: '#333', marginBottom: '8px' }}>
                            <span style={{ color: '#dc3545' }}>* </span>Is Dosage Given?
                        </Form.Label>
                        <div style={{ display: 'flex', gap: '20px', padding: '12px 0' }}>
                            <Form.Check
                                type="radio"
                                label="Yes"
                                name="is_dosage_given_non_med"
                                checked={nonMedicationLogData.is_dosage_given === 1 || nonMedicationLogData.is_dosage_given === '1'}
                                onChange={() => setNonMedicationLogData({
                                    ...nonMedicationLogData,
                                    is_dosage_given: 1
                                })}
                                style={{ fontSize: '14px', fontWeight: '500' }}
                            />
                            <Form.Check
                                type="radio"
                                label="No"
                                name="is_dosage_given_non_med"
                                checked={nonMedicationLogData.is_dosage_given === 0 || nonMedicationLogData.is_dosage_given === '0'}
                                onChange={() => setNonMedicationLogData({
                                    ...nonMedicationLogData,
                                    is_dosage_given: 0
                                })}
                                style={{ fontSize: '14px', fontWeight: '500' }}
                            />
                        </div>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={{ fontWeight: '600', color: '#333', marginBottom: '8px' }}>
                            Staff Signature (Optional)
                        </Form.Label>
                        {nonMedicationLogData.staff_signiture && nonMedicationLogData.staff_signiture !== 'null' && nonMedicationLogData.staff_signiture !== '' ? (
                            <div className="mb-2">
                                <img 
                                    src={nonMedicationLogData.staff_signiture} 
                                    alt="Existing Signature" 
                                    style={{ 
                                        maxWidth: '200px', 
                                        maxHeight: '80px',
                                        border: '1px solid #e9ecef',
                                        borderRadius: '8px',
                                        padding: '8px',
                                        background: 'white'
                                    }}
                                    onError={(e) => { e.target.style.display = 'none'; }}
                                />
                                <div className="text-muted small mt-1">Existing signature (will be replaced if you draw a new one)</div>
                            </div>
                        ) : null}
                        <div style={{ 
                            border: '2px solid #e9ecef', 
                            borderRadius: '8px', 
                            padding: '8px', 
                            background: 'white',
                            marginBottom: '8px'
                        }}>
                            <SignatureCanvas
                                ref={nonMedicationSignaturePadRef}
                                canvasProps={{
                                    style: { 
                                        width: '100%', 
                                        height: '150px',
                                        border: '1px dashed #dee2e6',
                                        borderRadius: '4px'
                                    }
                                }}
                            />
                        </div>
                        <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={() => {
                                if (nonMedicationSignaturePadRef.current) {
                                    nonMedicationSignaturePadRef.current.clear();
                                }
                            }}
                            type="button"
                            style={{ borderRadius: '6px' }}
                        >
                            <i className="ri-eraser-line me-1"></i>
                            Clear Signature
                        </Button>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={{ fontWeight: '600', color: '#333', marginBottom: '8px' }}>
                            Comments (Optional)
                        </Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            placeholder="Any additional comments or observations"
                            value={nonMedicationLogData.comments}
                            onChange={(e) => setNonMedicationLogData({
                                ...nonMedicationLogData,
                                comments: e.target.value
                            })}
                            style={{
                                borderRadius: '8px',
                                border: '2px solid #e9ecef',
                                padding: '12px 16px',
                                fontSize: '14px'
                            }}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer style={{
                borderTop: 'none',
                padding: '16px 24px',
                background: '#fafbfc'
            }}>
                <Button
                    variant="secondary"
                    onClick={() => {
                        setShowNonMedicationLogFormModal(false);
                        setIsEditingNonMedicationLog(false);
                        if (nonMedicationSignaturePadRef.current) {
                            nonMedicationSignaturePadRef.current.clear();
                        }
                    }}
                    style={{
                        borderRadius: '8px',
                        padding: '8px 20px',
                        fontSize: '14px',
                        fontWeight: '500'
                    }}
                >
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    onClick={saveNonMedicationLog}
                    disabled={isLoadingLogs}
                    style={{
                        borderRadius: '8px',
                        padding: '8px 20px',
                        fontSize: '14px',
                        fontWeight: '600',
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        border: 'none',
                        boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)'
                    }}
                >
                    {isLoadingLogs ? (
                        <>
                            <i className="ri-loader-4-line ri-spin me-2"></i>
                            Saving...
                        </>
                    ) : (
                        <>
                            <i className="ri-save-line me-2"></i>
                            Save Log Entry
                        </>
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );

    const renderMedicationLogViewModal = () => (
        <Modal show={showMedicationLogViewModal} onHide={() => setShowMedicationLogViewModal(false)} centered
            style={{ marginTop: "50px" }}>
            <Modal.Header closeButton style={{
                borderBottom: '3px solid #667eea',
                padding: '16px 24px',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
            }}>
                <Modal.Title style={{
                    fontSize: '20px',
                    fontWeight: '800',
                    color: 'white',
                    textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}>
                    <i className="ri-file-text-line me-3"></i>
                    Medication Log Details
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '24px', background: '#fafbfc' }}>
                {selectedMedicationLog ? (
                    <div>
                        <Row className="mb-3">
                            <Col sm={4}>
                                <strong style={{ color: '#333', fontSize: '14px' }}>Medication Date:</strong>
                            </Col>
                            <Col sm={8}>
                                <span style={{ color: '#666' }}>
                                    {selectedMedicationLog.medication_date ? Moment(selectedMedicationLog.medication_date).format('MMM D YYYY') : 'N/A'}
                                </span>
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col sm={4}>
                                <strong style={{ color: '#333', fontSize: '14px' }}>Medication:</strong>
                            </Col>
                            <Col sm={8}>
                                <span style={{ color: '#666', fontWeight: '600' }}>
                                    {selectedMedicationLog.medication || 'N/A'}
                                </span>
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col sm={4}>
                                <strong style={{ color: '#333', fontSize: '14px' }}>Dosage Given:</strong>
                            </Col>
                            <Col sm={8}>
                                <span style={{
                                    padding: '4px 12px',
                                    borderRadius: '12px',
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    background: selectedMedicationLog.is_dosage_given === 1 || selectedMedicationLog.is_dosage_given === '1' ? '#d1fae5' : '#fee2e2',
                                    color: selectedMedicationLog.is_dosage_given === 1 || selectedMedicationLog.is_dosage_given === '1' ? '#065f46' : '#991b1b',
                                    display: 'inline-block'
                                }}>
                                    {selectedMedicationLog.is_dosage_given === 1 || selectedMedicationLog.is_dosage_given === '1' ? 'Yes' : 'No'}
                                </span>
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col sm={4}>
                                <strong style={{ color: '#333', fontSize: '14px' }}>Time Given:</strong>
                            </Col>
                            <Col sm={8}>
                                <span style={{ color: '#666' }}>
                                    {selectedMedicationLog.time_given ? Moment(selectedMedicationLog.time_given, 'HH:mm:ss').format('h:mm A') : 'N/A'}
                                </span>
                            </Col>
                        </Row>
                        {selectedMedicationLog.staff_signiture && selectedMedicationLog.staff_signiture !== 'null' && selectedMedicationLog.staff_signiture !== '' && (
                            <Row className="mb-3">
                                <Col sm={4}>
                                    <strong style={{ color: '#333', fontSize: '14px' }}>Staff Signature:</strong>
                                </Col>
                                <Col sm={8}>
                                    <img 
                                        src={selectedMedicationLog.staff_signiture} 
                                        alt="Staff Signature" 
                                        onError={(e) => { e.target.style.display = 'none'; }}
                                        style={{ maxWidth: '150px', maxHeight: '75px', border: '1px solid #dee2e6', borderRadius: '4px', padding: '4px', background: 'white', display: 'block' }}
                                    />
                                </Col>
                            </Row>
                        )}
                        {selectedMedicationLog.comments && (
                            <Row className="mb-3">
                                <Col sm={4}>
                                    <strong style={{ color: '#333', fontSize: '14px' }}>Comments:</strong>
                                </Col>
                                <Col sm={8}>
                                    <span style={{ color: '#666' }}>
                                        {selectedMedicationLog.comments}
                                    </span>
                                </Col>
                            </Row>
                        )}
                        <Row className="mb-3">
                            <Col sm={4}>
                                <strong style={{ color: '#333', fontSize: '14px' }}>Recorded On:</strong>
                            </Col>
                            <Col sm={8}>
                                <span style={{ color: '#666' }}>
                                    {selectedMedicationLog.created_at
                                        ? Moment(selectedMedicationLog.created_at).format('MMM D YYYY h:mm A')
                                        : 'Not available'
                                    }
                                </span>
                            </Col>
                        </Row>
                    </div>
                ) : (
                    <p>No log details available</p>
                )}
            </Modal.Body>
        </Modal>
    );

    const renderNonMedicationModal = () => (
        <Modal show={showNonMedicationModal} onHide={() => setShowNonMedicationModal(false)} size="xl" centered
            style={{ marginTop: "30px" }}>
            <Modal.Header closeButton style={{
                borderBottom: '1px solid #e5e7eb',
                padding: '16px 20px',
                background: 'white'
            }}>
                <Modal.Title style={{
                    fontSize: '16px',
                    fontWeight: '700',
                    color: '#111827',
                    lineHeight: '1.3',
                    width: '100%',
                    maxWidth: 'calc(100% - 40px)'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <i className="ri-shield-check-line" style={{ fontSize: '20px', color: '#10b981' }}></i>
                            <div>
                                <div style={{ fontSize: '15px', fontWeight: '700', color: '#111827' }}>
                                    Non-Medication Overview
                                </div>
                                <div style={{ fontSize: '11px', color: '#6b7280', fontWeight: '500' }}>
                                    {nonMedicationData?.student_name}
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '16px', background: '#f9fafb', maxHeight: '65vh', overflowY: 'auto' }}>
                {nonMedicationData ? (
                    <Row>
                        <Col md={12}>
                            <Card style={{
                                borderRadius: '8px',
                                border: '1px solid #e5e7eb',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                marginBottom: '16px',
                                background: 'white'
                            }}>
                                <Card.Header style={{
                                    background: 'white',
                                    borderBottom: '1px solid #e5e7eb',
                                    borderRadius: '8px 8px 0 0',
                                    padding: '12px 16px',
                                    fontSize: '13px',
                                    fontWeight: '700',
                                    color: '#374151'
                                }}>
                                    <i className="ri-shield-check-line me-2" style={{ color: '#10b981' }}></i>
                                    Non-Medication Information
                                </Card.Header>
                                <Card.Body style={{ padding: '16px' }}>
                                    <Row>
                                        <Col md={6}>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Student Name
                                                </div>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                                                    {nonMedicationData.student_name}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Parent Name
                                                </div>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                                                    {nonMedicationData.parent_name || 'N/A'}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Medication Name
                                                </div>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#28a745' }}>
                                                    {nonMedicationData.medication_name || 'Not specified'}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Times to be Administered
                                                </div>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                                                    {nonMedicationData.times_to_be_administered || 'Not specified'}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Date Range
                                                </div>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                                                    {nonMedicationData.date_start !== 'N/A' ? Moment(nonMedicationData.date_start).format('MMM D YYYY') : 'N/A'} to {nonMedicationData.date_end !== 'N/A' ? Moment(nonMedicationData.date_end).format('MMM D YYYY') : 'N/A'}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Expiry Date
                                                </div>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                                                    {nonMedicationData.expiry_date && nonMedicationData.expiry_date !== 'N/A' ? Moment(nonMedicationData.expiry_date).format('MMM D YYYY') : 'N/A'}
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Reason for Administering
                                                </div>
                                                <div style={{ fontSize: '13px', color: '#666', lineHeight: '1.5' }}>
                                                    {nonMedicationData.reason_for_administering || 'No reason specified'}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Parent's Consent & Instructions
                                                </div>
                                                <div style={{ fontSize: '13px', color: '#666', lineHeight: '1.5' }}>
                                                    {nonMedicationData.parents_consent_and_instruction || 'No instructions provided'}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Additional Instructions
                                                </div>
                                                <div style={{ fontSize: '13px', color: '#666', lineHeight: '1.5' }}>
                                                    {nonMedicationData.additional_instructions || 'No additional instructions'}
                                                </div>
                                            </div>
                                            {nonMedicationData.signiture_of_parent && nonMedicationData.signiture_of_parent !== 'null' && nonMedicationData.signiture_of_parent !== '' && (
                                                <div style={{ marginBottom: '15px' }}>
                                                    <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                        Parent Signature
                                                    </div>
                                                    <img 
                                                        src={nonMedicationData.signiture_of_parent} 
                                                        alt="Parent Signature" 
                                                        onError={(e) => { e.target.style.display = 'none'; }}
                                                        style={{ maxWidth: '200px', maxHeight: '100px', border: '1px solid #dee2e6', borderRadius: '4px', padding: '8px', background: 'white', display: 'block' }}
                                                    />
                                                    <div style={{ fontSize: '12px', color: '#999', marginTop: '4px' }}>
                                                        Signed on: {nonMedicationData.signature_date}
                                                    </div>
                                                </div>
                                            )}
                                            {nonMedicationData.doctor_note && (
                                                <div style={{ marginBottom: '15px' }}>
                                                    <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                        Doctor's Note
                                                    </div>
                                                    <a href={nonMedicationData.doctor_note} target="_blank" rel="noopener noreferrer" style={{ fontSize: '13px', color: '#28a745' }}>
                                                        <i className="ri-file-text-line me-1"></i>
                                                        View Doctor's Note
                                                    </a>
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={12}>
                            <Card style={{
                                borderRadius: '12px',
                                border: 'none',
                                boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                            }}>
                                <Card.Header style={{
                                    background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                                    color: 'white',
                                    borderRadius: '12px 12px 0 0',
                                    padding: '16px 20px',
                                    fontSize: '18px',
                                    fontWeight: '600',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                }}>
                                    <div>
                                        <i className="ri-file-list-line me-2"></i>
                                        Non-Medication Logs
                                    </div>
                                    <Button
                                        variant="primary"
                                        size="sm"
                                        onClick={() => {
                                            setIsEditingNonMedicationLog(false);
                                            setNonMedicationLogData({
                                                medication_date: new Date().toISOString().split('T')[0],
                                                medication: nonMedicationData.medication_name || '',
                                                is_dosage_given: 1,
                                                time_given: new Date().toTimeString().slice(0, 5),
                                                staff_signiture: '',
                                                comments: ''
                                            });
                                            if (nonMedicationSignaturePadRef.current) {
                                                nonMedicationSignaturePadRef.current.clear();
                                            }
                                            setShowNonMedicationLogFormModal(true);
                                        }}
                                        style={{ borderRadius: '6px' }}
                                    >
                                        <i className="ri-add-line me-1"></i>
                                        Add Log Entry
                                    </Button>
                                </Card.Header>
                                <Card.Body style={{ padding: '0' }}>
                                    {nonMedicationData.non_medication_logs && nonMedicationData.non_medication_logs.length > 0 ? (
                                        <div style={{ overflowX: 'auto' }}>
                                            <Table hover style={{ margin: 0 }}>
                                                <thead style={{
                                                    background: '#f8f9fa',
                                                    borderBottom: '2px solid #dee2e6'
                                                }}>
                                                    <tr>
                                                        <th style={{ padding: '16px', fontWeight: '600', color: '#333' }}>Date</th>
                                                        <th style={{ padding: '16px', fontWeight: '600', color: '#333' }}>Medication</th>
                                                        <th style={{ padding: '16px', fontWeight: '600', color: '#333' }}>Dosage Given</th>
                                                        <th style={{ padding: '16px', fontWeight: '600', color: '#333' }}>Time</th>
                                                        <th style={{ padding: '16px', fontWeight: '600', color: '#333' }}>Staff Signature</th>
                                                        <th style={{ padding: '16px', fontWeight: '600', color: '#333' }}>Comments</th>
                                                        <th style={{ padding: '16px', fontWeight: '600', color: '#333', textAlign: 'center' }}>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {nonMedicationData.non_medication_logs.map((log, index) => (
                                                        <tr key={index} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                                            <td style={{ padding: '16px', color: '#333' }}>
                                                                {log.medication_date ? Moment(log.medication_date).format('MMM D YYYY') : 'N/A'}
                                                            </td>
                                                            <td style={{ padding: '16px', color: '#333', fontWeight: '600' }}>
                                                                {log.medication || 'N/A'}
                                                            </td>
                                                            <td style={{ padding: '16px', textAlign: 'center' }}>
                                                                <span style={{
                                                                    padding: '4px 12px',
                                                                    borderRadius: '12px',
                                                                    fontSize: '12px',
                                                                    fontWeight: '600',
                                                                    background: log.is_dosage_given === 1 || log.is_dosage_given === '1' ? '#d1fae5' : '#fee2e2',
                                                                    color: log.is_dosage_given === 1 || log.is_dosage_given === '1' ? '#065f46' : '#991b1b'
                                                                }}>
                                                                    {log.is_dosage_given === 1 || log.is_dosage_given === '1' ? 'Yes' : 'No'}
                                                                </span>
                                                            </td>
                                                            <td style={{ padding: '16px', color: '#333' }}>
                                                                {log.time_given ? Moment(log.time_given, 'HH:mm:ss').format('h:mm A') : 'N/A'}
                                                            </td>
                                                            <td style={{ padding: '16px', color: '#333' }}>
                                                                {log.staff_signiture && log.staff_signiture !== 'null' && log.staff_signiture !== '' ? (
                                                                    <img 
                                                                        src={log.staff_signiture} 
                                                                        alt="Staff Signature" 
                                                                        onError={(e) => { e.target.style.display = 'none'; e.target.parentElement.textContent = 'N/A'; }}
                                                                        style={{ maxWidth: '80px', maxHeight: '40px', display: 'block' }}
                                                                    />
                                                                ) : 'N/A'}
                                                            </td>
                                                            <td style={{ padding: '16px', color: '#666', maxWidth: '200px' }}>
                                                                {log.comments && log.comments.length > 40
                                                                    ? `${log.comments.substring(0, 40)}...`
                                                                    : log.comments || '-'
                                                                }
                                                            </td>
                                                            <td style={{ padding: '16px', textAlign: 'center' }}>
                                                                <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                                                                    <Button
                                                                        variant="outline-success"
                                                                        size="sm"
                                                                        onClick={() => editNonMedicationLog(log)}
                                                                        style={{ borderRadius: '6px' }}
                                                                        title="Edit Log"
                                                                    >
                                                                        <i className="ri-edit-line"></i>
                                                                    </Button>
                                                                    <Button
                                                                        variant="outline-danger"
                                                                        size="sm"
                                                                        onClick={() => deleteNonMedicationLog(log.id)}
                                                                        style={{ borderRadius: '6px' }}
                                                                        title="Delete Log"
                                                                    >
                                                                        <i className="ri-delete-bin-line"></i>
                                                                    </Button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>
                                    ) : (
                                        <div style={{
                                            padding: '40px',
                                            textAlign: 'center',
                                            color: '#666'
                                        }}>
                                            <i className="ri-shield-check-line" style={{ fontSize: '48px', color: '#ccc', marginBottom: '16px' }}></i>
                                            <p style={{ fontSize: '16px', marginBottom: '8px' }}>No logs found</p>
                                            <p style={{ fontSize: '14px', color: '#999' }}>
                                                No non-medication logs have been recorded yet
                                            </p>
                                        </div>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                ) : (
                    <div style={{
                        padding: '60px 24px',
                        textAlign: 'center'
                    }}>
                        <i className="ri-loader-4-line ri-spin" style={{ fontSize: '48px', color: '#28a745' }}></i>
                        <p style={{ marginTop: '16px', color: '#666', fontSize: '16px' }}>Loading non-medication information...</p>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );

    const renderMeditationModal = () => (
        <Modal show={showMeditationModal} onHide={() => {
            setShowMeditationModal(false);
            if (document.activeElement) {
                document.activeElement.blur();
            }
        }} size="lg" centered style={{ marginTop: "50px", marginBottom: "50px" }}>
            <Modal.Header closeButton style={{
                borderBottom: '2px solid #667eea',
                padding: '12px 16px',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
            }}>
                <Modal.Title style={{
                    fontSize: '16px',
                    fontWeight: '800',
                    color: 'white',
                    lineHeight: '1.2',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                }}>
                    <i className="ri-mental-health-line" style={{ fontSize: '20px' }}></i>
                    Medication Exercises
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '15px', background: '#f8f9fa' }}>
                {meditationData && meditationData.student && (
                    <div style={{ marginBottom: '15px' }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            background: 'white',
                            padding: '12px',
                            borderRadius: '10px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                        }}>
                            {meditationData.student.photo && (
                                <img
                                    src={meditationData.student.photo}
                                    alt={meditationData.student.name}
                                    style={{
                                        width: '50px',
                                        height: '50px',
                                        borderRadius: '50%',
                                        objectFit: 'cover',
                                        border: '2px solid #667eea'
                                    }}
                                />
                            )}
                            <div>
                                <div style={{ fontSize: '14px', fontWeight: '700', color: '#333' }}>
                                    {meditationData.student.name}
                                </div>
                                <div style={{ fontSize: '11px', color: '#666' }}>Student</div>
                            </div>
                        </div>
                    </div>
                )}

                <div style={{ marginTop: '15px' }}>
                    <h6 style={{
                        fontSize: '13px',
                        fontWeight: '700',
                        color: '#667eea',
                        marginBottom: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        <i className="ri-heart-pulse-line"></i>
                        Recommended Exercises
                    </h6>

                    {meditationData && meditationData.exercises && meditationData.exercises.map((exercise, index) => (
                        <div key={exercise.id} style={{
                            background: 'white',
                            padding: '12px',
                            borderRadius: '10px',
                            marginBottom: '10px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                            border: '1px solid #e5e7eb'
                        }}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                marginBottom: '8px'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}>
                                    <div style={{
                                        width: '28px',
                                        height: '28px',
                                        borderRadius: '50%',
                                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: 'white',
                                        fontSize: '11px',
                                        fontWeight: '700'
                                    }}>
                                        {index + 1}
                                    </div>
                                    <div>
                                        <div style={{ fontSize: '13px', fontWeight: '700', color: '#333' }}>
                                            {exercise.name}
                                        </div>
                                        <div style={{ fontSize: '11px', color: '#667eea', fontWeight: '600' }}>
                                            <i className="ri-time-line"></i> {exercise.duration}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{
                                fontSize: '12px',
                                color: '#666',
                                lineHeight: '1.5',
                                paddingLeft: '36px'
                            }}>
                                {exercise.description}
                            </div>
                        </div>
                    ))}
                </div>

                <div style={{
                    marginTop: '15px',
                    padding: '12px',
                    background: 'linear-gradient(135deg, #e0f2fe 0%, #dbeafe 100%)',
                    borderRadius: '10px',
                    border: '1px solid #bae6fd'
                }}>
                    <div style={{
                        fontSize: '12px',
                        color: '#0c4a6e',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        <i className="ri-information-line" style={{ fontSize: '16px' }}></i>
                        <div>
                            <strong>Note:</strong> Practice these exercises in a quiet, comfortable space. Start with 2-3 minutes for younger children.
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );



    const renderAllergyModal = () => (
        <Modal show={showAllergyModal} onHide={() => {
            setShowAllergyModal(false);
            if (document.activeElement) {
                document.activeElement.blur();
            }
        }} size="lg" centered
            style={{ marginTop: "50px", marginBottom: "50px" }}>
            <Modal.Header closeButton style={{
                background: 'white',
                borderBottom: '1px solid #e5e7eb',
                padding: '16px 20px'
            }}>
                <Modal.Title style={{ fontSize: '15px', fontWeight: '700', color: '#111827', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <div style={{
                        background: '#f3f4f6',
                        borderRadius: '8px',
                        padding: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <i className="ri-alert-fill" style={{ fontSize: '18px', color: '#f59e0b' }}></i>
                    </div>
                    Allergy & Food Preference
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '16px', background: '#f9fafb', maxHeight: '70vh', overflowY: 'auto' }}>
                {allergyData && allergyData.student && (
                    <>
                        <div style={{ marginBottom: '12px', fontSize: '12px', color: '#6b7280', fontWeight: '500' }}>
                            <strong>Student:</strong> {allergyData.student.name}
                        </div>

                        {allergyData.allergy_report && (
                            <div style={{
                                background: 'white',
                                padding: '16px',
                                borderRadius: '8px',
                                marginBottom: '12px',
                                border: '1px solid #e5e7eb',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                            }}>
                                <h6 style={{
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    marginBottom: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    color: '#374151',
                                    gap: '8px'
                                }}>
                                    <i className="ri-alert-line" style={{ fontSize: '16px', color: '#6366f1' }}></i>
                                    Allergy & Food Preference - {allergyData.student.name}
                                </h6>

                                <Row>
                                    {/* Left Side - Allergies */}
                                    <Col md={6}>
                                        <div style={{
                                            background: '#fef3c7',
                                            padding: '12px',
                                            borderRadius: '6px',
                                            marginBottom: '10px',
                                            border: '1px solid #fde68a'
                                        }}>
                                            <div style={{
                                                fontSize: '12px',
                                                fontWeight: '600',
                                                marginBottom: '8px',
                                                color: '#92400e'
                                            }}>
                                                ⚠️ Allergies
                                            </div>
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                                {allergyData.allergy_report.is_peanuts === 1 && (
                                                    <div style={{ display: 'flex', alignItems: 'center', fontSize: '12px' }}>
                                                        <span style={{ color: '#92400e', marginRight: '6px' }}>•</span>
                                                        <span>Peanuts</span>
                                                    </div>
                                                )}
                                                {allergyData.allergy_report.is_shellfish === 1 && (
                                                    <div style={{ display: 'flex', alignItems: 'center', fontSize: '12px' }}>
                                                        <span style={{ color: '#92400e', marginRight: '6px' }}>•</span>
                                                        <span>Shellfish {allergyData.allergy_report.shellfish_specify ? `(${allergyData.allergy_report.shellfish_specify})` : ''}</span>
                                                    </div>
                                                )}
                                                {allergyData.allergy_report.is_milk === 1 && (
                                                    <div style={{ display: 'flex', alignItems: 'center', fontSize: '12px' }}>
                                                        <span style={{ color: '#92400e', marginRight: '6px' }}>•</span>
                                                        <span>Milk/Dairy</span>
                                                    </div>
                                                )}
                                                {allergyData.allergy_report.is_food_additives === 1 && (
                                                    <div style={{ display: 'flex', alignItems: 'center', fontSize: '12px' }}>
                                                        <span style={{ color: '#92400e', marginRight: '6px' }}>•</span>
                                                        <span>Food Additives {allergyData.allergy_report.food_additives_specify ? `(${allergyData.allergy_report.food_additives_specify})` : ''}</span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </Col>

                                    {/* Right Side - Emergency Treatment */}
                                    <Col md={6}>
                                        <div style={{
                                            background: '#fee2e2',
                                            padding: '12px',
                                            borderRadius: '6px',
                                            marginBottom: '10px',
                                            border: '1px solid #fecaca'
                                        }}>
                                            <div style={{
                                                fontSize: '12px',
                                                fontWeight: '600',
                                                marginBottom: '8px',
                                                color: '#991b1b'
                                            }}>
                                                🏥 Emergency Treatment
                                            </div>

                                            {allergyData.allergy_report.emergency_treatment_procedures && (
                                                <div style={{ marginBottom: '8px' }}>
                                                    <div style={{ fontSize: '11px', fontWeight: '600', color: '#991b1b', marginBottom: '4px' }}>
                                                        Procedures:
                                                    </div>
                                                    <div style={{ fontSize: '12px', color: '#374151' }}>
                                                        {allergyData.allergy_report.emergency_treatment_procedures}
                                                    </div>
                                                </div>
                                            )}

                                            {allergyData.allergy_report.require_epi_pen === 1 && (
                                                <div style={{
                                                    background: '#fecaca',
                                                    padding: '8px',
                                                    borderRadius: '6px',
                                                    marginBottom: '8px',
                                                    border: '1px solid #fca5a5'
                                                }}>
                                                    <div style={{
                                                        fontSize: '11px',
                                                        fontWeight: '600',
                                                        color: '#991b1b',
                                                        marginBottom: '4px'
                                                    }}>
                                                        💉 EpiPen Required
                                                    </div>
                                                    {allergyData.allergy_report.location_of_epi_pen && (
                                                        <div style={{ fontSize: '11px', color: '#991b1b' }}>
                                                            Location: {allergyData.allergy_report.location_of_epi_pen}
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                            {allergyData.allergy_report.symptoms && (
                                                <div>
                                                    <div style={{ fontSize: '11px', fontWeight: '600', color: '#991b1b', marginBottom: '4px' }}>
                                                        Symptoms:
                                                    </div>
                                                    <div style={{ fontSize: '12px', color: '#374151' }}>
                                                        {allergyData.allergy_report.symptoms}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                </Row>

                                {/* Signatures */}
                                <Row style={{ marginTop: '12px' }}>
                                    <Col md={6}>
                                        <div>
                                            <div style={{ fontSize: '11px', fontWeight: '600', marginBottom: '8px', color: '#374151' }}>
                                                Parent Signature:
                                            </div>
                                            {allergyData.allergy_report.parent_signature ? (
                                                <div>
                                                    <div style={{
                                                        border: '1px solid #e5e7eb',
                                                        borderRadius: '6px',
                                                        padding: '8px',
                                                        background: '#f9fafb',
                                                        marginBottom: '6px'
                                                    }}>
                                                        <img
                                                            src={allergyData.allergy_report.parent_signature}
                                                            alt="Parent Signature"
                                                            style={{
                                                                maxWidth: '100%',
                                                                maxHeight: '60px',
                                                                display: 'block'
                                                            }}
                                                        />
                                                    </div>
                                                    {allergyData.allergy_report.parent_signature_date && (
                                                        <div style={{ fontSize: '11px', color: '#6b7280' }}>
                                                            Signed: {new Date(allergyData.allergy_report.parent_signature_date).toLocaleDateString('en-US', {
                                                                month: 'short',
                                                                day: 'numeric',
                                                                year: 'numeric'
                                                            })}
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                <div style={{ fontSize: '11px', color: '#6b7280', fontStyle: 'italic' }}>
                                                    Not signed
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div>
                                            <div style={{ fontSize: '11px', fontWeight: '600', marginBottom: '8px', color: '#374151' }}>
                                                Supervisor Signature:
                                            </div>
                                            {allergyData.allergy_report.supervisor_signature ? (
                                                <div>
                                                    <div style={{
                                                        border: '1px solid #e5e7eb',
                                                        borderRadius: '6px',
                                                        padding: '8px',
                                                        background: '#f9fafb',
                                                        marginBottom: '6px'
                                                    }}>
                                                        <img
                                                            src={allergyData.allergy_report.supervisor_signature}
                                                            alt="Supervisor Signature"
                                                            style={{
                                                                maxWidth: '100%',
                                                                maxHeight: '60px',
                                                                display: 'block'
                                                            }}
                                                        />
                                                    </div>
                                                    {allergyData.allergy_report.supervisor_signature_date && (
                                                        <div style={{ fontSize: '11px', color: '#6b7280' }}>
                                                            Signed: {new Date(allergyData.allergy_report.supervisor_signature_date).toLocaleDateString('en-US', {
                                                                month: 'short',
                                                                day: 'numeric',
                                                                year: 'numeric'
                                                            })}
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                <div style={{ fontSize: '11px', color: '#6b7280', fontStyle: 'italic' }}>
                                                    Not signed
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                </Row>

                                {/* Supervisor Notes */}
                                {allergyData.allergy_report.supervisor_notes && (
                                    <div style={{
                                        background: '#dbeafe',
                                        padding: '12px',
                                        borderRadius: '6px',
                                        marginTop: '12px',
                                        border: '1px solid #bfdbfe'
                                    }}>
                                        <div style={{ fontSize: '11px', fontWeight: '600', marginBottom: '6px', color: '#1e40af' }}>
                                            Supervisor Notes:
                                        </div>
                                        <div style={{ fontSize: '12px', color: '#374151' }}>
                                            {allergyData.allergy_report.supervisor_notes}
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </>
                )}
            </Modal.Body>
        </Modal>
    );

    // Helper functions for registration modal
    const formatPhoneNumber = (phone) => {
        if (!phone) return 'N/A';
        return phone;
    };

    const formatDateLong = (date) => {
        if (!date) return 'N/A';
        try {
            const d = new Date(date);
            if (isNaN(d.getTime())) return 'N/A';
            return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
        } catch (error) {
            return 'N/A';
        }
    };

    const calculateAge = (dob) => {
        if (!dob) return 'N/A';
        const birthDate = new Date(dob);
        const today = new Date();
        const age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            return age - 1;
        }
        return age;
    };

    // Render Accident Reports Modal
    const renderAccidentReportsModal = () => (
        <Modal show={showAccidentReportsModal} onHide={() => setShowAccidentReportsModal(false)} size="xl" centered>
            <Modal.Header closeButton style={{ borderBottom: '2px solid #ef4444', padding: '16px 20px' }}>
                <Modal.Title style={{ fontSize: '18px', fontWeight: '700', color: '#ef4444', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <i className="ri-first-aid-kit-line" style={{ fontSize: '24px' }}></i>
                    Accident Reports - {selectedStudent?.name}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '20px', maxHeight: '70vh', overflowY: 'auto' }}>
                {loadingAccidentReports ? (
                    <div style={{ textAlign: 'center', padding: '40px' }}>
                        <div className="spinner-border text-danger" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p style={{ marginTop: '16px', color: '#6c757d' }}>Loading accident reports...</p>
                    </div>
                ) : accidentReports.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '40px' }}>
                        <i className="ri-file-search-line" style={{ fontSize: '48px', color: '#cbd5e1' }}></i>
                        <p style={{ marginTop: '16px', color: '#6c757d', fontSize: '15px' }}>No accident reports found for this student.</p>
                    </div>
                ) : (
                    <div className="row g-3">
                        {accidentReports.map((report) => (
                            <div key={report.id} className="col-12">
                                <Card style={{ border: '1px solid #fee2e2', boxShadow: '0 2px 8px rgba(239, 68, 68, 0.1)' }}>
                                    <Card.Body>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: '12px' }}>
                                            <div>
                                                <Badge bg="danger" style={{ fontSize: '11px', marginBottom: '8px' }}>
                                                    Report #{report.id}
                                                </Badge>
                                                <h6 style={{ fontSize:'14px', fontWeight: '600', color: '#111827', marginBottom: '4px' }}>
                                                    {Moment(report.incident_date).format('MMM DD, YYYY')} at {formatTime(report.incident_time)}
                                                </h6>
                                                <p style={{ fontSize: '12px', color: '#6b7280', margin: 0 }}>
                                                    <i className="ri-map-pin-line"></i> {report.location}
                                                </p>
                                            </div>
                                            <div style={{ display: 'flex', gap: '8px' }}>
                                                {profileData?.user_type === 2 && !report.parent_signature && (
                                                    <Button
                                                        variant="outline-danger"
                                                        size="sm"
                                                        onClick={() => handleSignAccidentReport(report)}
                                                        style={{ fontSize: '11px', padding: '4px 12px' }}
                                                    >
                                                        <i className="ri-quill-pen-line"></i> Sign
                                                    </Button>
                                                )}
                                                {profileData?.user_type !== 2 && (
                                                    <>
                                                        <Button
                                                            variant="outline-primary"
                                                            size="sm"
                                                            onClick={() => {
                                                                setShowAccidentReportsModal(false);
                                                                handleEditAccidentReport(report);
                                                            }}
                                                            style={{ fontSize: '11px', padding: '4px 12px' }}
                                                        >
                                                            <i className="ri-edit-line"></i> Edit
                                                        </Button>
                                                        <Button
                                                            variant="outline-danger"
                                                            size="sm"
                                                            onClick={() => deleteAccidentReport(report.id)}
                                                            style={{ fontSize: '11px', padding: '4px 12px' }}
                                                        >
                                                            <i className="ri-delete-bin-line"></i> Delete
                                                        </Button>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                        
                                        <Row className="g-2">
                                            <Col md={12}>
                                                <div style={{ background: '#fef2f2', borderRadius: '6px', padding: '12px', marginBottom: '8px' }}>
                                                    <strong style={{ fontSize: '12px', color: '#991b1b' }}>Incident Description:</strong>
                                                    <div style={{ fontSize: '12px', color: '#374151', marginTop: '4px' }}
                                                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(report.incident_description) }}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={12}>
                                                <div style={{ background: '#f0fdf4', borderRadius: '6px', padding: '12px', marginBottom: '8px' }}>
                                                    <strong style={{ fontSize: '12px', color: '#166534' }}>First Aid Provided:</strong>
                                                    <div style={{ fontSize: '12px', color: '#374151', marginTop: '4px' }}
                                                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(report.first_aid) }}
                                                    />
                                                </div>
                                            </Col>
                                            {report.follow_up_information && (
                                                <Col md={12}>
                                                    <div style={{ background: '#eff6ff', borderRadius: '6px', padding: '12px' }}>
                                                        <strong style={{ fontSize: '12px', color: '#1e40af' }}>Follow-up Information:</strong>
                                                        <div style={{ fontSize: '12px', color: '#374151', marginTop: '4px' }}
                                                            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(report.follow_up_information) }}
                                                        />
                                                    </div>
                                                </Col>
                                            )}
                                            <Col md={6}>
                                                <div style={{ fontSize: '12px' }}>
                                                    <strong>Parent Contacted:</strong> {report.parent_contacted === 1 ? 'Yes' : 'No'}
                                                    {report.parent_contacted === 1 && report.parent_contacted_time && (
                                                        <span> at {formatTime(report.parent_contacted_time)}</span>
                                                    )}
                                                </div>
                                            </Col>
                                            {report.staff_name && (
                                                <Col md={6}>
                                                    <div style={{ fontSize: '12px' }}>
                                                        <strong>Staff:</strong> {report.staff_name} ({report.staff_position})
                                                    </div>
                                                </Col>
                                            )}
                                        </Row>

                                        {/* Signatures */}
                                        <div style={{ marginTop: '16px', paddingTop: '12px', borderTop: '1px solid #e5e7eb' }}>
                                            <Row className="g-2">
                                                {report.staff_signature && (
                                                    <Col md={4}>
                                                        <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px' }}>Staff Signature:</div>
                                                        <img src={report.staff_signature} alt="Staff Signature" style={{ maxWidth: '100%', height: '60px', border: '1px solid #e5e7eb', borderRadius: '4px' }} />
                                                    </Col>
                                                )}
                                                {report.supervisor_signature && (
                                                    <Col md={4}>
                                                        <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px' }}>Supervisor Signature:</div>
                                                        <img src={report.supervisor_signature} alt="Supervisor Signature" style={{ maxWidth: '100%', height: '60px', border: '1px solid #e5e7eb', borderRadius: '4px' }} />
                                                    </Col>
                                                )}
                                                {report.parent_signature && (
                                                    <Col md={4}>
                                                        <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px' }}>
                                                            Parent Signature ({Moment(report.parent_signature_date).format('MMM DD, YYYY')}):
                                                        </div>
                                                        <img src={report.parent_signature} alt="Parent Signature" style={{ maxWidth: '100%', height: '60px', border: '1px solid #e5e7eb', borderRadius: '4px' }} />
                                                    </Col>
                                                )}
                                            </Row>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </div>
                        ))}
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );

    // Render Illness Reports Modal
    const renderIllnessReportsModal = () => (
        <Modal show={showIllnessReportsModal} onHide={() => setShowIllnessReportsModal(false)} size="xl" centered>
            <Modal.Header closeButton style={{ borderBottom: '2px solid #f59e0b', padding: '16px 20px' }}>
                <Modal.Title style={{ fontSize: '18px', fontWeight: '700', color: '#f59e0b', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <i className="ri-thermometer-line" style={{ fontSize: '24px' }}></i>
                    Illness Reports - {selectedStudent?.name}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '20px', maxHeight: '70vh', overflowY: 'auto' }}>
                {loadingIllnessReports ? (
                    <div style={{ textAlign: 'center', padding: '40px' }}>
                        <div className="spinner-border text-warning" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p style={{ marginTop: '16px', color: '#6c757d' }}>Loading illness reports...</p>
                    </div>
                ) : illnessReports.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '40px' }}>
                        <i className="ri-file-search-line" style={{ fontSize: '48px', color: '#cbd5e1' }}></i>
                        <p style={{ marginTop: '16px', color: '#6c757d', fontSize: '15px' }}>No illness reports found for this student.</p>
                    </div>
                ) : (
                    <div className="row g-3">
                        {illnessReports.map((report) => (
                            <div key={report.id} className="col-12">
                                <Card style={{ border: '1px solid #fef3c7', boxShadow: '0 2px 8px rgba(245, 158, 11, 0.1)' }}>
                                    <Card.Body>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: '12px' }}>
                                            <div>
                                                <Badge bg="warning" text="dark" style={{ fontSize: '11px', marginBottom: '8px' }}>
                                                    Report #{report.id}
                                                </Badge>
                                                <h6 style={{ fontSize: '14px', fontWeight: '600', color: '#111827', marginBottom: '4px' }}>
                                                    Return Date: {Moment(report.return_date).format('MMM DD, YYYY')}
                                                </h6>
                                            </div>
                                            <div style={{ display: 'flex', gap: '8px' }}>
                                                {profileData?.user_type === 2 && !report.parent_signature && (
                                                    <Button
                                                        variant="outline-warning"
                                                        size="sm"
                                                        onClick={() => handleSignIllnessReport(report)}
                                                        style={{ fontSize: '11px', padding: '4px 12px' }}
                                                    >
                                                        <i className="ri-quill-pen-line"></i> Sign
                                                    </Button>
                                                )}
                                                {profileData?.user_type !== 2 && (
                                                    <>
                                                        <Button
                                                            variant="outline-primary"
                                                            size="sm"
                                                            onClick={() => {
                                                                setShowIllnessReportsModal(false);
                                                                handleEditIllnessReport(report);
                                                            }}
                                                            style={{ fontSize: '11px', padding: '4px 12px' }}
                                                        >
                                                            <i className="ri-edit-line"></i> Edit
                                                        </Button>
                                                        <Button
                                                            variant="outline-danger"
                                                            size="sm"
                                                            onClick={() => deleteIllnessReport(report.id)}
                                                            style={{ fontSize: '11px', padding: '4px 12px' }}
                                                        >
                                                            <i className="ri-delete-bin-line"></i> Delete
                                                        </Button>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                        
                                        <Row className="g-2">
                                            <Col md={12}>
                                                <div style={{ background: '#fef3c7', borderRadius: '6px', padding: '12px', marginBottom: '8px' }}>
                                                    <strong style={{ fontSize: '12px', color: '#92400e' }}>Symptoms:</strong>
                                                    <div style={{ fontSize: '12px', color: '#374151', marginTop: '4px' }}
                                                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(report.symptoms) }}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={12}>
                                                <div style={{ background: '#eff6ff', borderRadius: '6px', padding: '12px' }}>
                                                    <strong style={{ fontSize: '12px', color: '#1e40af' }}>Requested Action from Parent:</strong>
                                                    <div style={{ fontSize: '12px', color: '#374151', marginTop: '4px' }}
                                                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(report.requested_action_parent) }}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>

                                        {/* Signatures */}
                                        <div style={{ marginTop: '16px', paddingTop: '12px', borderTop: '1px solid #e5e7eb' }}>
                                            <Row className="g-2">
                                                {report.teacher_signature && (
                                                    <Col md={6}>
                                                        <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px' }}>
                                                            Teacher Signature ({Moment(report.teacher_signature_date).format('MMM DD, YYYY')}):
                                                        </div>
                                                        <img src={report.teacher_signature} alt="Teacher Signature" style={{ maxWidth: '100%', height: '60px', border: '1px solid #e5e7eb', borderRadius: '4px' }} />
                                                    </Col>
                                                )}
                                                {report.parent_signature && (
                                                    <Col md={6}>
                                                        <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px' }}>
                                                            Parent Signature ({Moment(report.parent_signature_date).format('MMM DD, YYYY')}):
                                                        </div>
                                                        <img src={report.parent_signature} alt="Parent Signature" style={{ maxWidth: '100%', height: '60px', border: '1px solid #e5e7eb', borderRadius: '4px' }} />
                                                    </Col>
                                                )}
                                            </Row>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </div>
                        ))}
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );

    // Render Accident Report Signature Modal
    const renderAccidentSignatureModal = () => (
        <Modal show={showAccidentSignatureModal} onHide={() => setShowAccidentSignatureModal(false)} centered>
            <Modal.Header closeButton>
                <Modal.Title style={{ fontSize: '16px', fontWeight: '600' }}>Sign Accident Report</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Signature Date</Form.Label>
                    <Form.Control
                        type="date"
                        value={accidentSignatureDate}
                        onChange={(e) => setAccidentSignatureDate(e.target.value)}
                        style={{ fontSize: '13px' }}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Parent Signature</Form.Label>
                    <div style={{ border: '1px solid #dee2e6', borderRadius: '4px', background: '#fff' }}>
                        <SignatureCanvas
                            ref={accidentSignaturePadRef}
                            canvasProps={{
                                style: { width: '100%', height: '200px' }
                            }}
                        />
                    </div>
                    <Button
                        variant="link"
                        size="sm"
                        onClick={() => accidentSignaturePadRef.current?.clear()}
                        style={{ fontSize: '12px', padding: '4px 0', marginTop: '4px' }}
                    >
                        Clear Signature
                    </Button>
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" size="sm" onClick={() => setShowAccidentSignatureModal(false)}>
                    Cancel
                </Button>
                <Button variant="danger" size="sm" onClick={submitAccidentReportSignature}>
                    Submit Signature
                </Button>
            </Modal.Footer>
        </Modal>
    );

    // Render Illness Report Signature Modal
    const renderIllnessSignatureModal = () => (
        <Modal show={showIllnessSignatureModal} onHide={() => setShowIllnessSignatureModal(false)} centered>
            <Modal.Header closeButton>
                <Modal.Title style={{ fontSize: '16px', fontWeight: '600' }}>Sign Illness Report</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Signature Date</Form.Label>
                    <Form.Control
                        type="date"
                        value={illnessSignatureDate}
                        onChange={(e) => setIllnessSignatureDate(e.target.value)}
                        style={{ fontSize: '13px' }}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Parent Signature</Form.Label>
                    <div style={{ border: '1px solid #dee2e6', borderRadius: '4px', background: '#fff' }}>
                        <SignatureCanvas
                            ref={illnessSignaturePadRef}
                            canvasProps={{
                                style: { width: '100%', height: '200px' }
                            }}
                        />
                    </div>
                    <Button
                        variant="link"
                        size="sm"
                        onClick={() => illnessSignaturePadRef.current?.clear()}
                        style={{ fontSize: '12px', padding: '4px 0', marginTop: '4px' }}
                    >
                        Clear Signature
                    </Button>
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" size="sm" onClick={() => setShowIllnessSignatureModal(false)}>
                    Cancel
                </Button>
                <Button variant="warning" size="sm" onClick={submitIllnessReportSignature}>
                    Submit Signature
                </Button>
            </Modal.Footer>
        </Modal>
    );

    // Render Create/Edit Accident Report Modal
    const renderCreateAccidentModal = () => (
        <Modal show={showCreateAccidentModal} onHide={() => {
            setShowCreateAccidentModal(false);
            setIsEditingAccidentReport(false);
            setEditingAccidentReportId(null);
        }} size="xl" centered style={{ marginTop: '20px' }}>
            <Modal.Header closeButton style={{ borderBottom: '2px solid #ef4444', padding: '16px 20px' }}>
                <Modal.Title style={{ fontSize: '18px', fontWeight: '700', color: '#ef4444', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <i className={isEditingAccidentReport ? "ri-edit-line" : "ri-file-add-line"} style={{ fontSize: '24px' }}></i>
                    {isEditingAccidentReport ? 'Edit Accident Report' : 'Indoor/Outdoor Accident Report'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '20px', maxHeight: '60vh', overflowY: 'auto' }}>
                <Form>
                    <Row className="g-3">
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Classroom:</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Select Classroom"
                                    value={accidentFormData.classroom}
                                    onChange={(e) => setAccidentFormData({...accidentFormData, classroom: e.target.value})}
                                    style={{ fontSize: '13px' }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Child's Name:</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={accidentFormData.child_name}
                                    readOnly
                                    style={{ fontSize: '13px', backgroundColor: '#f8f9fa' }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Date: <span style={{ color: 'red' }}>*</span></Form.Label>
                                <Form.Control
                                    type="date"
                                    value={accidentFormData.incident_date}
                                    onChange={(e) => setAccidentFormData({...accidentFormData, incident_date: e.target.value})}
                                    style={{ fontSize: '13px' }}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Time: <span style={{ color: 'red' }}>*</span></Form.Label>
                                <Form.Control
                                    type="time"
                                    value={accidentFormData.incident_time}
                                    onChange={(e) => setAccidentFormData({...accidentFormData, incident_time: e.target.value})}
                                    style={{ fontSize: '13px' }}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={12}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Location: <span style={{ color: 'red' }}>*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="e.g., Playground, Classroom, etc."
                                    value={accidentFormData.location}
                                    onChange={(e) => setAccidentFormData({...accidentFormData, location: e.target.value})}
                                    style={{ fontSize: '13px' }}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={12}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Detailed Description of what happened: <span style={{ color: 'red' }}>*</span></Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={4}
                                    value={accidentFormData.incident_description}
                                    onChange={(e) => setAccidentFormData({...accidentFormData, incident_description: e.target.value})}
                                    style={{ fontSize: '13px' }}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={12}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Any First Aid applied:</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    value={accidentFormData.first_aid}
                                    onChange={(e) => setAccidentFormData({...accidentFormData, first_aid: e.target.value})}
                                    style={{ fontSize: '13px' }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Check
                                    type="checkbox"
                                    label="Parent contacted:"
                                    checked={accidentFormData.parent_contacted}
                                    onChange={(e) => setAccidentFormData({...accidentFormData, parent_contacted: e.target.checked})}
                                    style={{ fontSize: '13px', fontWeight: '600' }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Time:</Form.Label>
                                <Form.Control
                                    type="time"
                                    value={accidentFormData.parent_contacted_time}
                                    onChange={(e) => setAccidentFormData({...accidentFormData, parent_contacted_time: e.target.value})}
                                    style={{ fontSize: '13px' }}
                                    disabled={!accidentFormData.parent_contacted}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={12}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Follow up information:</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    value={accidentFormData.follow_up_information}
                                    onChange={(e) => setAccidentFormData({...accidentFormData, follow_up_information: e.target.value})}
                                    style={{ fontSize: '13px' }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={12}>
                            <hr />
                            <h6 style={{ fontSize: '14px', fontWeight: '600', marginBottom: '12px' }}>Staff Signature</h6>
                            {isEditingAccidentReport && accidentFormData.existing_staff_signature && (
                                <div style={{ marginBottom: '12px', padding: '12px', background: '#f8f9fa', borderRadius: '6px', border: '1px solid #dee2e6' }}>
                                    <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '6px', fontWeight: '600' }}>Existing Signature:</div>
                                    <img 
                                        src={accidentFormData.existing_staff_signature} 
                                        alt="Staff Signature" 
                                        style={{ maxWidth: '100%', height: '80px', border: '1px solid #dee2e6', borderRadius: '4px', background: '#fff' }}
                                    />
                                    <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '6px' }}>Leave signature pad empty to keep existing signature</div>
                                </div>
                            )}
                            <div style={{ border: '1px solid #dee2e6', borderRadius: '4px', background: '#fff', marginBottom: '12px' }}>
                                <SignatureCanvas
                                    ref={accidentStaffSignaturePadRef}
                                    canvasProps={{
                                        style: { width: '100%', height: '150px' }
                                    }}
                                />
                            </div>
                            <Button
                                variant="link"
                                size="sm"
                                onClick={() => accidentStaffSignaturePadRef.current?.clear()}
                                style={{ fontSize: '12px', padding: '0', marginBottom: '12px' }}
                            >
                                Clear Signature Above
                            </Button>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Staff Name:</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Staff name"
                                    value={accidentFormData.staff_name}
                                    onChange={(e) => setAccidentFormData({...accidentFormData, staff_name: e.target.value})}
                                    style={{ fontSize: '13px' }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Staff Position:</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="e.g., Teacher, Supervisor"
                                    value={accidentFormData.staff_position}
                                    onChange={(e) => setAccidentFormData({...accidentFormData, staff_position: e.target.value})}
                                    style={{ fontSize: '13px' }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={12}>
                            <hr />
                            <h6 style={{ fontSize: '14px', fontWeight: '600', marginBottom: '12px' }}>Supervisor Signature</h6>
                            {isEditingAccidentReport && accidentFormData.existing_supervisor_signature && (
                                <div style={{ marginBottom: '12px', padding: '12px', background: '#f8f9fa', borderRadius: '6px', border: '1px solid #dee2e6' }}>
                                    <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '6px', fontWeight: '600' }}>Existing Signature:</div>
                                    <img 
                                        src={accidentFormData.existing_supervisor_signature} 
                                        alt="Supervisor Signature" 
                                        style={{ maxWidth: '100%', height: '80px', border: '1px solid #dee2e6', borderRadius: '4px', background: '#fff' }}
                                    />
                                    <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '6px' }}>Leave signature pad empty to keep existing signature</div>
                                </div>
                            )}
                            <div style={{ border: '1px solid #dee2e6', borderRadius: '4px', background: '#fff', marginBottom: '12px' }}>
                                <SignatureCanvas
                                    ref={accidentSupervisorSignaturePadRef}
                                    canvasProps={{
                                        style: { width: '100%', height: '150px' }
                                    }}
                                />
                            </div>
                            <Button
                                variant="link"
                                size="sm"
                                onClick={() => accidentSupervisorSignaturePadRef.current?.clear()}
                                style={{ fontSize: '12px', padding: '0', marginBottom: '12px' }}
                            >
                                Clear Signature Above
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => {
                    setShowCreateAccidentModal(false);
                    setIsEditingAccidentReport(false);
                    setEditingAccidentReportId(null);
                }}>
                    Cancel
                </Button>
                <Button variant="success" onClick={submitAccidentReport}>
                    <i className={isEditingAccidentReport ? "ri-check-line" : "ri-save-line"}></i> {isEditingAccidentReport ? 'Update Report' : 'Save Report'}
                </Button>
            </Modal.Footer>
        </Modal>
    );

    // Render Create/Edit Illness Report Modal
    const renderCreateIllnessModal = () => (
        <Modal show={showCreateIllnessModal} onHide={() => {
            setShowCreateIllnessModal(false);
            setIsEditingIllnessReport(false);
            setEditingIllnessReportId(null);
        }} size="lg" centered style={{ marginTop: '20px' }}>
            <Modal.Header closeButton style={{ borderBottom: '2px solid #f59e0b', padding: '16px 20px' }}>
                <Modal.Title style={{ fontSize: '18px', fontWeight: '700', color: '#f59e0b', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <i className={isEditingIllnessReport ? "ri-edit-line" : "ri-file-add-line"} style={{ fontSize: '24px' }}></i>
                    {isEditingIllnessReport ? 'Edit Illness Report' : 'Harmony Illness Report'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '20px', maxHeight: '60vh', overflowY: 'auto' }}>
                <Form>
                    <Row className="g-3">
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Classroom:</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Select Classroom"
                                    value={illnessFormData.classroom}
                                    onChange={(e) => setIllnessFormData({...illnessFormData, classroom: e.target.value})}
                                    style={{ fontSize: '13px' }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Student Name:</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={illnessFormData.student_name}
                                    readOnly
                                    style={{ fontSize: '13px', backgroundColor: '#f8f9fa' }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={12}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600', color: '#2563eb' }}>Symptoms: <span style={{ color: 'red' }}>*</span></Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={4}
                                    placeholder="Describe the symptoms observed..."
                                    value={illnessFormData.symptoms}
                                    onChange={(e) => setIllnessFormData({...illnessFormData, symptoms: e.target.value})}
                                    style={{ fontSize: '13px' }}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={12}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600', color: '#2563eb' }}>Requested action by parent: <span style={{ color: 'red' }}>*</span></Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={4}
                                    placeholder="What action is being requested from the parent..."
                                    value={illnessFormData.requested_action_parent}
                                    onChange={(e) => setIllnessFormData({...illnessFormData, requested_action_parent: e.target.value})}
                                    style={{ fontSize: '13px' }}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Return date: <span style={{ color: 'red' }}>*</span></Form.Label>
                                <Form.Control
                                    type="date"
                                    value={illnessFormData.return_date}
                                    onChange={(e) => setIllnessFormData({...illnessFormData, return_date: e.target.value})}
                                    style={{ fontSize: '13px' }}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Date:</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={illnessFormData.teacher_signature_date}
                                    onChange={(e) => setIllnessFormData({...illnessFormData, teacher_signature_date: e.target.value})}
                                    style={{ fontSize: '13px' }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={12}>
                            <hr />
                            <h6 style={{ fontSize: '14px', fontWeight: '600', marginBottom: '8px' }}>Teacher Signature: {!isEditingIllnessReport && <span style={{ color: 'red' }}>*</span>}</h6>
                            {isEditingIllnessReport && illnessFormData.existing_teacher_signature && (
                                <div style={{ marginBottom: '12px', padding: '12px', background: '#f8f9fa', borderRadius: '6px', border: '1px solid #dee2e6' }}>
                                    <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '6px', fontWeight: '600' }}>Existing Signature:</div>
                                    <img 
                                        src={illnessFormData.existing_teacher_signature} 
                                        alt="Teacher Signature" 
                                        style={{ maxWidth: '100%', height: '80px', border: '1px solid #dee2e6', borderRadius: '4px', background: '#fff' }}
                                    />
                                    <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '6px' }}>Leave signature pad empty to keep existing signature</div>
                                </div>
                            )}
                            <div style={{ border: '2px solid #3b82f6', borderRadius: '4px', background: '#fff', marginBottom: '8px' }}>
                                <SignatureCanvas
                                    ref={illnessTeacherSignaturePadRef}
                                    canvasProps={{
                                        style: { width: '100%', height: '150px' }
                                    }}
                                />
                            </div>
                            <div style={{ display: 'flex', gap: '8px' }}>
                                <Button
                                    variant="warning"
                                    size="sm"
                                    onClick={() => illnessTeacherSignaturePadRef.current?.clear()}
                                    style={{ fontSize: '12px' }}
                                >
                                    <i className="ri-eraser-line"></i> Clear Signature
                                </Button>
                                <Button
                                    variant="success"
                                    size="sm"
                                    disabled
                                    style={{ fontSize: '12px' }}
                                >
                                    <i className="ri-check-line"></i> Confirm
                                </Button>
                            </div>
                            <small style={{ color: '#6b7280', fontSize: '11px', display: 'block', marginTop: '8px' }}>
                                Draw your signature above
                            </small>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => {
                    setShowCreateIllnessModal(false);
                    setIsEditingIllnessReport(false);
                    setEditingIllnessReportId(null);
                }}>
                    Cancel
                </Button>
                <Button variant="success" onClick={submitIllnessReport}>
                    <i className={isEditingIllnessReport ? "ri-check-line" : "ri-save-line"}></i> {isEditingIllnessReport ? 'Update Report' : 'Save Report'}
                </Button>
            </Modal.Footer>
        </Modal>
    );

    return (
        <>
            <div id='content-page' className='content-page'>
                <Container>
                    {loading ? (
                        <Row>
                            <Col lg={12}>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minHeight: '400px',
                                    background: '#ffffff',
                                    borderRadius: '8px'
                                }}>
                                    <img src={loader} alt="loader" style={{ height: "100px" }} />
                                    <p style={{
                                        color: '#6c757d',
                                        fontSize: '14px',
                                        marginTop: '16px'
                                    }}>
                                        Loading attendance...
                                    </p>
                                </div>
                            </Col>
                        </Row>
                    ) : (
                        <>
                            <Row className="g-3 mb-3">
                                <Col xs={12} lg={8}>
                                    {renderDateSelector()}
                                </Col>
                                <Col xs={12} lg={4}>
                                    {renderStatsCards()}
                                </Col>
                            </Row>
                            <Row className="g-3 mb-3">
                                <Col xs={12}>
                                    {renderBulkActions()}
                                </Col>
                            </Row>
                            <Row className="g-3">
                                <Col xs={12}>
                                    {renderStudentsList()}
                                </Col>
                            </Row>
                        </>
                    )}
                    {renderBulkModal()}
                    {renderEmergencyContactsModal()}
                    {renderObservationModal()}
                    {renderExitTimeModal()}
                    {renderDailyReportModal()}
                    {renderDailyReportFormModal()}
                    {renderMedicationModal()}
                    {renderMedicationLogFormModal()}
                    {renderMedicationLogViewModal()}
                    {renderNonMedicationModal()}
                    {renderNonMedicationLogFormModal()}
                    {renderMeditationModal()}
                    {renderAllergyModal()}
                    <RegistrationDetailModal 
                        show={showRegistrationModal}
                        onHide={() => {
                            setShowRegistrationModal(false);
                            setRegistrationData(null);
                            setRegistrationLoading(false);
                            if (document.activeElement) {
                                document.activeElement.blur();
                            }
                        }}
                        data={registrationData}
                        loading={registrationLoading}
                        showEditButton={false}
                    />
                    {renderPeanutPolicyModal()}
                    {renderLunchPlanModal()}
                    {renderGameModal()}
                    {renderObservationViewModal()}
                    {renderAccidentReportsModal()}
                    {renderIllnessReportsModal()}
                    {renderAccidentSignatureModal()}
                    {renderIllnessSignatureModal()}
                    {renderCreateAccidentModal()}
                    {renderCreateIllnessModal()}
                </Container>
            </div>
        </>
    );
};

export default AttendancePage;
